import '../components.css';var un = Object.defineProperty;
var dn = (n, l, e) => l in n ? un(n, l, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[l] = e;
var N = (n, l, e) => dn(n, typeof l != "symbol" ? l + "" : l, e);
import { defineComponent as F, createElementBlock as m, openBlock as i, createElementVNode as a, renderSlot as Y, ref as T, normalizeClass as H, withDirectives as De, vModelCheckbox as qt, toDisplayString as A, useSlots as kt, useAttrs as mn, computed as $, Fragment as V, mergeProps as Mt, unref as h, renderList as Q, createBlock as pe, resolveDynamicComponent as Et, createTextVNode as fe, createCommentVNode as E, normalizeStyle as ee, resolveComponent as jt, isRef as tt, createVNode as de, watch as Ee, onBeforeUpdate as fn, vModelText as Bt, withModifiers as nt, onMounted as Le, onBeforeUnmount as Yt, vModelSelect as ht, useCssVars as Lt, watchEffect as pn, nextTick as it, withCtx as ze, reactive as St, createStaticVNode as hn, vShow as Nt, inject as vn, vModelRadio as yn, createSlots as $t, onUpdated as gn, normalizeProps as Cn, guardReactiveProps as bn } from "vue";
import { T as _n, M as In } from "./vendor.B946LCjM.js";
import { UUIDUtil as rt, toStringArray as ft, ConvStorageUtil as xn, BootstrapUtil as At, NaturalCompare as Ot } from "../util/index.js";
import "utif2";
import "./util-extensions.DsZ6PEq4.js";
import Ge from "jquery";
import { cloneDeep as at, isEqual as kn, sortBy as Vt, debounce as wn } from "lodash";
import _t from "@vuepic/vue-datepicker";
import Tn from "moment";
const Sn = {
  class: "btn-scv-bgcolor",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false",
  style: { padding: "0px 0px" }
}, Nn = { class: "d-flex align-items-center" }, Ht = /* @__PURE__ */ F({
  __name: "BGColorMenuButton",
  setup(n) {
    return (l, e) => (i(), m("button", Sn, [
      a("div", Nn, [
        e[0] || (e[0] = a("div", {
          class: "icon-font-deepblue ms-auto",
          style: { "margin-right": "2px", "letter-spacing": "normal" }
        }, null, -1)),
        Y(l.$slots, "text"),
        e[1] || (e[1] = a("div", {
          class: "icon-font-deepblue ms-auto",
          style: { "margin-right": "2px", "letter-spacing": "normal" }
        }, [
          a("i", { class: "icon-arrow2down" })
        ], -1))
      ])
    ]));
  }
}), Dn = { class: "switchButtonArea" }, Mn = { class: "switchArea" }, $n = { style: { "margin-left": "4px" } }, En = /* @__PURE__ */ F({
  __name: "SwitchButton",
  props: {
    text: { type: String, default: "" }
    // ボタンのテキスト
  },
  emits: ["onClickSwitch"],
  setup(n, { emit: l }) {
    const e = l, t = T(!1), s = () => {
      e("onClickSwitch", t.value);
    };
    return (o, c) => (i(), m("div", Dn, [
      a("div", Mn, [
        a("label", {
          class: H(["switchLabel", [t.value ? "chk_on_switchLabel" : ""]]),
          style: { display: "block", float: "left" }
        }, [
          a("label", {
            class: H(["swImg switchLabel", [t.value ? "chk_on_swImg" : ""]])
          }, [
            De(a("input", {
              type: "checkbox",
              onChange: s,
              "onUpdate:modelValue": c[0] || (c[0] = (r) => t.value = r),
              autocomplete: "off"
            }, null, 544), [
              [qt, t.value]
            ])
          ], 2)
        ], 2),
        a("div", {
          class: H(["text", [t.value ? "chk_on_text" : ""]])
        }, [
          a("span", $n, A(n.text), 1)
        ], 2)
      ])
    ]));
  }
}), Z = (n, l) => {
  const e = n.__vccOpts || n;
  for (const [t, s] of l)
    e[t] = s;
  return e;
}, rr = /* @__PURE__ */ Z(En, [["__scopeId", "data-v-b63ff4f7"]]), Bn = ["disabled"], Ln = { class: "dropdown-menu scv-dropdown-menu scv-dropdown-sub-menu" }, Rn = ["onClick"], An = /* @__PURE__ */ F({
  __name: "DropdownButton",
  props: {
    caption: {},
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["select"],
  setup(n, { emit: l }) {
    const e = n, t = l, s = kt(), o = mn(), c = $(() => s.default ? s.default() : {}), r = $(() => o.class || "btn-scv-bgcolor");
    function d(u, C) {
      t("select", u, C.props);
    }
    return (u, C) => (i(), m(V, null, [
      a("button", Mt({
        class: [u.$style.button, h(r)],
        type: "button",
        "data-bs-toggle": "dropdown",
        disabled: e.disabled
      }, u.$attrs), [
        a("span", null, A(e.caption), 1),
        C[0] || (C[0] = a("div", {
          class: "icon-font-size ms-auto",
          style: { "margin-right": "2px", "letter-spacing": "normal" }
        }, [
          a("i", { class: "icon-arrow2down" })
        ], -1))
      ], 16, Bn),
      a("ul", Ln, [
        (i(!0), m(V, null, Q(h(c), (p, v) => (i(), m("li", {
          key: v,
          class: H(u.$style.dropdownItem),
          onClick: (S) => d(v, p)
        }, [
          (i(), pe(Et(p)))
        ], 10, Rn))), 128))
      ])
    ], 64));
  }
}), On = "_button_zakwu_1", Vn = "_dropdownItem_zakwu_8", Hn = {
  button: On,
  dropdownItem: Vn
}, Un = {
  $style: Hn
}, cr = /* @__PURE__ */ Z(An, [["__cssModules", Un]]), Wn = {
  key: 0,
  class: "scv-dropdown-menu-button"
}, Pn = ["onClick"], Fn = {
  key: 1,
  class: "dropright scv-dropdown-sub"
}, zn = { class: "scv-dropdown-menu-button" }, Gn = ["onClick"], qn = { class: "dropdown-menu scv-dropdown-menu scv-dropdown-sub-menu" }, jn = ["onClick"], Yn = {
  key: 1,
  class: "scv-dropdown-menu-button"
}, Kn = {
  key: 0,
  class: "dropdown-item scv-dropdown-item-disabled",
  disabled: ""
}, Qn = {
  key: 1,
  class: "dropdown-item scv-dropdown-item-disabled",
  disabled: ""
}, Ut = /* @__PURE__ */ F({
  __name: "DropdownMenu",
  props: {
    models: { type: Object, required: !0 }
    // 検索のID
  },
  emits: ["onClickMenuItem"],
  setup(n, { emit: l }) {
    const e = l, t = (s) => {
      e("onClickMenuItem", s);
    };
    return (s, o) => (i(!0), m(V, null, Q(n.models, (c) => (i(), m(V, { key: c }, [
      c.disabled ? (i(), m("div", Yn, [
        c.childMenuItem.length === 0 ? (i(), m("a", Kn, A(c.description), 1)) : (i(), m("a", Qn, [
          fe(A(c.description) + " ", 1),
          o[1] || (o[1] = a("div", { class: "icon-font-silver-gray scv-dropdown-icon-right ms-auto" }, [
            a("i", { class: "icon-arrow1right" })
          ], -1))
        ]))
      ])) : (i(), m(V, { key: 0 }, [
        c.childMenuItem.length === 0 ? (i(), m("div", Wn, [
          a("a", {
            class: "dropdown-item",
            href: "javascript:void(0);",
            onClick: (r) => t(c.menuItemID)
          }, A(c.description), 9, Pn)
        ])) : (i(), m("div", Fn, [
          a("div", zn, [
            a("a", {
              class: "dropdown-item",
              href: "#",
              role: "button",
              "data-bs-toggle": "dropdown",
              onClick: (r) => t(c.menuItemID)
            }, [
              fe(A(c.description) + " ", 1),
              o[0] || (o[0] = a("div", { class: "icon-font-silver-gray scv-dropdown-icon-right ms-auto" }, [
                a("i", { class: "icon-arrow1right" })
              ], -1))
            ], 8, Gn),
            a("ul", qn, [
              (i(!0), m(V, null, Q(c.childMenuItem, (r) => (i(), m("li", {
                key: r,
                class: "scv-dropdown-menu-button"
              }, [
                a("a", {
                  class: "dropdown-item",
                  href: "javascript:void(0);",
                  onClick: (d) => t(r.menuItemID)
                }, A(r.description), 9, jn)
              ]))), 128))
            ])
          ])
        ]))
      ], 64))
    ], 64))), 128));
  }
});
var It = /* @__PURE__ */ ((n) => (n[n.Normal = 0] = "Normal", n[n.Check = 1] = "Check", n))(It || {}), Ne = /* @__PURE__ */ ((n) => (n[n.Information = 0] = "Information", n[n.Warning = 1] = "Warning", n[n.Error = 2] = "Error", n[n.Question = 3] = "Question", n))(Ne || {}), K = /* @__PURE__ */ ((n) => (n[n.MB_NO_BUTTON = 0] = "MB_NO_BUTTON", n[n.MB_OK = 1] = "MB_OK", n[n.MB_OKCANCEL = 2] = "MB_OKCANCEL", n[n.MB_ABORTRETRYIGNORE = 3] = "MB_ABORTRETRYIGNORE", n[n.MB_YESNOCANCEL = 4] = "MB_YESNOCANCEL", n[n.MB_YESNO = 5] = "MB_YESNO", n[n.MB_RETRYCANCEL = 6] = "MB_RETRYCANCEL", n[n.MB_CANCELTRYCONTINUE = 7] = "MB_CANCELTRYCONTINUE", n[n.MB_UNIQUE = 8] = "MB_UNIQUE", n[n.MB_ICONERROR = 16] = "MB_ICONERROR", n[n.MB_ICONQUESTION = 32] = "MB_ICONQUESTION", n[n.MB_ICONWARNING = 48] = "MB_ICONWARNING", n[n.MB_ICONINFORMATION = 64] = "MB_ICONINFORMATION", n[n.MB_NO_DEFBUTTON = 0] = "MB_NO_DEFBUTTON", n[n.MB_DEFBUTTON1 = 256] = "MB_DEFBUTTON1", n[n.MB_DEFBUTTON2 = 512] = "MB_DEFBUTTON2", n[n.MB_DEFBUTTON3 = 768] = "MB_DEFBUTTON3", n[n.MB_DEFBUTTON4 = 1024] = "MB_DEFBUTTON4", n[n.MB_BUTTON_CAUTION = 4096] = "MB_BUTTON_CAUTION", n))(K || {}), Te = /* @__PURE__ */ ((n) => (n[n.IDOK = 1] = "IDOK", n[n.IDCANCEL = 2] = "IDCANCEL", n[n.IDABORT = 3] = "IDABORT", n[n.IDRETRY = 4] = "IDRETRY", n[n.IDIGNORE = 5] = "IDIGNORE", n[n.IDYES = 6] = "IDYES", n[n.IDNO = 7] = "IDNO", n[n.IDTRYAGAIN = 10] = "IDTRYAGAIN", n[n.IDCONTINUE = 11] = "IDCONTINUE", n[n.IDUNIQUE1 = 12] = "IDUNIQUE1", n[n.IDUNIQUE2 = 13] = "IDUNIQUE2", n[n.IDUNIQUE3 = 14] = "IDUNIQUE3", n))(Te || {});
const oe = class oe {
  // OKボタン押下時に閉じない
  /*
   * メッセージの表示
   * @param[in] strHTML : メッセージ内容(HTML)
   * 
   * @param[in] callbackOK : OK押下後のコールバック関数
   *              ★Functionクラスで指定すること。コールバック不要ならnull
   *              
   * @param[in] callbackCancel : キャンセル押下後のコールバック関数
   *              ★MB_YESNOが立っているときのみ有効
   *              ★Functionクラスで指定すること。コールバック不要ならnull
   *              
   * @param[in] bit : オプションビット
   * 
   * @param[in] caption : タイトル(undefined: デフォルト ※アイコンに合わせたタイトル)
   * @param[in] okText : OK(確認メッセージでは"はい")ボタンの文言(undefined: デフォルト)
   * @param[in] cancelText :  確認メッセージの"いいえ"ボタンの文言(undefined: デフォルト)
   *                          ★MB_YESNOが立っているときのみ有効
   */
  static MessageBox(l, e, t, s, o = void 0, c = void 0, r = void 0) {
    if (oe.messageRef == null)
      return;
    let d = Ne.Information;
    s & oe.MB_ICON_WARNING && (d = Ne.Warning), s & oe.MB_ICON_ERROR && (d = Ne.Error), s & oe.MB_YESNO && (d = Ne.Question, oe.messageRef.SetCancelFocus((s & oe.MB_BTN_FOCUS_CANCEL) != 0)), s & oe.MB_ICON_NONE ? oe.messageRef.ShowIcon(!1) : oe.messageRef.ShowIcon(!0), oe.messageRef.Show(l, d, e, t, o, c, r, (s & oe.MB_OK_BTN_WHITE) != 0, (s & oe.MB_OK_BTN_NO_HIDE) == 0);
  }
  /*
   * メッセージを隠匿する
   */
  static HideMessage() {
    if (oe.messageRef != null) {
      var l = 300;
      const e = () => {
        oe.messageRef.IsShown() ? oe.messageRef.Hide() : 0 < l && (window.setTimeout(e, 10), --l);
      };
      e();
    }
  }
  /* 
   * メッセージの参照を登録
   * ★App.vue意外から呼び出さないこと★
   */
  static SetMessageBox(l) {
    oe.messageRef = l;
  }
};
// メッセージの種類
N(oe, "MB_YESNO", 1), // 確認メッセージ
// アイコン
N(oe, "MB_ICON_INFO", 2), // 情報アイコン
N(oe, "MB_ICON_WARNING", 4), // 警告アイコン
N(oe, "MB_ICON_ERROR", 8), // エラーアイコン
N(oe, "MB_ICON_NONE", 16), // アイコンなし
// フォーカス
N(oe, "MB_BTN_FOCUS_CANCEL", 32), // キャンセル
// ボタン動作
N(oe, "MB_OK_BTN_WHITE", 64), // OKボタンを白色にする
N(oe, "MB_OK_BTN_NO_HIDE", 128), /*
 * 表示するメッセージのrefs
 */
N(oe, "messageRef");
let Wt = oe;
var bt = /* @__PURE__ */ ((n) => (n[n.Vertical = 0] = "Vertical", n[n.Horizontal = 1] = "Horizontal", n))(bt || {}), Se = /* @__PURE__ */ ((n) => (n[n.Unchecked = 0] = "Unchecked", n[n.Checked = 1] = "Checked", n[n.Indeterminate = 2] = "Indeterminate", n))(Se || {});
const Jn = ["id", "checked", "indeterminate", "disabled"], Zn = ["for"], Xn = /* @__PURE__ */ F({
  __name: "TriStateCheckbox",
  props: {
    modelValue: {},
    allowTriState: { type: Boolean, default: !1 },
    label: { default: "" },
    disabled: { type: Boolean, default: !1 },
    stopPropagation: { type: Boolean, default: !0 },
    labelClass: { default: () => ["default-text-font"] },
    labelStyle: { default: void 0 },
    beforeChange: { type: Function, default: () => !0 }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: l }) {
    const e = n, t = l, s = $(() => Se.Unchecked !== e.modelValue), o = $(() => Se.Indeterminate === e.modelValue), c = T(`triStateCheckbox${rt.NewID()}`), r = $(() => {
      switch (e.modelValue) {
        case Se.Unchecked:
          return Se.Checked;
        case Se.Indeterminate:
          return Se.Unchecked;
        case Se.Checked:
          return e.allowTriState ? Se.Indeterminate : Se.Unchecked;
        default:
          return Se.Unchecked;
      }
    });
    function d(p) {
      e.beforeChange(e.modelValue, r.value) || p.preventDefault();
    }
    function u() {
      t("update:modelValue", r.value);
    }
    function C(p) {
      e.stopPropagation && p.stopPropagation();
    }
    return (p, v) => (i(), m("div", {
      class: H(p.$style.container),
      onClick: C
    }, [
      a("input", {
        type: "checkbox",
        id: h(c),
        checked: h(s),
        indeterminate: h(o),
        disabled: e.disabled,
        onChange: u,
        onClick: d
      }, null, 40, Jn),
      0 < e.label.length ? (i(), m("label", {
        key: 0,
        for: h(c),
        class: H(e.labelClass),
        style: ee(e.labelStyle)
      }, A(e.label), 15, Zn)) : E("", !0)
    ], 2));
  }
}), el = "_container_17jg4_3", tl = {
  container: el
}, nl = {
  $style: tl
}, ll = /* @__PURE__ */ Z(Xn, [["__cssModules", nl]]), ol = { class: "dropdownMenuItem dropdown-item" }, sl = /* @__PURE__ */ F({
  __name: "DropdownMenuItem",
  props: {
    item: {},
    menuStyle: { default: It.Normal }
  },
  emits: ["change"],
  setup(n, { emit: l }) {
    const e = n, t = l, s = $({
      get: () => e.item.checked ? Se.Checked : Se.Unchecked,
      set: (c) => t("change", e.item.menuItemID, Se.Checked === c)
    }), o = $(() => e.item.disabled);
    return (c, r) => {
      const d = jt("DropdownMenuItem", !0);
      return i(), m(V, null, [
        a("div", ol, [
          h(It).Check === e.menuStyle ? (i(), pe(ll, {
            key: 0,
            modelValue: h(s),
            "onUpdate:modelValue": r[0] || (r[0] = (u) => tt(s) ? s.value = u : null),
            label: c.item.description,
            disabled: h(o)
          }, null, 8, ["modelValue", "label", "disabled"])) : (i(), m("span", {
            key: 1,
            class: H({ disabled: h(o) })
          }, A(c.item.description), 3))
        ]),
        (i(!0), m(V, null, Q(c.item.childMenuItem, (u, C) => (i(), m("div", {
          key: C,
          class: "subMenu"
        }, [
          de(d, {
            item: u,
            menuStyle: e.menuStyle,
            onChange: r[1] || (r[1] = (p, v) => t("change", p, v))
          }, null, 8, ["item", "menuStyle"])
        ]))), 128))
      ], 64);
    };
  }
}), al = /* @__PURE__ */ Z(sl, [["__scopeId", "data-v-96e87e4a"]]), il = /* @__PURE__ */ F({
  __name: "DropdownSelectMenu",
  props: {
    models: { type: Object, required: !0 }
    // 検索のID
  },
  emits: ["onChangeMenuItem"],
  setup(n, { emit: l }) {
    const e = n, t = l, s = T(new Array());
    Ee(
      () => e.models,
      () => {
        s.value.splice(0, s.value.length), e.models.forEach((c) => s.value.push(JSON.parse(JSON.stringify(c))));
      },
      { deep: !0, immediate: !0 }
    );
    const o = (c, r) => {
      const d = (v) => {
        c === v.menuItemID ? v.checked = r : v.childMenuItem.forEach((S) => d(S));
      };
      s.value.forEach((v) => d(v));
      const u = (v, S) => {
        v.disabled = S ?? !1, v.childMenuItem.forEach((f) => u(f, S || v.checked));
      };
      s.value.forEach((v) => u(v));
      const C = (v, S) => {
        v.checked && S.push(v.menuItemID), v.childMenuItem.forEach((f) => C(f, S));
      };
      let p = [];
      s.value.forEach((v) => C(v, p)), p.sort((v, S) => v - S), t("onChangeMenuItem", p);
    };
    return (c, r) => (i(!0), m(V, null, Q(s.value, (d, u) => (i(), pe(al, {
      key: u,
      item: d,
      menuStyle: h(It).Check,
      onChange: o
    }, null, 8, ["item", "menuStyle"]))), 128));
  }
});
class ur {
  /// <summary>
  /// コンストラクタ
  /// </summary>
  constructor(l, e, t, s, o) {
    /// <summary>
    /// メニューアイテムのID クリック時にこのIDを元に判定を行うため、リスト内で一意になるように作成すること
    /// </summary>
    N(this, "menuItemID", 0);
    /// <summary>
    /// サブメニュー ★DropdownMenu: 現時点ではサブメニューは1階層までしか対応しておりません★
    ///              ★2階層目以降は、".\DropdownMenu.vue"への実装が必要です。
    ///              ★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★
    ///              ★DropdownSelectMenu : 現時点ではサブメニュは対応しておりません。★
    ///              ★サブメニューを使用するには、".\DropdownSelectMenu.vue"への実装が必要です。
    /// </summary>
    N(this, "childMenuItem", new Array());
    /// <summary>
    /// メニュー名称
    /// </summary>
    N(this, "description", "");
    /// <summary>
    /// メニューの押下(有効・無効)
    /// </summary>
    N(this, "disabled", !1);
    /// <summary>
    /// メニューの選択(選択・非選択)
    /// </summary>
    N(this, "checked", !1);
    l != null && (this.menuItemID = l), e != null && (this.description = e), t != null && (this.disabled = t), s != null && (this.checked = s), o != null && (this.childMenuItem = o);
  }
}
class rl {
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(l) {
    if (l == null || l == null || l.value === "")
      return "";
    let e = l.value, t = !1;
    const s = parseInt(l.min);
    if ((isNaN(s) || s < 0) && l.value.startsWith("-") && (t = !0, (l.value === "-" || l.value === "-0") && (e = "-1")), e = e.removeNotHalfNumber(), t && (e = "-" + e), e == "" || e == null)
      return e;
    let o = parseInt(e);
    const c = parseInt(l.max);
    return isNaN(c) == !1 && c < o && (o = c), Math.trunc(o).toString();
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(l) {
    return "";
  }
}
class cl {
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(l) {
    if (l == null || l == null || l.value === "")
      return "";
    let e = l.value;
    return e = e.removeNotHalfNumberDecimal(), e == "" || e == null, e;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(l) {
    return "";
  }
}
class Kt {
  constructor(l) {
    // オプション
    N(this, "option");
    // Optionを適応させる
    N(this, "applyOption", (l) => {
      let e = l;
      return e = this.correctUnuseChars(e), e = this.correctLength(e), e;
    });
    // 使用禁止文字を取り除く
    N(this, "correctUnuseChars", (l) => {
      var e;
      return ((e = this.option) == null ? void 0 : e.unUseChars) === void 0 ? l : l.removeChars(this.option.unUseChars);
    });
    // 文字数の補正を行います
    N(this, "correctLength", (l) => {
      var e;
      return ((e = this.option) == null ? void 0 : e.maxMultiBiteLength) === void 0 ? l : l.trimMaxLengthByMulti(this.option.maxMultiBiteLength);
    });
    this.option = l;
  }
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(l) {
    if (l == null || l.value === "")
      return "";
    let e = l.value.removeControlCode();
    return e = this.applyOption(e), e;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(l) {
    if (l == null || l == null || l.value === "")
      return "";
    let e = l.value.removeControlCodeAllowNewLine();
    return e = this.applyOption(e), e;
  }
}
class ul {
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(l) {
    if (l == null || l == null || l.value === "")
      return "";
    let e = l.value.removeControlCode();
    return e = e.removeNotHalfChar(), e;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(l) {
    if (l == null || l == null || l.value === "")
      return "";
    let e = l.value.removeControlCodeAllowNewLine();
    return e = e.removeNotHalfCharAllowNewLine(), e;
  }
}
class Qt {
  constructor(l) {
    // オプション
    N(this, "option");
    // Optionを適応させる
    N(this, "applyOption", (l) => {
      let e = l;
      return e = this.correctUnuseChars(e), e = this.correctLength(e), e;
    });
    // 使用禁止文字を取り除く
    N(this, "correctUnuseChars", (l) => {
      var e;
      return ((e = this.option) == null ? void 0 : e.unUseChars) === void 0 ? l : l.removeChars(this.option.unUseChars);
    });
    // 文字数の補正を行います
    N(this, "correctLength", (l) => {
      var e;
      return ((e = this.option) == null ? void 0 : e.maxMultiBiteLength) === void 0 ? l : l.trimMaxLengthByMulti(this.option.maxMultiBiteLength);
    });
    this.option = l;
  }
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(l) {
    if (l == null || l.value === "")
      return "";
    let e = l.value.removeControlCode();
    return e = e.removeNotSJIS(), e = this.applyOption(e), e;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(l) {
    if (l == null || l.value === "")
      return "";
    let e = l.value.removeControlCodeAllowNewLine();
    return e = e.removeNotSJIS(), e = this.applyOption(e), e;
  }
}
class dl {
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(l) {
    if (l == null || l == null || l.value === "")
      return "";
    let e = l.value.removeControlCode();
    return e = e.removeNotHalfNumber(), e;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(l) {
    return "";
  }
}
class ml {
  constructor(l) {
    N(this, "strDesignText", "");
    this.strDesignText = l;
  }
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(l) {
    if (l == null || l == null || l.value === "")
      return "";
    let e = l.value.removeControlCode();
    return e = e.removeNotSJIS(), 0 < this.strDesignText.length && (e = e.designString(this.strDesignText)), e;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(l) {
    return "";
  }
}
class fl {
  constructor(l) {
    N(this, "strDesignText", "");
    this.strDesignText = l;
  }
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(l) {
    if (l == null || l == null || l.value === "")
      return "";
    let e = l.value.removeControlCode();
    return e = e.removeNotSJIS(), 0 < this.strDesignText.length && (e = e.designReplaceString(this.strDesignText)), e;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(l) {
    return "";
  }
}
class pl {
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(l) {
    if (l == null || l == null || l.value === "")
      return "";
    let e = l.value.removeControlCode();
    return e = e.removeNotHalfChar(), e = e.removeHalfSpaceChar(), e;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(l) {
    if (l == null || l == null || l.value === "")
      return "";
    let e = l.value.removeControlCodeAllowNewLine();
    return e = e.removeNotHalfCharAllowNewLine(), e = e.removeHalfSpaceChar(), e;
  }
}
class hl {
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(l) {
    if (l == null || l == null || l.value === "")
      return "";
    let e = l.value.removeControlCode();
    return e = e.replace(/[^0-9,-]/g, ""), e;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertTextAreaValue(l) {
    return "";
  }
}
class vl {
  /**
   * @brief	input要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  convertInputValue(l) {
    if (l == null || l == null || l.value === "")
      return "";
    let e = l.value.removeControlCode();
    return e = e.removeUnUsemailAddressChar(), e;
  }
  /**
   * @brief	TextArea要素のvalueの値を変換する
   * @param   [in]    target  対象のDOM情報
   * @return	変換後のvalue
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  convertTextAreaValue(l) {
    return "";
  }
}
const yl = ["value", "placeholder"], gl = ["value", "placeholder"], Cl = ["value", "placeholder"], bl = ["value", "placeholder"], _l = /* @__PURE__ */ F({
  __name: "MaskInput",
  props: {
    modelValue: { default: void 0 },
    numValue: { default: void 0 },
    convertType: {},
    nullable: { type: Boolean, default: !1 },
    spinMode: { type: Boolean, default: !1 },
    enableNewLine: { type: Boolean, default: !1 },
    disableResize: { type: Boolean, default: !1 },
    designText: { default: "" },
    placeholder: { default: void 0 },
    unUseChars: { default: void 0 },
    maxMultiBiteLength: { default: void 0 }
  },
  emits: ["update:modelValue", "update:numValue", "modifyText"],
  setup(n, { emit: l }) {
    const e = n, t = l, s = T(""), o = T("");
    let c = new Kt({ unUseChars: e.unUseChars, maxMultiBiteLength: e.maxMultiBiteLength });
    switch (e.convertType) {
      case "half-alphanumeric-symbol":
        c = new ul(), o.value = "半角英数字記号";
        break;
      case "half-number":
        c = new rl(), e.spinMode || (o.value = "数値");
        break;
      case "text":
        break;
      case "text-sjis":
        c = new Qt({ unUseChars: e.unUseChars, maxMultiBiteLength: e.maxMultiBiteLength });
        break;
      case "text-sjis-design":
        c = new ml(e.designText);
        break;
      case "text-sjis-design-replace":
        c = new fl(e.designText);
        break;
      case "string-harf-number":
        c = new dl();
        break;
      case "half-number-version":
        c = new cl(), o.value = "文字列";
        break;
      case "half-alphanumeric-symbol-prohibit-space":
        c = new pl(), o.value = "半角英数字記号";
        break;
      case "half-number-comma-hyphen":
        c = new hl();
        break;
      case "mail-address":
        c = new vl();
        break;
    }
    e.placeholder && (o.value = e.placeholder), Ee(() => e.placeholder, () => {
      o.value = e.placeholder ? e.placeholder : "";
    }), C(), fn(() => {
      C();
    });
    function r(p) {
      if (e.convertType == "half-number" && p.target instanceof HTMLInputElement && e.numValue !== void 0) {
        const v = parseInt(s.value);
        let S = s.value, f = p.target;
        const g = parseInt(f.min);
        isNaN(v) ? isNaN(g) == !1 ? (t("update:numValue", g), S = g.toString()) : e.nullable || (t("update:numValue", 0), S = "0") : isNaN(g) == !1 && g > v && (t("update:numValue", g), S = g.toString()), s.value = S;
      }
    }
    function d(p) {
      if (!(!(p.target instanceof HTMLInputElement) && !(p.target instanceof HTMLTextAreaElement))) {
        var v = new InputEvent("input");
        p.target.dispatchEvent(v);
      }
    }
    function u(p) {
      if (p instanceof InputEvent && p.inputType == "insertCompositionText")
        return;
      let v;
      if (p.target instanceof HTMLInputElement)
        v = p.target;
      else if (p.target instanceof HTMLTextAreaElement)
        v = p.target;
      else
        return;
      if (e.maxMultiBiteLength !== void 0) {
        const x = v.value, L = e.modelValue, U = x.getMultiBytesSize(), q = L.getMultiBytesSize();
        if (U > e.maxMultiBiteLength && U > q && x.length !== v.selectionEnd) {
          const J = v.selectionStart;
          v.value = L;
          const j = x.length - L.length;
          J && v.setSelectionRange(J - j, J - j);
          return;
        }
      }
      var S = v.value.length, f = v.selectionStart;
      f == null && (f = 0);
      var g = v.selectionEnd;
      g == null && (g = 0);
      let y = "";
      if (v instanceof HTMLInputElement ? y = c.convertInputValue(v) : v instanceof HTMLTextAreaElement && (y = c.convertTextAreaValue(v)), s == null && (y = ""), e.modelValue !== void 0)
        t("update:modelValue", y);
      else if (e.numValue !== void 0 && v instanceof HTMLInputElement) {
        const x = parseInt(y);
        isNaN(x) ? (t("update:numValue", null), y = "") : t("update:numValue", x);
      }
      if (v.value = y, s.value = y, !e.spinMode)
        if (s.value.length < S) {
          var k = S - s.value.length;
          v.setSelectionRange(f - k, g - k);
        } else
          v.setSelectionRange(f, g);
      t("modifyText");
    }
    function C() {
      e.modelValue !== void 0 ? e.modelValue !== null ? s.value = e.modelValue : s.value = "" : e.numValue !== void 0 && (e.numValue !== null ? s.value = e.numValue.toString() : s.value = "");
    }
    return (p, v) => p.spinMode === !0 ? (i(), m("input", {
      key: 0,
      type: "number",
      value: h(s),
      onInput: u,
      onCompositionend: d,
      placeholder: h(o),
      autocomplete: "off",
      onBlur: r
    }, null, 40, yl)) : p.enableNewLine === !1 ? (i(), m("input", {
      key: 1,
      type: "text",
      value: h(s),
      onInput: u,
      onCompositionend: d,
      placeholder: h(o),
      autocomplete: "off",
      onBlur: r
    }, null, 40, gl)) : p.disableResize === !1 ? (i(), m("textarea", {
      key: 2,
      type: "text",
      value: h(s),
      onInput: u,
      onCompositionend: d,
      placeholder: h(o),
      autocomplete: "off"
    }, null, 40, Cl)) : (i(), m("textarea", {
      key: 3,
      type: "text",
      value: h(s),
      onInput: u,
      onCompositionend: d,
      placeholder: h(o),
      autocomplete: "off",
      class: "disableResize"
    }, null, 40, bl));
  }
}), lt = /* @__PURE__ */ Z(_l, [["__scopeId", "data-v-cfed1472"]]), Il = /* @__PURE__ */ F({
  __name: "SearchInput",
  setup(n) {
    return (l, e) => (i(), pe(lt, {
      convertType: "text",
      class: "input-text-scv searchIcon",
      placeholder: "検索キーワードを入力"
    }));
  }
}), dr = /* @__PURE__ */ Z(Il, [["__scopeId", "data-v-3b72a709"]]), xl = ["placeholder", "maxLength", "disabled"], kl = {
  key: 0,
  class: "combo-list"
}, wl = ["onMousedown"], Tl = /* @__PURE__ */ F({
  __name: "ComboBox",
  props: {
    modelValue: { default: void 0 },
    options: {},
    convertType: {},
    placeholder: { default: void 0 },
    isError: { type: Boolean },
    inputStyles: {},
    maxLength: { default: void 0 },
    maxMultiBiteLength: { default: void 0 },
    disabled: { type: Boolean },
    unUseChars: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: l }) {
    function e(f, g) {
      const y = (k) => {
        !f.value || f.value.contains(k.target) || g();
      };
      Le(() => document.addEventListener("click", y)), Yt(() => document.removeEventListener("click", y));
    }
    const t = n, s = l, o = T(!1), c = T(t.modelValue), r = T(null), d = T(!1);
    e(r, () => o.value = !1), Ee(
      () => t.modelValue,
      (f) => c.value = f
    );
    let u = new Kt({ unUseChars: t.unUseChars, maxMultiBiteLength: t.maxMultiBiteLength });
    switch (t.convertType) {
      case "text-sjis":
        u = new Qt({ unUseChars: t.unUseChars, maxMultiBiteLength: t.maxMultiBiteLength });
        break;
    }
    const C = () => {
      o.value = !o.value;
    }, p = (f) => {
      c.value = f, s("update:modelValue", f), o.value = !1;
    }, v = (f) => {
      if (f instanceof InputEvent && f.inputType === "insertCompositionText")
        return;
      let g;
      if ((f.target instanceof HTMLInputElement || f.target instanceof HTMLTextAreaElement) && (g = f.target), g === void 0) return;
      if (t.maxMultiBiteLength !== void 0) {
        const U = g.value, q = t.modelValue, J = U.getMultiBytesSize(), j = q.getMultiBytesSize();
        if (J > t.maxMultiBiteLength && J > j && U.length !== g.selectionEnd) {
          const ne = g.selectionStart;
          g.value = q, c.value = q;
          const ce = U.length - q.length;
          ne && g.setSelectionRange(ne - ce, ne - ce);
          return;
        }
      }
      const y = g.value.length, k = g.selectionStart ?? 0, x = g.selectionEnd ?? 0;
      let L = "";
      if (g instanceof HTMLInputElement ? L = u.convertInputValue(g) : g instanceof HTMLTextAreaElement && (L = u.convertTextAreaValue(g)), g.value = L, c.value = L, s("update:modelValue", c.value), c.value.length < y) {
        const U = y - c.value.length;
        g.setSelectionRange(k - U, x - U);
      } else
        g.setSelectionRange(k, x);
    };
    function S(f) {
      if (!(!(f.target instanceof HTMLInputElement) && !(f.target instanceof HTMLTextAreaElement))) {
        var g = new InputEvent("input");
        f.target.dispatchEvent(g);
      }
    }
    return (f, g) => (i(), m("div", {
      class: "combo-box",
      ref_key: "dropdown",
      ref: r
    }, [
      a("div", {
        class: H(["combo-input-wrapper", { focused: d.value, "input-text-validation-error": t.isError }])
      }, [
        De(a("input", {
          type: "text",
          "onUpdate:modelValue": g[0] || (g[0] = (y) => c.value = y),
          onInput: v,
          onCompositionend: S,
          placeholder: f.placeholder,
          class: H(["input-text-scv", "combo-box-input"]),
          style: ee(t.inputStyles),
          maxLength: t.maxLength,
          autocomplete: "off",
          onFocus: g[1] || (g[1] = (y) => d.value = !0),
          onBlur: g[2] || (g[2] = (y) => d.value = !1),
          disabled: t.disabled
        }, null, 44, xl), [
          [Bt, c.value]
        ]),
        a("div", {
          class: "d-flex select-icon",
          onClick: C,
          style: { width: "22px", cursor: "pointer" }
        })
      ], 2),
      o.value && t.options.length ? (i(), m("ul", kl, [
        (i(!0), m(V, null, Q(t.options, (y, k) => (i(), m("li", {
          key: k,
          onMousedown: nt((x) => p(y), ["prevent"]),
          class: "combo-item"
        }, A(y), 41, wl))), 128))
      ])) : E("", !0)
    ], 512));
  }
}), Sl = {
  class: "select-icon",
  style: { width: "fit-content" }
}, Nl = ["id"], Dl = ["value"], Ml = ["value"], $l = /* @__PURE__ */ F({
  __name: "SelectBox",
  props: {
    numValue: { default: void 0 },
    options: {},
    placeholder: { default: "" },
    placeholderValue: { default: -1 },
    inputWidth: {}
  },
  emits: ["update:numValue"],
  setup(n, { emit: l }) {
    const e = n, t = l, s = rt.NewID(), o = T(e.numValue);
    Ee(() => e.numValue, (r) => o.value = r);
    function c(r) {
      if (r.target.value) {
        const d = Number(r.target.value);
        t("update:numValue", d);
      }
    }
    return (r, d) => (i(), m("div", Sl, [
      De(a("select", {
        class: "input-text-scv over-text",
        id: h(s),
        style: ee({ width: e.inputWidth != 0 ? e.inputWidth + "px" : "" }),
        "onUpdate:modelValue": d[0] || (d[0] = (u) => o.value = u),
        onChange: c
      }, [
        0 < e.placeholder.length ? (i(), m("option", {
          value: e.placeholderValue,
          key: e.placeholderValue,
          hidden: "",
          selected: ""
        }, A(e.placeholder), 9, Dl)) : E("", !0),
        (i(!0), m(V, null, Q(r.options, (u) => (i(), m("option", {
          value: u.key,
          key: u.key
        }, A(u.label), 9, Ml))), 128))
      ], 44, Nl), [
        [ht, o.value]
      ])
    ]));
  }
});
function Jt() {
  const n = [];
  function l(t, s) {
    var d, u;
    const o = new MutationObserver((C) => {
      C.forEach((p) => {
        e(Ge(p.target), s);
      });
    }), c = {
      attributes: !0,
      attributeFilter: ["style"],
      characterData: !1,
      childList: !1,
      subtree: !1
    };
    o.observe(t, c);
    const r = Ge(t).closest(".modal, .collapse");
    0 < r.length ? (o.observe(r[0], c), (d = s == null ? void 0 : s.options) != null && d.immediate && e(r, s)) : (u = s == null ? void 0 : s.options) != null && u.immediate && e(Ge(t), s), n.push(o);
  }
  function e(t, s) {
    t.length <= 0 || (t.is(":hidden") ? s != null && s.onHidden && s.onHidden(t[0]) : s != null && s.onVisibled && s.onVisibled(t[0]));
  }
  return Yt(() => {
    n.forEach((t) => t.disconnect());
  }), {
    watchElementVisibility: l
  };
}
const El = /* @__PURE__ */ F({
  __name: "ValidatedInput",
  props: {
    type: { default: 0 },
    modelValue: {},
    numValue: { default: void 0 },
    inputType: { default: "text" },
    label: { default: "" },
    errorText: { default: () => [] },
    placeHolder: {},
    placeHolderValue: {},
    note: { default: () => [] },
    inputHeight: {},
    inputWidth: {},
    inputDesignText: {},
    maxLength: {},
    maxMultiBiteLength: {},
    labelHeight: {},
    labelWidth: {},
    labelLayout: { default: bt.Vertical },
    reserveErrorTextArea: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    options: { default: () => [] },
    selectOptions: { default: () => [] },
    unUseChars: { default: void 0 },
    labelTextAlign: { default: "right" }
  },
  emits: ["update:modelValue", "update:numValue"],
  setup(n, { emit: l }) {
    Lt((y) => ({
      "58bc05a2": h(S) ? "52px" : "74px"
    }));
    const e = n, t = l, s = $({
      get: () => e.modelValue,
      set: (y) => t("update:modelValue", y)
    }), o = $({
      get: () => e.numValue,
      set: (y) => {
        y && t("update:numValue", y);
      }
    }), c = T(null), r = T({}), d = $(() => 0 < e.errorText.length), u = $(() => ft(e.note).filter((y) => !ft(e.errorText).includes(y))), C = $(() => ft(e.errorText)), p = $(() => {
      const y = {};
      if (e.inputHeight && (y.height = `${e.inputHeight}px`), e.inputWidth) {
        const k = e.inputWidth - (e.type === 1 ? 24 : 0);
        y.width = `${k}px`;
      }
      return y;
    }), v = $(() => {
      const y = {
        display: "block",
        textAlign: e.labelTextAlign
      };
      return e.labelHeight && (y.height = `${e.labelHeight}px`), e.labelWidth && (y.width = `${e.labelWidth}px`), y;
    }), S = $(() => bt.Horizontal === e.labelLayout), { watchElementVisibility: f } = Jt();
    Le(() => {
      c.value && bt.Horizontal === e.labelLayout && f(c.value, {
        onVisibled(y) {
          r.value = {
            marginLeft: `${c.value ? g(c.value) : 0}px`
          };
        },
        options: {
          immediate: !0
        }
      });
    });
    function g(y) {
      const k = y.offsetWidth, x = window.getComputedStyle(y);
      return k + parseFloat(x.marginLeft) + parseFloat(x.marginRight);
    }
    return (y, k) => (i(), m("div", {
      class: H([y.$style.container, y.$style[e.reserveErrorTextArea ? "reserveErrorTextArea" : ""]])
    }, [
      a("div", {
        class: H([y.$style[h(S) ? "inputAreaHorizontal" : "inputAreaVertical"]])
      }, [
        0 < e.label.length ? (i(), m("span", {
          key: 0,
          ref_key: "labelRef",
          ref: c,
          style: ee(h(v))
        }, A(e.label), 5)) : E("", !0),
        a("div", {
          class: H(y.$style.inputAreaHorizontal)
        }, [
          y.type === 0 ? (i(), pe(lt, {
            key: 0,
            modelValue: h(s),
            "onUpdate:modelValue": k[0] || (k[0] = (x) => tt(s) ? s.value = x : null),
            convertType: e.inputType,
            placeholder: e.placeHolder,
            class: H(["input-text-scv", { "input-text-validation-error": h(d) }]),
            style: ee(h(p)),
            maxLength: e.maxLength,
            maxMultiBiteLength: e.maxMultiBiteLength,
            designText: e.inputDesignText,
            disabled: e.disabled,
            unUseChars: e.unUseChars
          }, null, 8, ["modelValue", "convertType", "placeholder", "class", "style", "maxLength", "maxMultiBiteLength", "designText", "disabled", "unUseChars"])) : E("", !0),
          y.type === 1 ? (i(), pe(Tl, {
            key: 1,
            modelValue: h(s),
            "onUpdate:modelValue": k[1] || (k[1] = (x) => tt(s) ? s.value = x : null),
            options: e.options,
            convertType: e.inputType,
            placeholder: e.placeHolder,
            isError: h(d),
            inputStyles: h(p),
            maxLength: e.maxLength,
            maxMultiBiteLength: e.maxMultiBiteLength,
            disabled: e.disabled,
            unUseChars: e.unUseChars
          }, null, 8, ["modelValue", "options", "convertType", "placeholder", "isError", "inputStyles", "maxLength", "maxMultiBiteLength", "disabled", "unUseChars"])) : E("", !0),
          y.type === 2 ? (i(), pe($l, {
            key: 2,
            numValue: h(o),
            "onUpdate:numValue": k[2] || (k[2] = (x) => tt(o) ? o.value = x : null),
            options: e.selectOptions,
            placeholder: e.placeHolder,
            placeholderValue: e.placeHolderValue,
            isError: h(d),
            inputWidth: e.inputWidth
          }, null, 8, ["numValue", "options", "placeholder", "placeholderValue", "isError", "inputWidth"])) : E("", !0),
          Y(y.$slots, "tail")
        ], 2)
      ], 2),
      0 < h(u).length ? (i(), m("div", {
        key: 0,
        class: H(["input-text-annotation", y.$style.errorTextArea]),
        style: ee(h(r))
      }, [
        (i(!0), m(V, null, Q(h(u), (x, L) => (i(), m("span", { key: L }, A(x), 1))), 128))
      ], 6)) : E("", !0),
      0 < h(C).length ? (i(), m("div", {
        key: 1,
        class: H(["input-text-validation-error-message", y.$style.errorTextArea]),
        style: ee(h(r))
      }, [
        (i(!0), m(V, null, Q(h(C), (x, L) => (i(), m("span", { key: L }, A(x), 1))), 128))
      ], 6)) : E("", !0)
    ], 2));
  }
}), Bl = "_container_1kdml_5", Ll = "_reserveErrorTextArea_1kdml_25", Rl = "_inputAreaHorizontal_1kdml_35", Al = "_inputAreaVertical_1kdml_57", Ol = "_errorTextArea_1kdml_79", Vl = {
  container: Bl,
  reserveErrorTextArea: Ll,
  inputAreaHorizontal: Rl,
  inputAreaVertical: Al,
  errorTextArea: Ol
}, Hl = {
  $style: Vl
}, mr = /* @__PURE__ */ Z(El, [["__cssModules", Hl]]), Ul = ["id", "accept"], Wl = ["disabled"], fr = /* @__PURE__ */ F({
  __name: "SelectFileInput",
  props: {
    modelValue: { type: File, default: void 0 },
    // File情報を受け取る変数。「v-model」で指定する
    id: { type: String, default: "SelectFileUtilDF" },
    // 同一Vue内で一意となるように指定する
    textCaption: { type: String, default: "" },
    // ファイルパス入力エリアのキャプション
    selectedTextCaption: { type: String, default: "" },
    // 選択されている時のファイルパス入力エリアのキャプション
    btnCaption: { type: String, default: "参照" },
    // ボタンのキャプション
    accept: { type: String, default: void 0 },
    // ファイル選択ダイアログで指定するファイル拡張子の初期状態
    widthEdit: { type: Number, default: 0 },
    // エディットボックスの幅（0ならflex-grow-1）
    sjisOnlyName: { type: Boolean, default: !1 },
    // sjis範囲内の参照か
    disabled: { type: Boolean, default: !1 }
    // Disabled指定
  },
  emits: ["update:modelValue", "modifyFile"],
  setup(n, { emit: l }) {
    const e = n, t = l, s = T("");
    pn(() => {
      e.modelValue == null ? s.value = "" : e.selectedTextCaption.length === 0 ? s.value = e.modelValue.name : s.value = e.selectedTextCaption;
    });
    const o = () => {
      const r = document.getElementById(e.id);
      r != null && r != null && (r.value = ""), Ge("#" + e.id).click();
    }, c = (r) => {
      r.preventDefault();
      let d = r.target.files;
      if (d[0] != null && d[0] != null) {
        if (e.sjisOnlyName && d[0].name.includeNotSJIS()) {
          r.stopPropagation(), alert(`指定したファイルは使用できません。\r
ファイル名に使用できない文字が含まれています。`);
          return;
        }
        t("update:modelValue", d[0]), t("modifyFile", d[0]);
      }
    };
    return (r, d) => (i(), m(V, null, [
      a("input", {
        style: { display: "none" },
        id: n.id,
        type: "file",
        accept: n.accept,
        onChange: c
      }, null, 40, Ul),
      a("div", {
        class: H(["d-flex align-items-center", [n.widthEdit === 0 ? "flex-grow-1" : ""]])
      }, [
        De(a("input", {
          type: "text",
          class: H(["input-text-scv", [n.widthEdit === 0 ? "d-flex flex-grow-1" : ""]]),
          "onUpdate:modelValue": d[0] || (d[0] = (u) => s.value = u),
          style: ee([{ width: n.widthEdit != 0 ? n.widthEdit + "px" : "" }, { "margin-right": "8px" }]),
          disabled: ""
        }, null, 6), [
          [Bt, s.value]
        ]),
        a("button", {
          type: "button",
          class: "btn-scv-bgcolor btn-setting-size",
          style: { width: "64px", height: "32px" },
          onClick: o,
          disabled: n.disabled
        }, A(n.btnCaption), 9, Wl)
      ], 2)
    ], 64));
  }
});
class pr {
  /// <summary>
  /// コンストラクタ
  /// </summary>
  constructor(l = 0, e = "", t = 0, s = void 0, o = void 0, c = void 0) {
    // カラムID
    N(this, "columnID", 0);
    // テキスト
    N(this, "text", "");
    // データタイプ
    N(this, "dataType", 0);
    // カラム幅
    N(this, "columnWidth");
    // カラム幅の最大幅
    N(this, "columnMaxWidth");
    // カラム幅の最小値
    N(this, "columnMinWidth");
    this.columnID = l, this.text = e, this.dataType = t, this.columnWidth = s, this.columnMaxWidth = o, this.columnMinWidth = c;
  }
}
class xt {
  constructor() {
    /// <summary>
    /// カラム幅
    /// </summary>
    N(this, "columnWidth");
    /// <summary>
    /// 最小のカラム幅
    /// </summary>
    N(this, "columnMinWidth");
    /// <summary>
    /// 最大のカラム幅
    /// </summary>
    N(this, "columnMaxWidth");
  }
}
var X = /* @__PURE__ */ ((n) => (n[n.string = 1] = "string", n[n.number = 2] = "number", n[n.icon = 4] = "icon", n[n.link = 8] = "link", n[n.icon_s = 16] = "icon_s", n[n.no_sort = 32] = "no_sort", n[n.html_column = 64] = "html_column", n[n.check_column = 128] = "check_column", n[n.file_size = 256] = "file_size", n[n.external_sort = 512] = "external_sort", n))(X || {});
const Pl = { class: "container" }, Fl = { class: "img-wrapper" }, zl = ["data-bs-toggle", "src"], Gl = /* @__PURE__ */ F({
  __name: "ImageHover",
  props: {
    imageUrl_small: { type: String, required: !0 },
    // 画像のURL
    imageUrl_big: { type: String, required: !0 }
    // 画像のURL
  },
  setup(n) {
    const l = n, e = T(""), t = T("tooltip tooltip-font scv-tooltip-manual"), s = T(null), o = T(null), c = T(!1), r = T(!1), d = (p) => {
      if (c.value) {
        p();
        return;
      }
      const v = new Image();
      v.src = l.imageUrl_big, v.onload = () => {
        e.value = `<img id="hoverImage" src="${l.imageUrl_big}">`, c.value = !0, p();
      };
    }, u = () => {
      o.value && (r.value || (r.value = !0, d(() => {
        o.value && (s.value || (s.value = new _n(o.value, {
          title: e.value,
          html: !0,
          placement: "bottom",
          template: '<div class="tooltip tooltip-font scv-image-hover" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
          fallbackPlacements: ["top", "bottom"]
          // 自動調整される位置を指定
        }), r.value && s.value.show()));
      })));
    }, C = () => {
      r.value = !1, s.value && (s.value.dispose(), s.value = null);
    };
    return (p, v) => (i(), m("div", Pl, [
      a("div", Fl, [
        a("img", {
          "data-bs-toggle": t.value,
          src: n.imageUrl_small,
          class: H({ "half-opacity": r.value }),
          onMouseover: u,
          onMouseout: C,
          ref_key: "imageElement",
          ref: o
        }, null, 42, zl)
      ])
    ]));
  }
}), ql = /* @__PURE__ */ Z(Gl, [["__scopeId", "data-v-67279d2e"]]), jl = {
  class: "sticky-top",
  style: { "z-index": "990" }
}, Yl = {
  key: 0,
  style: { width: "30px" }
}, Kl = ["checked", "disabled"], Ql = ["onClick"], Jl = {
  class: "d-flex flex-row align-items-center",
  style: { position: "relative", height: "100%", "align-items": "center" }
}, Zl = {
  key: 0,
  class: "ellipsis"
}, Xl = ["innerHTML"], eo = {
  key: 0,
  class: "icon-font-slategray"
}, to = {
  key: 1,
  class: "icon-font-slategray"
}, no = ["onMousedown"], lo = {
  key: 1,
  style: { padding: "0" }
}, oo = {
  key: 2,
  style: { width: "0px", padding: "0", border: "none" }
}, so = ["onClick"], ao = {
  key: 0,
  style: { width: "36px" }
}, io = ["onClick", "checked"], ro = ["innerHTML", "onClick"], co = ["id", "checked", "onClick", "disabled"], uo = ["onClick"], mo = {
  key: 1,
  style: { padding: "0" }
}, fo = {
  key: 2,
  style: { width: "0px", padding: "0", border: "none" }
}, Ct = 100, po = 50, ho = /* @__PURE__ */ F({
  __name: "ListCtrl",
  props: {
    columns: { type: Array, required: !0 },
    // 対象カラム(Array<SearchColumnData>)
    selectType: { type: Number, default: 0 },
    // 0:選択なし 1:単数選択 2:複数選択 3:チェックボックス付複数選択
    saveMemoryMode: { type: Boolean, default: !1 },
    // 省メモリモード（ソートやページネーションなどをメモリ上で行わず、SQLなどで行うときにtrueにします）
    sortDeleteIndex: { type: Boolean, default: !0 },
    // true: ソート時に選択状態を忘れる
    enableAllCheck: { type: Boolean, default: !0 },
    // false: ヘッダのチェックボックスがなくなる
    enableSetting: { type: Boolean, default: !0 },
    // false: リストを無効化する
    /*
     * 通常テキストのcell文言作成
     * @param[in]   column: カラム
     * @param[in]   index: リストのindex
     * return cellのテキスト
     */
    getCellTextFunc: { type: Function, default: null },
    getImageFunc: { type: Function, default: null },
    getCellCheckFunc: { type: Function, default: null },
    // 特殊なソートを行いたいときのcompare関数
    // l < r :-1
    // l = r :0
    // l > r :1
    externalCompareFunc: { type: Function, default: null },
    /*
     * アイコンとかリンクとかにしたいときcellのHTMLを取得
     * @param[in]   column: カラム
     * @param[in]   index: リストのindex
     * return cellのクラス名
     */
    getCellHTMLFunc: { type: Function, default: null },
    /*
     * cellの個別のstyleを取得
     * @param[in]   column: カラム
     * return cellのクラス名
     */
    getCellStyleFunc: { type: Function, default: null },
    /*
     * 行が選択された時の個別のstyleを取得
     * @param[in]   index: 行インデックス
     */
    getSelectRowStyleFunc: { type: Function, default: null },
    /* 行ごとのクラス名を取得 */
    getRowClassFunc: { type: Function, default: null },
    /* 複数行表示かどうか（paddingが前後に4px付くようになるだけ） */
    multiLine: { type: Boolean, default: !1 },
    /* チェックボックス押下時（変更前） */
    selectRowCheckButtonFunc: { type: Function, default: null },
    /* ヘッダのチェックボックス押下時（変更前） */
    selectHeaderCheckButtonFunc: { type: Function, default: null }
  },
  emits: ["onClickCell", "onSelectIndexChanged", "onColumnHeaderClick"],
  setup(n, { expose: l, emit: e }) {
    const t = n, s = e;
    let o = 0, c = T(new Array()), r = T(new Array()), d = T(/* @__PURE__ */ new Set()), u = -1;
    const C = T(-1), p = T(!0);
    let v = "", S = -1, f = -1, g = X.no_sort, y = X.html_column, k = X.check_column, x = T(new Array()), L = 0, U = T(0), q = T(40), J = T(32), j = T(), ne = T(), ce = null, he, Ce = window.innerWidth, se = T(/* @__PURE__ */ new Map()), me = T();
    const G = T([]);
    let Re = 0, ae = 0, Oe, Ve = !1, be = !1, R = !1, P = T(!1);
    const le = $(() => t.columns.reduce((b, I) => (b.set(I.columnID, I), b), /* @__PURE__ */ new Map()));
    Le(() => {
      ce = new ResizeObserver(() => ve()), ce.observe(j.value);
    }), Ee(
      r,
      () => {
        d.value = new Set(r.value);
      },
      {
        deep: !0
      }
    );
    const te = $(() => Array.from(se.value.values())), ve = () => {
      0 < he || (he = setTimeout(() => {
        Ce != window.innerWidth && (P.value = !0, Ce = window.innerWidth), Ze(), he = 0;
      }, 15));
    }, ke = (b) => {
      t.selectType != 0 && t.selectType != 3 && (r.value.splice(0, r.value.length), r.value.push(b), u = b, s("onSelectIndexChanged", st()));
    }, Me = (b) => {
      t.selectType != 0 && t.selectType != 3 && (u = b, D(b));
    }, qe = (b) => {
      if (t.selectType != 0 && t.selectType != 3) {
        if (t.selectType == 1) {
          ke(b);
          return;
        }
        if (u != b) {
          u == -1 && (u = c.value[0]);
          var I = c.value.findIndex((O) => O == u), _ = c.value.findIndex((O) => O == b);
          r.value.splice(0, r.value.length);
          var B = 0;
          if (I < _)
            for (B = I; B <= _; ++B)
              r.value.push(c.value[B]);
          else
            for (B = I; _ <= B; --B)
              r.value.push(c.value[B]);
          r.value.sort(function(O, ge) {
            return O - ge;
          }), s("onSelectIndexChanged", st());
        }
      }
    }, Ue = (b = new Event("default")) => {
      if (r.value.length == c.value.length && r.value.length > 0)
        r.value.splice(0, r.value.length);
      else {
        if (t.selectHeaderCheckButtonFunc != null && b.type != "default" && !t.selectHeaderCheckButtonFunc(c.value, b))
          return;
        r.value.splice(0, r.value.length);
        const I = c.value.length;
        for (let _ = 0; _ < I; ++_)
          r.value.push(c.value[_]);
      }
      r.value.sort(function(I, _) {
        return I - _;
      }), s("onSelectIndexChanged", st());
    }, We = (b) => {
      if (!Ve) {
        for (let I of t.columns)
          if (I.columnID == b && X.no_sort & I.dataType)
            return;
        C.value == b ? p.value = !p.value : p.value = !0, C.value = b, s("onColumnHeaderClick", C.value, p.value), t.saveMemoryMode || (M(), s("onSelectIndexChanged", st()));
      }
    }, Pe = (b, I) => {
      t.selectType == 3 && D(I, b);
    }, ue = (b, I, _) => {
      _ && s("onClickCell", I, b);
    }, Qe = () => {
      Ze();
    }, Tt = (b, I, _) => {
      Re = b.clientX, ae = G.value[_].offsetWidth, Oe = I, Ve = !0, P.value = !0, R || (be = !0), document.addEventListener("mousemove", yt), document.addEventListener("mouseup", ut), document.body.style.userSelect = "none";
    }, yt = (b) => {
      if (Oe === void 0) return;
      const I = le.value.get(Oe), _ = se.value.get(Oe);
      if (!_ || !I) return;
      const B = b.clientX - Re, O = ae + B;
      (I.columnMinWidth ?? po) <= O && (_.columnWidth = O, _.columnMinWidth = O, _.columnMaxWidth = O);
    }, ut = () => {
      document.removeEventListener("mousemove", yt), document.removeEventListener("mouseup", ut), Oe = void 0, document.body.style.userSelect = "", R || (be = !1), setTimeout(() => {
        Ve = !1;
      }, 0);
    }, M = () => {
      let b = new Array(), I = -1;
      if (t.sortDeleteIndex || (b = st(), I = u), j.value != null && (L == 0 && (L = at(j.value.scrollTop)), j.value.scrollTop = 0), r.value.splice(0, r.value.length), c.value.splice(0, c.value.length), u = -1, t.saveMemoryMode)
        for (let B = 0; B < o; B++)
          c.value.push(B);
      else {
        var _ = w(t.columns, C.value, p.value, v);
        _.forEach((B) => c.value.push(B)), c.value.length != 0 && -1 < S && -1 < f && S <= f && (c.value = c.value.slice(S, f + 1));
      }
      t.sortDeleteIndex || (Rt(b), u = I), Ze();
    }, w = (b, I, _, B) => {
      let O = new Array();
      if (B.length == 0)
        for (let xe = 0; xe < o; ++xe)
          O.push(xe);
      else {
        const xe = B.split(" ");
        for (let je = 0; je < o; je++)
          for (const Xe of xe) {
            if (Xe.length === 0)
              continue;
            let Ye = !1;
            for (let et = 0; et < t.columns.length && (Ye = z(t.columns[et].columnID, t.columns[et].dataType, je, !1).toLowerCase().indexOf(Xe.toLowerCase()) !== -1, !Ye); ++et)
              ;
            Ye && (O.includes(je) || O.push(je));
          }
      }
      let ge = -1, $e = -1;
      for (let xe = 0; xe < b.length; xe++)
        if (b[xe].columnID == I) {
          ge = xe, $e = b[xe].dataType;
          break;
        }
      let Fe = -1;
      return _ && (Fe = 1), ge != -1 && $e != -1 && O.sort((xe, je) => {
        if (t.externalCompareFunc && X.external_sort & $e)
          return t.externalCompareFunc(I, xe, je) * Fe;
        let Xe = "", Ye = "";
        if (X.check_column & $e ? (Xe = ye(I, xe) ? "1" : "0", Ye = ye(I, je) ? "1" : "0") : (Xe = W(I, xe, !1), Ye = W(I, je, !1)), X.number & $e || X.check_column & $e || X.file_size & $e) {
          const et = parseInt(Xe), gt = parseInt(Ye);
          return isNaN(et) && isNaN(gt) ? Xe.compareSort(Ye) * Fe : isNaN(et) ? -1 * Fe : isNaN(gt) ? 1 * Fe : (et - gt) * Fe;
        } else
          return Xe.toLocaleLowerCase().compareSort(Ye.toLocaleLowerCase()) * Fe;
      }), O;
    }, D = (b, I = new Event("default")) => {
      if (t.selectType == 1) {
        ke(b);
        return;
      }
      if (t.selectRowCheckButtonFunc != null && I.type != "default")
        r.value = t.selectRowCheckButtonFunc(r.value, b, I);
      else {
        var _ = r.value.indexOf(b);
        0 <= _ ? r.value.splice(_, 1) : r.value.push(b);
      }
      r.value.sort(function(B, O) {
        return B - O;
      }), s("onSelectIndexChanged", st());
    }, W = (b, I, _) => {
      let B = "", O = !1;
      if (t.getCellHTMLFunc != null) {
        const ge = t.getCellHTMLFunc(b, I);
        ge != "" && (B = _ ? ge : Ge.parseHTML(ge).reduce(($e, Fe) => Fe.textContent ? $e + Fe.textContent : $e, ""), O = !0);
      }
      return t.getCellTextFunc != null && !O && (B = t.getCellTextFunc(b, I)), B;
    }, z = (b, I, _, B) => {
      if (X.file_size & I && t.getCellTextFunc != null) {
        const O = t.getCellTextFunc(b, _), ge = parseInt(O);
        return isNaN(ge) ? O : xn.ConvStorage(ge);
      }
      return W(b, _, B);
    }, ye = (b, I) => {
      let _ = !1;
      return t.getCellCheckFunc != null && (_ = t.getCellCheckFunc(b, I)), _;
    }, re = (b) => {
      var I = "";
      if (d.value.has(b) && t.selectType != 3) {
        let _ = "";
        t.getSelectRowStyleFunc != null && (_ = t.getSelectRowStyleFunc(b)), _ != null && 0 < _.length ? I += " " + _ : I += " table-common-scv-select-cell-color";
      }
      return I;
    }, ot = (b) => {
      let I = "df-list-ctrl-cell";
      return X.icon & b ? I += " df-list-ctrl-cell-icon" : X.icon_s & b && (I += " df-list-ctrl-cell-icon-s"), I;
    }, Je = (b) => {
      let I = {};
      if (t.getCellStyleFunc != null) {
        let B = t.getCellStyleFunc(b);
        B != null && (I = B);
      }
      const _ = t.columns.find((B) => B.columnID === b);
      if (_ && X.check_column & _.dataType && (I["text-align"] = "center"), se.value.has(b)) {
        let B = se.value.get(b);
        B != null && B.columnMaxWidth != null && (I["max-Width"] = B.columnMaxWidth + "px");
      }
      return I;
    }, ie = (b) => {
      var _;
      let I = {};
      if (I.cursor = g & b.dataType ? "default" : "pointer", I.overflow = "hidden", se.value.has(b.columnID)) {
        let B = (_ = se.value.get(b.columnID)) == null ? void 0 : _.columnMaxWidth;
        B != null && 0 < B && (I["max-width"] = B + "px");
      }
      return I;
    }, _e = (b, I) => t.getImageFunc != null && t.getImageFunc(I, b, !1) != "", Ie = (b, I) => t.getCellHTMLFunc != null && t.getCellHTMLFunc(I, b) != "", we = (b) => !!(X.link & b || X.check_column & b), Ze = () => {
      let b = 0;
      if (j.value != null && (b = at(j.value.scrollTop)), ne.value != null) {
        const I = ne.value.getElementsByTagName("td")[0];
        I != null && I.offsetHeight != 0 && (J.value = I.offsetHeight);
      }
      if (j.value != null) {
        let I = b / J.value, _ = Math.floor(I / Ct) * Ct, B = Ct / 2;
        _ = B < _ ? _ - B : _, U.value = _;
        let O = Ct * 2, ge = _ + O;
        x.value = c.value.slice(U.value, ge);
      }
      it(() => {
        Xt(), me.value != null && j.value != null && 0 < L && (L < me.value.clientHeight ? j.value.scrollTop = at(L) : j.value.scrollTop = at(me.value.clientHeight), L = 0);
      });
    }, dt = () => {
      if (t.selectType == 3) {
        let I = new xt();
        I.columnWidth = 36, I.columnMinWidth = 36, I.columnMaxWidth = 36, se.value.set(-1, I);
      }
      let b = !0;
      for (let I = 0; I < t.columns.length; ++I) {
        let _ = new xt();
        _.columnWidth = 0 < (t.columns[I].columnWidth ?? 0) ? t.columns[I].columnWidth : void 0, _.columnMaxWidth = 0 < (t.columns[I].columnMaxWidth ?? 0) ? t.columns[I].columnMaxWidth : void 0, b && _.columnWidth == null && (b = !1), se.value.set(t.columns[I].columnID, _);
      }
      0 < t.columns.length && b && (R = !0, be = !0);
    }, Xt = () => {
      if (t.columns.length != 0 && (se.value.size == 0 && dt(), G.value != null))
        for (let b = 0; b < G.value.length; ++b) {
          const _ = G.value[b].getBoundingClientRect();
          if (0 < _.width) {
            if (!se.value.has(t.columns[b].columnID))
              continue;
            let B = se.value.get(t.columns[b].columnID);
            B != null && (B.columnMinWidth == null || B.columnMinWidth < _.width) && (B.columnMinWidth = _.width, B.columnWidth = _.width);
          }
        }
    }, en = (b) => {
      o = b, se.value = /* @__PURE__ */ new Map(), P.value = !1, R = !1, be = !1, M(), it(() => {
        dt(), Ze();
      });
    }, st = () => {
      let b = new Array();
      return b = at(r.value), b.sort(function(I, _) {
        return I - _;
      }), b;
    }, tn = () => at(c.value), nn = () => at(x.value), ln = (b) => {
      v = b, M();
    }, on = (b, I) => {
      for (let _ of t.columns)
        if (_.columnID == b && X.no_sort & _.dataType)
          return;
      C.value = b, p.value = I;
    }, sn = () => C.value, an = () => p.value, rn = (b, I) => {
      S = b, f = I, M();
    }, cn = (b) => {
      if (b < 0 || o <= b)
        return;
      let I = c.value[b];
      r.value.splice(0, r.value.length), r.value.push(I), u = I;
    }, Rt = (b) => {
      r.value.splice(0, r.value.length), u = -1;
      let I = new Set(c.value);
      for (let _ = 0; _ < b.length; _++) {
        const B = b[_];
        B < 0 || o <= B || I.has(B) && r.value.push(B);
      }
    };
    return l({
      updateList: en,
      getSelectListIndex: st,
      getDisplayListIndex: tn,
      getVisibleListIndex: nn,
      search: ln,
      setSort: on,
      getSortColumnID: sn,
      getIsAsc: an,
      setPaginationIndex: rn,
      selectRow: cn,
      selectRows: Rt,
      selectRowAll: () => {
        r.value.splice(0, r.value.length), u = -1;
        for (let b of c.value)
          b != -1 && r.value.push(b);
      }
    }), (b, I) => (i(), m("div", {
      class: H(["overflow-auto table-common-scv-out-border table-common-scv-bg", [t.enableSetting ? "" : "disabled"]]),
      ref_key: "ref_list",
      ref: j,
      onScroll: Qe
    }, [
      a("div", {
        class: "virtual-area",
        ref_key: "ref_virtualArea",
        ref: me,
        style: ee({ height: h(J) * h(c).length + h(q) + "px" })
      }, [
        a("table", {
          class: H(["table-common-scv text-nowrap table-striped view-area", [t.multiLine ? "table-common-scv-multiline" : ""]]),
          ref_key: "ref_table",
          ref: ne,
          frame: "box",
          bordercolor: "lightgray",
          style: ee({ top: h(J) * h(U) + "px", "table-layout": h(be) ? "fixed" : "auto" })
        }, [
          a("colgroup", null, [
            (i(!0), m(V, null, Q(te.value, (_, B) => (i(), m("col", {
              key: B,
              style: ee({ minWidth: _.columnMinWidth + "px", width: _.columnWidth + "px", maxWidth: _.columnMaxWidth + "px" })
            }, null, 4))), 128))
          ]),
          a("thead", jl, [
            a("tr", null, [
              t.selectType === 3 ? (i(), m("th", Yl, [
                t.enableAllCheck ? (i(), m("input", {
                  key: 0,
                  type: "checkbox",
                  onClick: I[0] || (I[0] = (_) => Ue(_)),
                  checked: h(r).length == h(c).length && h(r).length > 0,
                  disabled: h(c).length == 0
                }, null, 8, Kl)) : E("", !0)
              ])) : E("", !0),
              (i(!0), m(V, null, Q(t.columns, (_, B) => (i(), m("th", {
                key: B,
                ref_for: !0,
                ref_key: "ref_tableHeader",
                ref: G,
                onClick: (O) => We(_.columnID),
                style: ee(ie(_))
              }, [
                a("div", Jl, [
                  h(y) & _.dataType ? (i(), m("span", {
                    key: 1,
                    innerHTML: _.text
                  }, null, 8, Xl)) : (i(), m("span", Zl, A(_.text), 1)),
                  C.value === _.columnID ? (i(), m(V, { key: 2 }, [
                    p.value ? (i(), m("div", eo, I[1] || (I[1] = [
                      a("i", { class: "icon-arrow2top" }, null, -1)
                    ]))) : (i(), m("div", to, I[2] || (I[2] = [
                      a("i", { class: "icon-arrow2down" }, null, -1)
                    ])))
                  ], 64)) : E("", !0),
                  a("div", {
                    class: "resizer",
                    onMousedown: (O) => Tt(O, _.columnID, B)
                  }, null, 40, no)
                ])
              ], 12, Ql))), 128)),
              h(P) ? (i(), m("th", lo)) : (i(), m("th", oo))
            ])
          ]),
          a("tbody", null, [
            (i(!0), m(V, null, Q(h(x), (_, B) => (i(), m("tr", {
              class: H([t.getRowClassFunc ? t.getRowClassFunc(_) : ""]),
              key: B,
              onClick: [
                nt((O) => ke(_), ["exact"]),
                nt((O) => Me(_), ["ctrl", "exact"]),
                nt((O) => qe(_), ["shift", "exact"])
              ]
            }, [
              t.selectType === 3 ? (i(), m("td", ao, [
                a("input", {
                  type: "checkbox",
                  onClick: (O) => Pe(O, _),
                  checked: h(d).has(_)
                }, null, 8, io)
              ])) : E("", !0),
              Y(b.$slots, "row", { rowIndex: _ }, () => [
                (i(!0), m(V, null, Q(t.columns, (O, ge) => (i(), m("td", {
                  key: ge,
                  class: H(ot(O.dataType) + re(_)),
                  style: ee(Je(O.columnID))
                }, [
                  _e(_, O.columnID) ? (i(), pe(ql, {
                    key: 0,
                    imageUrl_small: n.getImageFunc(O.columnID, _, !1),
                    imageUrl_big: n.getImageFunc(O.columnID, _, !0)
                  }, null, 8, ["imageUrl_small", "imageUrl_big"])) : Ie(_, O.columnID) ? (i(), m("span", {
                    key: 1,
                    innerHTML: z(O.columnID, O.dataType, _, !0),
                    onClick: ($e) => ue(_, O.columnID, we(O.dataType))
                  }, null, 8, ro)) : h(k) & O.dataType ? (i(), m("input", {
                    key: 2,
                    type: "checkbox",
                    id: "checkbox" + ge,
                    checked: ye(O.columnID, _),
                    onClick: ($e) => ue(_, O.columnID, we(O.dataType)),
                    disabled: !t.enableSetting
                  }, null, 8, co)) : (i(), m("span", {
                    key: 3,
                    onClick: ($e) => ue(_, O.columnID, we(O.dataType))
                  }, A(z(
                    O.columnID,
                    O.dataType,
                    _,
                    !1
                  )), 9, uo))
                ], 6))), 128))
              ], !0),
              h(P) ? (i(), m("td", mo)) : (i(), m("td", fo))
            ], 10, so))), 128))
          ])
        ], 6)
      ], 4)
    ], 34));
  }
}), vo = /* @__PURE__ */ Z(ho, [["__scopeId", "data-v-6c4e67b3"]]), yo = { class: "pagination" }, go = ["onClick"], Pt = 8, Co = /* @__PURE__ */ F({
  __name: "PaginationUtil",
  props: {
    totalPageNum: { type: Number, default: 1 }
    // 総ページ数
  },
  emits: ["onChanged"],
  setup(n, { expose: l, emit: e }) {
    const t = n, s = e, o = T(1), c = () => {
      o.value = 1, s("onChanged");
    }, r = () => {
      o.value !== 1 && (o.value = o.value - 1, s("onChanged"));
    }, d = () => {
      t.totalPageNum !== o.value && (o.value = o.value + 1, s("onChanged"));
    }, u = () => {
      o.value = t.totalPageNum, s("onChanged");
    }, C = (f) => {
      o.value = f, s("onChanged");
    }, p = (f) => {
      const g = Math.max(1, o.value - Pt / 2 + 1), y = Math.min(t.totalPageNum, g + Pt - 1);
      return g <= f && f <= y;
    };
    return l({
      get: () => o.value,
      set: (f) => {
        o.value = f;
      }
    }), (f, g) => (i(), m("nav", null, [
      a("ul", yo, [
        a("li", {
          class: H(["page-item", { disabled: o.value === 1 }])
        }, [
          a("a", {
            class: "page-link",
            "aria-label": "First",
            onClick: c
          }, g[0] || (g[0] = [
            a("div", {
              class: "d-flex align-items-center justify-content-center",
              style: { height: "100%" },
              "aria-hidden": "true"
            }, [
              a("div", { class: "icon-font-size" }, [
                a("i", { class: "icon-page_first" })
              ])
            ], -1)
          ]))
        ], 2),
        a("li", {
          class: H(["page-item", { disabled: 1 >= o.value }])
        }, [
          a("a", {
            class: "page-link",
            "aria-label": "Previous",
            onClick: r
          }, g[1] || (g[1] = [
            a("span", { "aria-hidden": "true" }, "前へ", -1)
          ]))
        ], 2),
        (i(!0), m(V, null, Q(n.totalPageNum, (y) => (i(), m(V, { key: y }, [
          p(y) ? (i(), m("li", {
            key: 0,
            class: H(["page-item", { active: o.value === y }])
          }, [
            a("a", {
              class: "page-link",
              onClick: (k) => C(y)
            }, A(y), 9, go)
          ], 2)) : E("", !0)
        ], 64))), 128)),
        a("li", {
          class: H(["page-item", { disabled: n.totalPageNum <= o.value }])
        }, [
          a("a", {
            class: "page-link",
            "aria-label": "Next",
            onClick: d
          }, g[2] || (g[2] = [
            a("span", { "aria-hidden": "true" }, "次へ", -1)
          ]))
        ], 2),
        a("li", {
          class: H(["page-item", { disabled: o.value === n.totalPageNum }])
        }, [
          a("a", {
            class: "page-link",
            "aria-label": "Last",
            onClick: u
          }, g[3] || (g[3] = [
            a("div", {
              class: "d-flex align-items-center justify-content-center",
              style: { height: "100%" },
              "aria-hidden": "true"
            }, [
              a("div", { class: "icon-font-size" }, [
                a("i", { class: "icon-page_last" })
              ])
            ], -1)
          ]))
        ], 2)
      ])
    ]));
  }
}), bo = /* @__PURE__ */ Z(Co, [["__scopeId", "data-v-6b54a587"]]), _o = { class: "paginationArea d-flex align-items-center" }, Io = {
  class: "select-icon",
  style: { margin: "0px 8px" }
}, xo = ["value"], ko = { class: "ms-auto" }, wo = /* @__PURE__ */ F({
  __name: "PaginationArea",
  props: {
    selectChangeList: { type: Array, default: [10, 100, 1e3] },
    defaultSelect: { type: Number, default: 100 }
  },
  emits: ["onChanged"],
  setup(n, { expose: l, emit: e }) {
    const t = n, s = e, o = T(0), c = T(0), r = T(0), d = T(1), u = T(t.defaultSelect), C = T(), p = () => {
      g(), v();
    }, v = () => {
      s("onChanged");
    }, S = () => {
      const y = new Array();
      return y.push((C.value.get() - 1) * u.value + 1), y.push(u.value), y;
    }, f = (y, k) => {
      if (y == 0)
        o.value = 0, c.value = 0;
      else {
        const x = (C.value.get() - 1) * u.value;
        o.value = x + 1, c.value = x + y;
      }
      d.value = Math.ceil(k / u.value), d.value == 0 && (d.value = 1), r.value = k;
    }, g = () => {
      o.value = 0, c.value = 0, r.value = 0, d.value = 1, C.value.set(1);
    };
    return l({
      get: S,
      set: f,
      reset: g
    }), (y, k) => (i(), m("div", _o, [
      k[1] || (k[1] = a("span", null, "1ページに", -1)),
      a("div", Io, [
        De(a("select", {
          class: "input-text-scv",
          style: { "min-width": "80px" },
          "onUpdate:modelValue": k[0] || (k[0] = (x) => u.value = x),
          onChange: p
        }, [
          (i(!0), m(V, null, Q(n.selectChangeList, (x) => (i(), m("option", {
            value: x,
            key: x
          }, A(x), 9, xo))), 128))
        ], 544), [
          [ht, u.value]
        ])
      ]),
      k[2] || (k[2] = a("span", { style: { "margin-right": "24px" } }, "件表示", -1)),
      de(bo, {
        ref_key: "ref_PaginationUtil",
        ref: C,
        totalPageNum: d.value,
        onOnChanged: v
      }, null, 8, ["totalPageNum"]),
      a("div", ko, A(o.value) + "-" + A(c.value) + "件表示中/全" + A(r.value) + "件", 1)
    ]));
  }
}), To = /* @__PURE__ */ Z(wo, [["__scopeId", "data-v-9129c2e8"]]);
var mt = /* @__PURE__ */ ((n) => (n[n.None = 0] = "None", n[n.Single = 1] = "Single", n[n.Multiple = 2] = "Multiple", n[n.CheckBox = 3] = "CheckBox", n[n.CheckBoxWithoutSelectAll = 4] = "CheckBoxWithoutSelectAll", n))(mt || {}), ct = /* @__PURE__ */ ((n) => (n[n.Minimum = 0] = "Minimum", n[n.ShowDropdownMenu = 1] = "ShowDropdownMenu", n[n.ShowExpantionButton = 2] = "ShowExpantionButton", n[n.DisposePagination = 4] = "DisposePagination", n[n.ShowPaginationIfNeeded = 8] = "ShowPaginationIfNeeded", n))(ct || {});
function So(n) {
  const l = T({}), e = T([]), t = $(() => {
    var C;
    const d = new Set(e.value), u = Object.entries(l.value).filter(([p, v]) => d.has(v)).map(([p, v]) => Number.parseInt(p));
    if (n.value) {
      const [p, v] = (C = n.value) == null ? void 0 : C.get(), S = p - 1;
      return u.filter((f) => S <= f && f < S + v).map((f) => f - S);
    } else
      return u;
  });
  function s(d) {
    const u = new Set(o(t.value)), C = e.value.filter((p) => !u.has(p));
    e.value = [
      ...C,
      ...o(d)
    ];
  }
  function o(d) {
    var C;
    let u = 0;
    if (n.value) {
      const [p, v] = (C = n.value) == null ? void 0 : C.get();
      u = p - 1;
    }
    return Array.isArray(d) ? d.map((p) => l.value[p + u]) : l.value[d + u];
  }
  function c(d, u, C, p) {
    l.value = {}, 0 <= d.columnId ? Array.from({ length: u }, (v, S) => S).map((v) => ({
      index: v,
      value: C(d.columnId, v),
      required: p(v)
    })).sort((v, S) => {
      let f = r(v, S, d.columnType);
      return v.required && !S.required ? f = d.ascending ? -1 : 1 : !v.required && S.required && (f = d.ascending ? 1 : -1), d.ascending ? f : -f;
    }).forEach((v, S) => {
      l.value[S] = v.index;
    }) : Array.from({ length: u }, (v, S) => S).forEach((v) => {
      l.value[v] = v;
    });
  }
  function r(d, u, C) {
    if (C & X.check_column || C & X.file_size || C & X.number) {
      if (Number.isNaN(d.value) && Number.isNaN(u.value))
        return d.value.localeCompare(u.value);
      if (Number.isNaN(d.value))
        return -1;
      if (Number.isNaN(u.value))
        return 1;
      const p = Number.parseInt(d.value), v = Number.parseInt(u.value);
      return p - v;
    } else
      return d.value.localeCompare(u.value);
  }
  return {
    selectedItemIndexes: e,
    displayedSelectedRowIndexes: t,
    updateSelectedItemIndexes: s,
    rowIndexToItemIndex: o,
    performLogicalSort: c
  };
}
const No = { class: "paginated-list-ctrl" }, Do = { class: "listArea d-flex flex-column flex-grow-1" }, Mo = {
  key: 0,
  class: "title-belt-table"
}, $o = {
  key: 0,
  class: "d-flex align-items-center ms-auto"
}, Eo = {
  class: "dropdown-menu scv-dropdown-menu",
  "aria-labelledby": "navbarDropdown"
}, Bo = ["onClick"], Lo = { class: "d-flex align-items-center justify-content-center" }, Ro = { class: "icon-font-deepblue" }, Ao = {
  key: 1,
  style: { height: "16px" }
}, Oo = { key: 3 }, Vo = /* @__PURE__ */ F({
  __name: "PaginatedListCtrl",
  props: {
    dataGetter: { type: Function, default: (n, l) => "" },
    columns: {},
    totalItems: {},
    styles: { default: ct.Minimum },
    selection: { default: mt.None },
    forgetSelectionAfterSort: { type: Boolean, default: !0 },
    selectedItemIndexes: {},
    checkStateGetter: { type: Function, default: (n, l) => !1 },
    columnStylesGetter: { type: Function, default: () => ({}) },
    rowClassGetter: { type: Function, default: () => "" },
    selectedColumnStylesGetter: { type: Function, default: () => ({}) },
    rowSelectionCommitter: { type: Function, default: (n, l, e) => !0 },
    selectAllCommitter: { type: Function, default: (n, l) => !0 },
    itemsDisplayedPerPageChoices: { default: () => [10, 100, 1e3] },
    itemsDisplayedPerPage: { default: 100 },
    disbled: { type: Boolean, default: !1 },
    useMultiline: { type: Boolean, default: !1 },
    expandList: { type: Boolean, default: !1 },
    decorator: {},
    revision: { default: 0 }
  },
  emits: ["cellClicked", "selectionChanged", "toggleExpantion", "menuClicked", "columnClicked"],
  setup(n, { expose: l, emit: e }) {
    const t = n, s = e, o = kt(), c = T(null), r = T(null), {
      selectedItemIndexes: d,
      displayedSelectedRowIndexes: u,
      updateSelectedItemIndexes: C,
      rowIndexToItemIndex: p,
      performLogicalSort: v
    } = So(r), S = T(t.expandList), f = $(() => mt.CheckBoxWithoutSelectAll === t.selection ? mt.CheckBox : t.selection), g = $(() => mt.CheckBoxWithoutSelectAll !== t.selection), y = $(() => (ct.ShowDropdownMenu & t.styles) !== 0 && !!o.menu), k = $(() => (ct.ShowExpantionButton & t.styles) !== 0), x = $(() => !!o.header || y.value || k.value), L = $(() => o.menu ? o.menu() : []), U = $(() => ct.DisposePagination & t.styles ? !1 : ct.ShowPaginationIfNeeded & t.styles ? Math.min(...t.itemsDisplayedPerPageChoices) < t.totalItems : !0), q = $(() => {
      if (!U.value)
        return t.totalItems;
      const R = t.itemsDisplayedPerPageChoices.find((te) => te === t.itemsDisplayedPerPage);
      if (R)
        return R;
      const P = Math.min(...t.itemsDisplayedPerPageChoices);
      if (t.itemsDisplayedPerPage <= P)
        return P;
      const le = Math.max(...t.itemsDisplayedPerPageChoices);
      return le <= t.itemsDisplayedPerPage ? le : t.itemsDisplayedPerPageChoices.reduce((te, ve) => Math.abs(ve - t.itemsDisplayedPerPage) < Math.abs(te - t.itemsDisplayedPerPage) ? ve : te);
    });
    Ee(() => t.selectedItemIndexes, () => {
      var R, P;
      kn(Vt(d.value), Vt(t.selectedItemIndexes)) || (d.value = t.selectedItemIndexes ?? [], (P = c.value) == null || P.selectRows(
        (R = t.decorator) != null && R.getSelectedRowIndexesInPage ? t.decorator.getSelectedRowIndexesInPage(0, q.value) : u.value
      ));
    }), Ee(d, (R, P) => {
      s("selectionChanged", d.value);
    }, { immediate: !0 }), Ee(() => t.totalItems, () => {
      d.value = t.selectedItemIndexes ?? [], it(() => {
        J();
      });
    }), Ee(() => t.revision, () => {
      it(() => {
        J();
      });
    }), Le(() => {
      d.value = t.selectedItemIndexes ?? [], it(() => {
        J();
      });
    });
    function J() {
      var R, P, le, te, ve, ke, Me, qe;
      if ((R = r.value) == null || R.set(q.value, t.totalItems), (P = c.value) == null || P.updateList(Math.min(t.totalItems, q.value)), c.value) {
        const Ue = c.value.getSortColumnID(), We = {
          columnId: Ue,
          ascending: c.value.getIsAsc(),
          columnType: ((le = t.columns.find((Pe) => Pe.columnID === Ue)) == null ? void 0 : le.dataType) ?? 0
        };
        if ((te = t.decorator) != null && te.performLogicalSort)
          t.decorator.performLogicalSort(We.columnId, We.ascending);
        else {
          const Pe = () => !1;
          v(
            We,
            t.totalItems,
            ((ve = t.decorator) == null ? void 0 : ve.getCellSortText) ?? t.dataGetter,
            ((ke = t.decorator) == null ? void 0 : ke.isRequired) ?? Pe
          );
        }
      }
      (qe = c.value) == null || qe.selectRows(
        (Me = t.decorator) != null && Me.getSelectedRowIndexesInPage ? t.decorator.getSelectedRowIndexesInPage(0, q.value) : u.value
      );
    }
    function j(R, P) {
      return t.dataGetter(R, p(P));
    }
    function ne(R) {
      return t.columnStylesGetter(R);
    }
    function ce(R) {
      return t.rowClassGetter(p(R));
    }
    function he(R) {
      return t.selectedColumnStylesGetter(p(R));
    }
    function Ce(R, P, le) {
      const te = new Set(R);
      return t.rowSelectionCommitter(
        new Set(p(R)),
        p(P),
        le
      ) ? te.has(P) ? te.delete(P) : te.add(P) : le.preventDefault(), Array.from(te);
    }
    function se(R, P) {
      return t.selectAllCommitter(p(R), P);
    }
    function me(R, P) {
      return t.checkStateGetter(R, p(P));
    }
    function G(R, P) {
      s("cellClicked", R, p(P));
    }
    function Re(R) {
      C(R);
    }
    function ae() {
      var le, te, ve, ke, Me;
      let [R, P] = (le = r.value) == null ? void 0 : le.get();
      t.totalItems < R - 1 + P && (P -= R + P - 1 - t.totalItems), (te = r.value) == null || te.set(P, t.totalItems), (ve = c.value) == null || ve.updateList(Math.min(t.totalItems, P)), (Me = c.value) == null || Me.selectRows(
        (ke = t.decorator) != null && ke.getSelectedRowIndexesInPage ? t.decorator.getSelectedRowIndexesInPage(R, P) : u.value
      );
    }
    function Oe(R, P) {
      var te, ve, ke, Me, qe, Ue, We, Pe;
      t.forgetSelectionAfterSort && (d.value = []);
      const le = {
        columnId: R,
        ascending: P,
        columnType: ((te = t.columns.find((ue) => ue.columnID === R)) == null ? void 0 : te.dataType) ?? 0
      };
      if ((ve = t.decorator) != null && ve.performLogicalSort) {
        t.decorator.performLogicalSort(le.columnId, le.ascending);
        let [ue, Qe] = (ke = r.value) == null ? void 0 : ke.get();
        t.totalItems < ue - 1 + Qe && (Qe -= ue + Qe - 1 - t.totalItems), (Me = t.decorator) != null && Me.getSelectedRowIndexesInPage && ((qe = c.value) == null || qe.selectRows(
          t.decorator.getSelectedRowIndexesInPage(ue, Qe)
        ));
      } else {
        const ue = () => !1;
        v(
          le,
          t.totalItems,
          ((Ue = t.decorator) == null ? void 0 : Ue.getCellSortText) ?? t.dataGetter,
          ((We = t.decorator) == null ? void 0 : We.isRequired) ?? ue
        ), (Pe = c.value) == null || Pe.selectRows(u.value);
      }
      s("columnClicked", le.columnId, le.ascending);
    }
    function Ve() {
      S.value = !S.value, s("toggleExpantion", S.value);
    }
    function be(R) {
      s("menuClicked", R);
    }
    return l({
      onGetCellText: j
    }), (R, P) => (i(), m("div", No, [
      a("div", Do, [
        h(x) ? (i(), m("div", Mo, [
          Y(R.$slots, "header", {}, void 0, !0),
          h(y) || h(k) ? (i(), m("div", $o, [
            h(y) ? (i(), m(V, { key: 0 }, [
              P[0] || (P[0] = a("button", {
                class: "btn-scv-bgcolor btn-icon",
                id: "navbarDropdown",
                "data-bs-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false",
                style: { "margin-left": "8px" }
              }, [
                a("div", { class: "d-flex align-items-center justify-content-center" }, [
                  a("div", { class: "icon-font-deepblue" }, [
                    a("i", { class: "icon-menu" })
                  ])
                ])
              ], -1)),
              a("div", Eo, [
                (i(!0), m(V, null, Q(h(L), (le, te) => (i(), m("div", {
                  key: te,
                  class: "scv-dropdown-menu-button"
                }, [
                  a("a", {
                    class: "dropdown-item",
                    href: "javascript:void(0);",
                    onClick: (ve) => be(te)
                  }, [
                    (i(), pe(Et(le)))
                  ], 8, Bo)
                ]))), 128))
              ])
            ], 64)) : E("", !0),
            h(k) ? (i(), m("button", {
              key: 1,
              class: "btn-scv-bgcolor btn-icon",
              onClick: Ve,
              style: { "margin-left": "8px" }
            }, [
              a("div", Lo, [
                a("div", Ro, [
                  a("i", {
                    class: H([h(S) ? "icon-screen_undo" : "icon-screen_full"])
                  }, null, 2)
                ])
              ])
            ])) : E("", !0)
          ])) : E("", !0)
        ])) : E("", !0),
        de(vo, {
          ref_key: "listCtrl",
          ref: c,
          class: "flex-grow-1",
          columns: t.columns,
          selectType: h(f),
          sortDeleteIndex: t.forgetSelectionAfterSort,
          enableSetting: !t.disbled,
          enableAllCheck: h(g),
          "multi-line": t.useMultiline,
          saveMemoryMode: !0,
          getCellTextFunc: j,
          getCellHTMLFunc: j,
          getCellCheckFunc: me,
          getCellStyleFunc: ne,
          getRowClassFunc: ce,
          getSelectRowStyleFunc: he,
          selectRowCheckButtonFunc: Ce,
          selectHeaderCheckButtonFunc: se,
          onOnClickCell: G,
          onOnSelectIndexChanged: Re,
          onOnColumnHeaderClick: Oe
        }, {
          row: ze(({ rowIndex: le }) => [
            Y(R.$slots, "row", {
              itemIndex: h(p)(le)
            }, void 0, !0)
          ]),
          _: 3
        }, 8, ["columns", "selectType", "sortDeleteIndex", "enableSetting", "enableAllCheck", "multi-line"]),
        h(U) || R.$slots.footer ? (i(), m("div", Ao)) : E("", !0),
        h(U) ? (i(), pe(To, {
          key: 2,
          ref_key: "paginationArea",
          ref: r,
          selectChangeList: t.itemsDisplayedPerPageChoices,
          defaultSelect: h(q),
          onOnChanged: ae
        }, null, 8, ["selectChangeList", "defaultSelect"])) : E("", !0),
        R.$slots.footer ? (i(), m("div", Oo, [
          Y(R.$slots, "footer", {}, void 0, !0)
        ])) : E("", !0)
      ])
    ]));
  }
}), hr = /* @__PURE__ */ Z(Vo, [["__scopeId", "data-v-f2e4afaa"]]), Ho = { class: "overflow-auto table-common-scv-out-border table-common-scv-bg" }, Uo = {
  class: "sticky-top",
  style: { "z-index": "990" }
}, Wo = {
  key: 0,
  style: { width: "30px" }
}, Po = ["checked", "disabled"], Fo = ["onClick"], zo = {
  class: "d-flex flex-row align-items-center",
  style: { position: "relative", height: "100%", "align-items": "center" }
}, Go = {
  key: 0,
  class: "ellipsis"
}, qo = ["innerHTML"], jo = {
  key: 0,
  class: "icon-font-slategray"
}, Yo = {
  key: 1,
  class: "icon-font-slategray"
}, Ko = ["onMousedown"], Qo = { key: 1 }, Jo = {
  key: 2,
  style: { width: "0px", padding: "0 !important", border: "none" }
}, Zo = ["onClick"], Xo = { key: 0 }, es = ["onClick", "checked"], ts = ["innerHTML", "onClick"], ns = ["onClick"], ls = { key: 1 }, os = {
  key: 2,
  style: { width: "0px", padding: "0 !important", border: "none" }
}, ss = 36, as = /* @__PURE__ */ F({
  __name: "VariableListCtrl",
  props: {
    columns: { type: Array, required: !0 },
    // 対象カラム(Array<SearchColumnData>)
    selectType: { type: Number, default: 0 },
    // 0:選択なし 1:単数選択 2:複数選択 3:チェックボックス付複数選択
    saveMemoryMode: { type: Boolean, default: !1 },
    // 省メモリモード（ソートやページネーションなどをメモリ上で行わず、SQLなどで行うときにtrueにします）
    sortDeleteIndex: { type: Boolean, default: !0 },
    // true: ソート時に選択状態を忘れる
    /*
     * 通常テキストのcell文言作成
     * @param[in]   column: カラム
     * @param[in]   index: リストのindex
     * return cellのテキスト
     */
    getCellTextFunc: { type: Function, default: null },
    /*
     * アイコンとかリンクとかにしたいときcellのHTMLを取得
     * @param[in]   column: カラム
     * @param[in]   index: リストのindex
     * return cellのクラス名
     */
    getCellHTMLFunc: { type: Function, default: null },
    /*
     * cellの個別のstyleを取得
     * @param[in]   column: カラム
     * return cellのクラス名
     */
    getCellStyleFunc: { type: Function, default: null },
    /*
     * 行が選択された時の個別のstyleを取得
     * @param[in]   index: 行インデックス
     */
    getSelectRowStyleFunc: { type: Function, default: null },
    /* 行ごとのクラス名を取得 */
    getRowClassFunc: { type: Function, default: null },
    /* 複数行表示かどうか（paddingが前後に4px付くようになるだけ） */
    MultiLine: { type: Boolean, default: !1 }
  },
  emits: ["onClickCell", "onSelectIndexChanged", "onColumnHeaderClick"],
  setup(n, { expose: l, emit: e }) {
    class t {
      constructor() {
        /// <summary>
        /// カラムID
        /// </summary>
        N(this, "columnID", 0);
        /// <summary>
        /// 表示内容（includingHtmlがtrueならhtml文）
        /// </summary>
        N(this, "text", "");
        /// <summary>
        /// クラス名
        /// </summary>
        N(this, "className", "");
        /// <summary>
        /// HTML表示かどうか
        /// </summary>
        N(this, "includingHtml", !1);
        /// <summary>
        /// クリック時に親にイベントを返すかどうか
        /// </summary>
        N(this, "notifyClickEvent", !1);
        /// <summary>
        /// スタイル
        /// </summary>
        N(this, "style");
      }
    }
    class s {
      constructor() {
        /// <summary>
        /// セルデータ
        /// </summary>
        N(this, "cells", new Array());
        /// <summary>
        /// ID
        /// </summary>
        N(this, "id", 0);
      }
    }
    const o = n, c = e;
    let r = St(new Array()), d = St(new Array()), u = St(new Array()), C = new Array(), p = -1, v = !0, S = "", f = -1, g = X.no_sort, y = X.html_column;
    const k = T(), x = T([]);
    let L = 0, U = 0, q, J = !1, j = T(!1), ne = T(/* @__PURE__ */ new Map()), ce = null, he, Ce = window.innerWidth;
    Le(() => {
      ce = new ResizeObserver(() => me()), ce.observe(k.value);
    });
    const se = $(() => Array.from(ne.value.values())), me = () => {
      0 < he || (he = window.setTimeout(() => {
        Ce != window.innerWidth && (j.value = !0, Ce = window.innerWidth), he = 0;
      }, 15));
    }, G = (M) => {
      o.selectType != 0 && o.selectType != 3 && (u.splice(0, u.length), u.push(M), c("onSelectIndexChanged", ue()));
    }, Re = (M) => {
      o.selectType != 0 && o.selectType != 3 && Me(M);
    }, ae = (M) => {
      if (o.selectType != 0 && o.selectType != 3) {
        if (o.selectType == 1 || u.length == 0) {
          G(M);
          return;
        }
        var w = u[0];
        if (w != M) {
          u.splice(0, u.length);
          var D = 0;
          if (w < M)
            for (D = w; D <= M; ++D)
              u.push(D);
          else
            for (D = w; M <= D; --D)
              u.push(D);
          u.sort(function(W, z) {
            return W - z;
          }), c("onSelectIndexChanged", ue());
        }
      }
    }, Oe = () => {
      if (u.length == d.length && u.length > 0)
        u.splice(0, u.length);
      else {
        u.splice(0, u.length);
        const M = d.length;
        for (let w = 0; w < M; ++w)
          u.push(w);
      }
      u.sort(function(M, w) {
        return M - w;
      }), c("onSelectIndexChanged", ue());
    }, Ve = (M) => {
      if (!J) {
        for (let w of o.columns)
          if (w.columnID == M && X.no_sort & w.dataType)
            return;
        p == M ? v = !v : v = !0, p = M, o.saveMemoryMode || (ve(), c("onSelectIndexChanged", ue())), c("onColumnHeaderClick", p, v);
      }
    }, be = (M) => {
      o.selectType == 3 && Me(M);
    }, R = (M, w, D) => {
      D && c("onClickCell", w, M);
    }, P = (M, w, D) => {
      L = M.clientX, U = x.value[D].offsetWidth, q = w, J = !0, j.value = !0, document.addEventListener("mousemove", le), document.addEventListener("mouseup", te), document.body.style.userSelect = "none";
    }, le = (M) => {
      var w;
      if (q !== void 0) {
        const D = M.clientX - L, W = U + D;
        if (W >= ss && ne.value.has(q)) {
          let z = (w = ne.value) == null ? void 0 : w.get(q);
          z != null && (z.columnWidth = W, z.columnMinWidth = W, z.columnMaxWidth = W);
        }
      }
    }, te = () => {
      document.removeEventListener("mousemove", le), document.removeEventListener("mouseup", te), q = void 0, document.body.style.userSelect = "", setTimeout(() => {
        J = !1;
      }, 0);
    }, ve = () => {
      let M = new Array();
      if (o.sortDeleteIndex || (M = ue()), u.splice(0, u.length), d.splice(0, d.length), o.saveMemoryMode)
        for (let D = 0; D < r.length; D++)
          d.push(D);
      else {
        var w = ke(o.columns, r, p, v, S);
        w.forEach((D) => d.push(D)), d.length != 0 && -1 < f;
      }
      o.sortDeleteIndex || ut(M), it(() => {
        We();
      });
    }, ke = (M, w, D, W, z) => {
      const ye = new Array();
      if (z.length == 0)
        for (let ie = 0; ie < w.length; ie++)
          ye.push(ie);
      else {
        const ie = z.split(" ");
        for (let _e = 0; _e < w.length; _e++)
          for (const Ie of ie) {
            if (Ie.length === 0)
              continue;
            w[_e].cells.some((Ze) => {
              if (Ze.includingHtml) {
                const dt = Ge(Ze.text).text();
                if (dt != null)
                  return dt.toLowerCase().indexOf(Ie.toLowerCase()) !== -1;
              }
              return Ze.text.toLowerCase().indexOf(Ie.toLowerCase()) !== -1;
            }) && (ye.includes(_e) || ye.push(_e));
          }
      }
      let re = -1, ot = -1;
      for (let ie = 0; ie < M.length; ie++)
        if (M[ie].columnID == D) {
          re = ie, ot = M[ie].dataType;
          break;
        }
      let Je = -1;
      return W && (Je = 1), re != -1 && ot != -1 && ye.sort((ie, _e) => {
        if (w[ie].cells.length <= re)
          return 0;
        if (w[_e].cells.length <= re)
          return 0;
        if (X.number & ot) {
          const Ie = parseInt(w[ie].cells[re].text), we = parseInt(w[_e].cells[re].text);
          return isNaN(Ie) && isNaN(we) ? w[ie].cells[re].text.compareSort(w[_e].cells[re].text) * Je : isNaN(Ie) ? -1 * Je : isNaN(we) ? 1 * Je : (Ie - we) * Je;
        } else {
          let Ie = "";
          w[ie].cells[re].includingHtml && !((X.icon | X.icon_s) & ot) ? (Ie = Ge(w[ie].cells[re].text).text(), Ie == null && (Ie = w[ie].cells[re].text)) : Ie = w[ie].cells[re].text;
          let we = "";
          return w[_e].cells[re].includingHtml && !((X.icon | X.icon_s) & ot) ? (we = Ge(w[_e].cells[re].text).text(), we == null && (we = w[_e].cells[re].text)) : we = w[_e].cells[re].text, Ie.toLocaleLowerCase().compareSort(we.toLocaleLowerCase()) * Je;
        }
      }), ye;
    }, Me = (M) => {
      if (o.selectType == 1) {
        G(M);
        return;
      }
      var w = u.indexOf(M);
      0 <= w ? u.splice(w, 1) : u.push(M), u.sort(function(D, W) {
        return D - W;
      }), c("onSelectIndexChanged", ue());
    }, qe = (M) => {
      var w = "";
      if (u.includes(M) && o.selectType != 3) {
        let D = "";
        o.getSelectRowStyleFunc != null && (D = o.getSelectRowStyleFunc(M)), D != null && 0 < D.length ? w += " " + D : w += " table-common-scv-select-cell-color";
      }
      return w;
    }, Ue = () => {
      if (ne.value = /* @__PURE__ */ new Map(), j.value = !1, o.selectType == 3) {
        let w = new xt();
        w.columnWidth = 36, w.columnMinWidth = 36, w.columnMaxWidth = 36, ne.value.set(-1, w);
      }
      let M = !0;
      for (let w = 0; w < o.columns.length; ++w) {
        M && o.columns[w].columnWidth == null && (M = !1);
        let D = new xt();
        D.columnWidth = 0 < (o.columns[w].columnWidth ?? 0) ? o.columns[w].columnWidth : void 0, D.columnMaxWidth = 0 < (o.columns[w].columnMaxWidth ?? 0) ? o.columns[w].columnMaxWidth : void 0, ne.value.set(o.columns[w].columnID, D);
      }
    }, We = () => {
      if (o.columns.length != 0 && (ne.value.size == 0 && Ue(), x.value != null))
        for (let M = 0; M < x.value.length; ++M) {
          const D = x.value[M].getBoundingClientRect();
          if (!ne.value.has(o.columns[M].columnID))
            continue;
          let W = ne.value.get(o.columns[M].columnID);
          W != null && (W.columnMinWidth == null || W.columnMinWidth < D.width) && (W.columnMinWidth = D.width, W.columnWidth = D.width);
        }
    }, Pe = (M) => {
      r.splice(0, r.length), d.splice(0, d.length), u.splice(0, u.length), C = new Array();
      for (let w = 0; w < M; w++) {
        let D = new s();
        o.getRowClassFunc != null && (C[w] = o.getRowClassFunc(w)), o.columns.forEach((W) => {
          let z = new t();
          if (z.columnID = W.columnID, o.getCellTextFunc != null && (z.text = o.getCellTextFunc(W.columnID, w)), z.className = "df-list-ctrl-cell", o.getCellStyleFunc != null) {
            const ye = o.getCellStyleFunc(W.columnID);
            ye != null && (z.style = ye);
          }
          if (o.getCellHTMLFunc != null) {
            const ye = o.getCellHTMLFunc(W.columnID, w);
            ye != "" && (z.text = ye, z.includingHtml = !0);
          }
          X.icon & W.dataType ? z.className += " df-list-ctrl-cell-icon" : X.icon_s & W.dataType && (z.className += " df-list-ctrl-cell-icon-s"), X.link & W.dataType && (z.notifyClickEvent = !0), D.cells.push(z);
        }), r.push(D);
      }
      Ue(), ve();
    }, ue = () => {
      let M = new Array();
      return u.forEach((w) => {
        w < d.length && M.push(d[w]);
      }), M.sort(function(w, D) {
        return w - D;
      }), M;
    }, Qe = (M, w) => {
      for (let D of o.columns)
        if (D.columnID == M && X.no_sort & D.dataType)
          return;
      p = M, v = w;
    }, Tt = () => p, yt = () => v, ut = (M) => {
      u.splice(0, u.length);
      for (let w = 0; w < M.length; w++) {
        const D = M[w];
        if (D < 0 || r.length <= D)
          continue;
        let W = d.indexOf(D);
        W != -1 && u.push(W);
      }
    };
    return l({
      updateList: Pe,
      getSelectListIndex: ue,
      setSort: Qe,
      getSortColumnID: Tt,
      getIsAsc: yt,
      selectRows: ut
    }), (M, w) => (i(), m("div", Ho, [
      a("table", {
        ref_key: "ref_table",
        ref: k,
        class: H(["table-common-scv text-nowrap table-striped", [n.MultiLine ? "table-common-scv-multiline" : ""]]),
        frame: "box",
        bordercolor: "lightgray",
        style: ee({ "table-layout": h(j) ? "fixed" : "auto" })
      }, [
        a("colgroup", null, [
          (i(!0), m(V, null, Q(se.value, (D, W) => (i(), m("col", {
            key: W,
            style: ee({ minWidth: D.columnMinWidth + "px", width: D.columnWidth + "px", maxWidth: D.columnMaxWidth + "px" })
          }, null, 4))), 128))
        ]),
        a("thead", Uo, [
          a("tr", null, [
            n.selectType === 3 ? (i(), m("th", Wo, [
              a("input", {
                type: "checkbox",
                onClick: Oe,
                checked: h(u).length == h(d).length && h(u).length > 0,
                disabled: h(d).length == 0
              }, null, 8, Po)
            ])) : E("", !0),
            (i(!0), m(V, null, Q(n.columns, (D, W) => (i(), m("th", {
              key: W,
              ref_for: !0,
              ref_key: "ref_tableHeader",
              ref: x,
              onClick: (z) => Ve(D.columnID),
              style: ee({ cursor: h(g) & D.dataType ? "default" : "pointer", overflow: "hidden" })
            }, [
              a("div", zo, [
                h(y) & D.dataType ? (i(), m("span", {
                  key: 1,
                  innerHTML: D.text
                }, null, 8, qo)) : (i(), m("span", Go, A(D.text), 1)),
                h(p) === D.columnID ? (i(), m(V, { key: 2 }, [
                  h(v) ? (i(), m("div", jo, w[0] || (w[0] = [
                    a("i", { class: "icon-arrow2top" }, null, -1)
                  ]))) : (i(), m("div", Yo, w[1] || (w[1] = [
                    a("i", { class: "icon-arrow2down" }, null, -1)
                  ])))
                ], 64)) : E("", !0),
                a("div", {
                  class: "resizer",
                  onMousedown: (z) => P(z, D.columnID, W)
                }, null, 40, Ko)
              ])
            ], 12, Fo))), 128)),
            h(j) ? (i(), m("th", Qo)) : (i(), m("th", Jo))
          ])
        ]),
        a("tbody", null, [
          (i(!0), m(V, null, Q(h(d), (D, W) => (i(), m("tr", {
            class: H([D < h(C).length ? h(C)[D] : ""]),
            key: W,
            onClick: [
              nt((z) => G(W), ["exact"]),
              nt((z) => Re(W), ["ctrl", "exact"]),
              nt((z) => ae(W), ["shift", "exact"])
            ]
          }, [
            n.selectType === 3 ? (i(), m("td", Xo, [
              a("input", {
                type: "checkbox",
                onClick: (z) => be(W),
                checked: h(u).includes(W)
              }, null, 8, es)
            ])) : E("", !0),
            (i(!0), m(V, null, Q(h(r)[D].cells, (z, ye) => (i(), m("td", {
              key: ye,
              class: H(z.className + qe(W)),
              style: ee(z.style)
            }, [
              z.includingHtml ? (i(), m("span", {
                key: 0,
                innerHTML: z.text,
                onClick: (re) => R(D, z.columnID, z.notifyClickEvent)
              }, null, 8, ts)) : (i(), m("span", {
                key: 1,
                onClick: (re) => R(D, z.columnID, z.notifyClickEvent)
              }, A(z.text), 9, ns))
            ], 6))), 128)),
            h(j) ? (i(), m("td", ls)) : (i(), m("td", os))
          ], 10, Zo))), 128))
        ])
      ], 6)
    ]));
  }
}), vr = /* @__PURE__ */ Z(as, [["__scopeId", "data-v-c8b9e6ce"]]), is = { class: "d-flex flex-wrap title-belt-table" }, rs = {
  class: "d-flex",
  style: { "min-height": "43px" }
}, cs = {
  key: 0,
  class: "d-flex",
  style: { height: "40px", "border-radius": "4px", "background-color": "#64CDFF" }
}, us = { class: "d-flex align-items-center" }, ds = { style: { "margin-left": "16px", "margin-right": "16px", "font-size": "14px", "font-weight": "700", color: "#fff" } }, ms = { class: "d-flex align-items-center" }, fs = { class: "dropdown-menu scv-dropdown-menu" }, ps = {
  key: 1,
  class: "title-belt-table-text"
}, hs = {
  class: "d-flex flex-row full-width flex-grow-1",
  style: { "padding-top": "4px", height: "43px" }
}, vs = { class: "dropdown-menu keep-open-on-click scv-dropdown-menu" }, ys = ["disabled"], gs = {
  key: 0,
  style: { "min-width": "16px" }
}, Cs = {
  key: 0,
  style: { margin: "0px 8px" }
}, bs = ["disabled"], _s = {
  key: 0,
  style: { "margin-left": "8px" }
}, Is = {
  key: 1,
  style: { margin: "0px 8px" }
}, xs = ["disabled"], ks = {
  key: 0,
  style: { "margin-left": "8px" }
}, ws = {
  key: 1,
  style: { margin: "0px 8px" }
}, Ts = ["disabled"], Ss = {
  key: 0,
  style: { "margin-left": "8px" }
}, Ns = {
  key: 1,
  style: { margin: "0px 8px" }
}, Ds = ["disabled"], Ms = {
  key: 4,
  class: "d-flex flex-row ms-auto align-items-start"
}, $s = {
  key: 0,
  style: { "margin-left": "8px" }
}, Es = ["disabled"], Bs = {
  key: 0,
  style: { "margin-left": "16px" }
}, Ls = { class: "dropdown-menu scv-dropdown-menu" }, Rs = ["value"], As = /* @__PURE__ */ F({
  __name: "ListTitleBar",
  props: {
    /*
     * タイトル
     */
    titleCaption: { type: String, default: "aaa" },
    /*
     * タイトルボタン
     */
    titleBotton_1: { type: String },
    /*
     * ボタン名
     */
    btnCaption_1: { type: String },
    btnCaption_2: { type: String },
    btnCaption_3: { type: String },
    btnCaption_4: { type: String },
    btnCaption_r1: { type: String },
    // 右寄り
    /*
     * ボタン説明テキスト(ボタンの前に表示されます。例：ADEプロファイル管理画面)
     */
    btnDescription_1: { type: String },
    btnDescription_2: { type: String },
    btnDescription_3: { type: String },
    btnDescription_4: { type: String },
    /*
     * ボタン説明テキストのスタイル
     */
    btnDescriptionStyle_1: { type: String },
    btnDescriptionStyle_2: { type: String },
    btnDescriptionStyle_3: { type: String },
    btnDescriptionStyle_4: { type: String },
    /*
     * 0(null) : 常にアクティブ
     * 1 : 単一選択時にのみアクティブ
     * 2 : 複数選択時にのみアクティブ
     * 3 : 単一又は複数選択時にのみアクティブ
     * 4 : リストにデータが1つ以上あるときのみアクティブ
     */
    btnActiveType_Title1: { type: Number, default: 0 },
    btnActiveType_1: { type: Number, default: 0 },
    btnActiveType_2: { type: Number, default: 0 },
    btnActiveType_3: { type: Number, default: 0 },
    btnActiveType_4: { type: Number, default: 0 },
    btnActiveType_r1: { type: Number, default: 0 },
    // 右寄り
    /*
     * ボタンのスタイル
     */
    additionalTitleClass_1: { type: Object, default: {} },
    additionalClass_1: { type: Object, default: {} },
    additionalClass_2: { type: Object, default: {} },
    additionalClass_3: { type: Object, default: {} },
    additionalClass_4: { type: Object, default: {} },
    additionalClass_r1: { type: Object, default: {} },
    // 右寄り(★ClassではなくStyle)
    additionalClassName_r1: { type: String, default: "btn-scv-white-small" },
    // 右寄りのクラス
    isBtndisabled_1: { type: Boolean, default: !1 },
    /* 強制的にボタン1をDisableにする*/
    isBtndisabled_2: { type: Boolean, default: !1 },
    /* 強制的にボタン2をDisableにする*/
    isBtndisabled_3: { type: Boolean, default: !1 },
    /* 強制的にボタン3をDisableにする*/
    /*
     * カウンター
     */
    rowCountArea: { type: Boolean, default: !1 },
    /* カウンターの有無 */
    rowCount: { type: Number, default: 0 },
    /* カウント数 */
    /*
     * その他
     */
    disabled: { type: Boolean, default: !1 },
    /* 強制的にボタンをDisableにする*/
    selectCount: { type: Number, default: 0 },
    /* 現在の選択数（ボタンのDisable判定に利用） */
    /*
     * 文字検索(非対応)
     */
    enableSearchText: { type: Boolean, default: !1 },
    /* 文字列検索バーの有無 */
    /*操作ボタン押下時のリスト: Array<DropdownItemBase> */
    menuItemList: { type: Object, default: {} },
    /*操作ボタンを使用するか */
    isUseMenuItemList: { type: Boolean, default: !1 },
    /*表示設定押下時のリスト: Array<DropdownItemBase> */
    selectmenuItemList: { type: Object, default: {} },
    /*表示設定ボタンを使用するか */
    isUseSelectMenuItemList: { type: Boolean, default: !1 },
    /*「三」押下時のリスト: Array<DropdownItemBase> */
    rightMenuItemList: { type: Object, default: {} },
    /*表示設定ボタンを使用するか */
    isUseRightMenuItemList: { type: Boolean, default: !1 }
  },
  emits: ["onBtnTitleClicked_1", "onBtnClicked_1", "onBtnClicked_2", "onBtnClicked_3", "onBtnClicked_4", "onBtnClicked_r1", "onClickMenuItem", "onChangeMenuItem", "onClickRightMenuItem"],
  setup(n, { emit: l }) {
    const e = n, t = l, s = () => {
      t("onBtnTitleClicked_1");
    }, o = () => {
      t("onBtnClicked_1");
    }, c = () => {
      t("onBtnClicked_2");
    }, r = () => {
      t("onBtnClicked_3");
    }, d = () => {
      t("onBtnClicked_4");
    }, u = () => {
      t("onBtnClicked_r1");
    }, C = (f) => {
      t("onClickMenuItem", f);
    }, p = (f) => {
      t("onChangeMenuItem", f);
    }, v = (f) => {
      t("onClickRightMenuItem", f);
    }, S = (f) => {
      switch (f) {
        case 1:
          if (e.selectCount == 1)
            return !1;
          break;
        case 2:
          if (2 <= e.selectCount)
            return !1;
          break;
        case 3:
          if (1 <= e.selectCount)
            return !1;
          break;
        case 4:
          if (1 <= e.rowCount)
            return !1;
          break;
        case 0:
        default:
          return !1;
      }
      return !0;
    };
    return (f, g) => (i(), m("div", is, [
      a("div", rs, [
        n.isUseMenuItemList === !0 && n.selectCount > 0 ? (i(), m("div", cs, [
          a("div", us, [
            a("span", ds, A(n.selectCount) + "件選択中", 1)
          ]),
          a("div", ms, [
            de(Ht, { style: { width: "88px", "margin-right": "4px" } }, {
              text: ze(() => g[0] || (g[0] = [
                fe(" 操作 ")
              ])),
              _: 1
            }),
            a("div", fs, [
              de(Ut, {
                models: n.menuItemList,
                onOnClickMenuItem: C
              }, null, 8, ["models"])
            ])
          ])
        ])) : (i(), m("span", ps, A(n.titleCaption), 1)),
        g[1] || (g[1] = a("div", { style: { "min-width": "12px" } }, null, -1))
      ]),
      a("div", hs, [
        Y(f.$slots, "label", {}, void 0, !0),
        n.isUseSelectMenuItemList ? (i(), m(V, { key: 0 }, [
          de(Ht, { style: { width: "119px", height: "32px" } }, {
            text: ze(() => g[2] || (g[2] = [
              fe(" 表示設定 ")
            ])),
            _: 1
          }),
          a("div", vs, [
            de(il, {
              models: n.selectmenuItemList,
              onOnChangeMenuItem: p
            }, null, 8, ["models"])
          ]),
          g[3] || (g[3] = a("div", { style: { "min-width": "16px" } }, null, -1))
        ], 64)) : E("", !0),
        n.titleBotton_1 ? (i(), m("button", {
          key: 1,
          type: "button",
          class: "btn-scv-white-small listBtnLayout",
          disabled: n.disabled || S(n.btnActiveType_Title1),
          onClick: s,
          style: ee(n.additionalTitleClass_1)
        }, A(n.titleBotton_1), 13, ys)) : E("", !0),
        n.btnCaption_1 || n.btnCaption_2 || n.btnCaption_3 ? (i(), m(V, { key: 2 }, [
          n.titleBotton_1 ? (i(), m("div", gs)) : E("", !0),
          n.btnCaption_1 ? (i(), m(V, { key: 1 }, [
            n.btnDescription_1 ? (i(), m("div", Cs, [
              a("span", {
                class: "title-belt-table-no-center-text",
                style: ee(n.btnDescriptionStyle_1)
              }, A(n.btnDescription_1), 5)
            ])) : E("", !0),
            a("button", {
              type: "button",
              class: "btn-scv-white-small listBtnLayout",
              disabled: n.disabled || S(n.btnActiveType_1) || n.isBtndisabled_1,
              onClick: o,
              style: ee(n.additionalClass_1)
            }, A(n.btnCaption_1), 13, bs)
          ], 64)) : E("", !0),
          n.btnCaption_2 ? (i(), m(V, { key: 2 }, [
            n.btnCaption_1 ? (i(), m("div", _s)) : E("", !0),
            n.btnDescription_2 ? (i(), m("div", Is, [
              a("span", {
                class: "title-belt-table-no-center-text",
                style: ee(n.btnDescriptionStyle_2)
              }, A(n.btnDescription_2), 5)
            ])) : E("", !0),
            a("button", {
              type: "button",
              class: "btn-scv-white-small listBtnLayout",
              disabled: n.disabled || S(n.btnActiveType_2) || n.isBtndisabled_2,
              onClick: c,
              style: ee(n.additionalClass_2)
            }, A(n.btnCaption_2), 13, xs)
          ], 64)) : E("", !0),
          n.btnCaption_3 ? (i(), m(V, { key: 3 }, [
            n.btnCaption_1 || n.btnCaption_2 ? (i(), m("div", ks)) : E("", !0),
            n.btnDescription_3 ? (i(), m("div", ws, [
              a("span", {
                class: "title-belt-table-no-center-text",
                style: ee(n.btnDescriptionStyle_3)
              }, A(n.btnDescription_3), 5)
            ])) : E("", !0),
            a("button", {
              type: "button",
              class: "btn-scv-white-small listBtnLayout",
              disabled: n.disabled || S(n.btnActiveType_3) || n.isBtndisabled_3,
              onClick: r,
              style: ee(n.additionalClass_3)
            }, A(n.btnCaption_3), 13, Ts)
          ], 64)) : E("", !0)
        ], 64)) : E("", !0),
        n.btnCaption_4 ? (i(), m(V, { key: 3 }, [
          n.btnCaption_1 || n.btnCaption_2 || n.btnCaption_3 ? (i(), m("div", Ss)) : E("", !0),
          n.btnDescription_4 ? (i(), m("div", Ns, [
            a("span", {
              class: "title-belt-table-no-center-text",
              style: ee(n.btnDescriptionStyle_4)
            }, A(n.btnDescription_4), 5)
          ])) : E("", !0),
          a("button", {
            type: "button",
            class: "btn-scv-white-small listBtnLayout",
            disabled: n.disabled || S(n.btnActiveType_4),
            onClick: d,
            style: ee(n.additionalClass_4)
          }, A(n.btnCaption_4), 13, Ds)
        ], 64)) : E("", !0),
        n.enableSearchText || n.btnCaption_r1 || n.rowCountArea || n.isUseRightMenuItemList ? (i(), m("div", Ms, [
          g[6] || (g[6] = a("div", { style: { "min-width": "24px" } }, null, -1)),
          n.btnCaption_r1 ? (i(), m(V, { key: 0 }, [
            n.enableSearchText ? (i(), m("div", $s)) : E("", !0),
            a("button", {
              type: "button",
              class: H(n.additionalClassName_r1),
              disabled: n.disabled || S(n.btnActiveType_r1),
              onClick: u,
              style: ee(n.additionalClass_r1)
            }, A(n.btnCaption_r1), 15, Es)
          ], 64)) : E("", !0),
          n.isUseRightMenuItemList ? (i(), m(V, { key: 1 }, [
            n.enableSearchText || n.btnCaption_r1 ? (i(), m("div", Bs)) : E("", !0),
            g[4] || (g[4] = a("button", {
              class: "btn-scv-bgcolor btn-icon",
              "data-bs-toggle": "dropdown"
            }, [
              a("div", { class: "d-flex align-items-center justify-content-center" }, [
                a("div", { class: "icon-font-deepblue" }, [
                  a("i", { class: "icon-menu" })
                ])
              ])
            ], -1)),
            a("div", Ls, [
              de(Ut, {
                models: n.rightMenuItemList,
                onOnClickMenuItem: v
              }, null, 8, ["models"])
            ])
          ], 64)) : E("", !0),
          n.rowCountArea ? (i(), m(V, { key: 2 }, [
            g[5] || (g[5] = a("div", { style: { width: "16px" } }, null, -1)),
            a("input", {
              type: "text",
              class: "input-text-scv ms-auto",
              style: { width: "64px", height: "32px" },
              value: n.rowCount,
              readonly: ""
            }, null, 8, Rs)
          ], 64)) : E("", !0)
        ])) : E("", !0)
      ])
    ]));
  }
}), yr = /* @__PURE__ */ Z(As, [["__scopeId", "data-v-f2924851"]]), Os = ["id"], Vs = /* @__PURE__ */ F({
  __name: "GlobalLoading",
  setup(n, { expose: l }) {
    const e = T("loading_global");
    Le(() => {
      s();
    });
    const t = () => {
      let o = document.getElementById(e.value);
      o != null && (o.style.display = "flex");
    }, s = () => {
      let o = document.getElementById(e.value);
      o != null && (o.style.display = "none");
    };
    return l({
      start: t,
      stop: s
    }), (o, c) => (i(), m("div", {
      id: e.value,
      class: "loading"
    }, c[0] || (c[0] = [
      hn('<div class="loader" data-v-be979695><div class="loader-one" data-v-be979695></div><div class="loader-two" data-v-be979695></div><div class="loader-three" data-v-be979695></div><div class="loader-four" data-v-be979695></div></div>', 1)
    ]), 8, Os));
  }
}), gr = /* @__PURE__ */ Z(Vs, [["__scopeId", "data-v-be979695"]]), Ae = class Ae {
  /*
   * ローディング開始
   */
  static Start() {
    Ae.loadingRef != null && (Ae.loadingcount++, Ae.loadingRef.start());
  }
  /*
   * ローディング終了
   */
  static Stop() {
    Ae.loadingRef != null && (Ae.loadingcount--, !(0 < Ae.loadingcount) && Ae.loadingRef.stop());
  }
  /* 
   * ローディング画面の参照を登録
   * ★App.vue意外から呼び出さないこと★
   */
  static SetLoading(l) {
    Ae.loadingRef = l;
  }
};
// 参照カウンタ
N(Ae, "loadingcount", 0), /*
 * ローディング画面のrefs
 */
N(Ae, "loadingRef");
let Ft = Ae;
const Hs = ["id"], Us = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scv-cmn",
  role: "document"
}, Ws = { class: "modal-content modal-content-scv-cmn" }, Ps = { class: "modal-header modal-header-scv-cmn" }, Fs = { class: "modal-header-text-box-scv-cmn" }, zs = { class: "modal-header-text-scv-cmn" }, Gs = ["id"], qs = { class: "modal-footer modal-footer-scv-cmn" }, js = { class: "d-flex justify-content-center" }, Ys = /* @__PURE__ */ F({
  __name: "TemplateModal",
  props: {
    modalId: { type: String, required: !0 },
    // モーダルのID
    autoClose: { type: Boolean, default: !0 },
    // 閉じるや×ボタンでモーダルを自動で閉じるかどうか
    hide_btn_ok: { type: Boolean, default: !1 },
    // OKボタンを非表示
    showScroll: { type: Boolean, default: !1 },
    // スクロールバーを表示するかどうか
    isFooterPositionCenter: { type: Boolean, default: !0 }
    // ボタン中央寄せするかどうか
  },
  emits: ["onOk", "onCancel"],
  setup(n, { expose: l, emit: e }) {
    const t = n, s = e;
    let o;
    Le(async () => {
      const C = document.getElementById(t.modalId);
      C != null && (C.addEventListener("shown.bs.modal", () => {
        C.focus();
      }), o = new In(C, {
        backdrop: "static",
        /* 背景をクリックしても閉じないように */
        focus: !0,
        keyboard: !1
        /* エスケープキーで閉じないように */
      }));
    });
    const c = () => {
      s("onOk");
    }, r = () => {
      s("onCancel"), t.autoClose && u();
    }, d = () => {
      o != null && o.show();
    }, u = () => {
      o != null && o.hide();
    };
    return l({
      show: d,
      hide: u
    }), (C, p) => (i(), m("div", {
      class: "modal fade",
      id: n.modalId,
      tabindex: "-1",
      role: "dialog",
      "aria-labelledby": "modalFileUpload",
      "aria-hidden": "true",
      "data-bs-backdrop": "static",
      "data-bs-keyboard": "false"
    }, [
      a("div", Us, [
        a("div", Ws, [
          a("div", Ps, [
            a("div", Fs, [
              a("div", zs, [
                Y(C.$slots, "title", {}, () => [
                  p[0] || (p[0] = fe("タイトル"))
                ], !0)
              ])
            ]),
            a("a", {
              class: "btn-scv-cmn-close",
              onClick: r
            }, p[1] || (p[1] = [
              a("div", { class: "icon-font-slategray" }, [
                a("i", { class: "icon-delete" })
              ], -1)
            ]))
          ]),
          a("div", {
            id: t.modalId + "scroll",
            class: H(["modal-body modal-body-scv-cmn", { scroll: t.showScroll }])
          }, [
            Y(C.$slots, "body", {}, () => [
              p[2] || (p[2] = fe(" ボディ部 "))
            ], !0)
          ], 10, Gs),
          a("div", qs, [
            a("div", js, [
              a("div", {
                class: H(["zero-font", [t.isFooterPositionCenter ? "" : "templateModalExFooter"]])
              }, [
                Y(C.$slots, "footer", {}, () => [
                  n.hide_btn_ok ? E("", !0) : (i(), m("button", {
                    key: 0,
                    type: "button",
                    class: "btn-scv-blue",
                    style: { "margin-right": "40px" },
                    onClick: c
                  }, [
                    Y(C.$slots, "ok_text", {}, () => [
                      p[3] || (p[3] = fe(" OK "))
                    ], !0)
                  ])),
                  a("button", {
                    type: "button",
                    class: "btn-scv-white",
                    onClick: r
                  }, [
                    Y(C.$slots, "cancel_text", {}, () => [
                      p[4] || (p[4] = fe(" キャンセル "))
                    ], !0)
                  ])
                ], !0)
              ], 2)
            ])
          ])
        ])
      ])
    ], 8, Hs));
  }
}), Ks = /* @__PURE__ */ Z(Ys, [["__scopeId", "data-v-bf2aaf5b"]]), Qs = {
  key: 0,
  class: "d-flex flex-row"
}, Js = ["src"], Zs = ["innerHTML"], Xs = {
  key: 1,
  class: "d-flex flex-row"
}, ea = ["src"], ta = ["innerHTML"], na = {
  key: 2,
  class: "d-flex flex-row align-items-center"
}, la = ["src"], oa = ["innerHTML"], Cr = /* @__PURE__ */ F({
  __name: "MessageBox",
  props: {
    info_icon: { type: String, default: "" },
    // 情報アイコンのパス
    alert_icon: { type: String, default: "" },
    // 警告アイコンのパス
    error_icon: { type: String, default: "" },
    // エラーアイコンのパス
    question_icon: { type: String, default: "" }
    // 確認アイコンのパス
  },
  emits: ["onOk", "onCancel"],
  setup(n, { expose: l, emit: e }) {
    const t = n, s = e;
    Le(async () => {
      const G = document.getElementById("modal_message_box");
      G != null && (G.addEventListener("shown.bs.modal", () => {
        k ? Ge("#btn_cancel_modal_message_box").focus() : Ge("#btnOk_modal_message_box").focus(), J = !0;
      }), G.addEventListener("hidden.bs.modal", () => {
        C.value = Ne.Information, v.value = "", S.value = !1, f.value = !1, y = null, g.value = "OK", p.value = "", L.value = "", x = null, k = !1, J = !1, U.value = !1, q.value = !0;
      }));
    });
    const o = (G) => {
      f.value = !G;
    }, c = (G) => {
      k = G;
    }, r = () => J, d = (G, Re, ae, Oe, Ve = void 0, be = void 0, R = void 0, P, le) => {
      let te = !1;
      0 < v.value.length && (te = !0), v.value = G, C.value = Re, y = ae, Ve == null || Ve == "" ? p.value = "" : p.value = Ve, me(C.value) ? (be == null || be == "" ? g.value = "はい" : g.value = be, R == null || R == "" ? L.value = "いいえ" : L.value = R, x = Oe) : be == null || be == "" ? g.value = "OK" : g.value = be, U.value = P, q.value = le, te || j.value.show();
    }, u = () => {
      j.value.hide();
    };
    l({
      ShowIcon: o,
      Show: d,
      Hide: u,
      SetCancelFocus: c,
      IsShown: r
    });
    const C = T(Ne.Information), p = T(""), v = T(""), S = T(!1), f = T(!1), g = T("");
    let y = null, k = !1, x = null;
    const L = T(""), U = T(!1), q = T(!0);
    let J = !1;
    const j = T(), ne = () => {
      q.value && u(), s("onOk", y);
    }, ce = () => {
      me(C.value) ? (u(), s("onCancel", x)) : s("onOk", y);
    }, he = (G) => p.value != "" ? p.value : G === Ne.Error ? "エラー" : G === Ne.Warning ? "警告" : G === Ne.Question ? "確認" : "情報", Ce = (G) => 0 <= G.indexOf("<br"), se = (G) => G === Ne.Error ? t.error_icon : G === Ne.Warning ? t.alert_icon : G === Ne.Question ? t.question_icon : t.info_icon, me = (G) => G === Ne.Question;
    return (G, Re) => (i(), pe(Ks, {
      modalId: "modal_message_box",
      onOnCancel: ce,
      autoClose: q.value,
      ref_key: "ref_TemplateModal",
      ref: j
    }, {
      title: ze(() => [
        fe(A(he(C.value)), 1)
      ]),
      body: ze(() => [
        Ce(v.value) === !0 && S.value ? (i(), m("div", Qs, [
          De(a("img", {
            src: se(C.value),
            height: "24",
            style: { "margin-right": "8px" }
          }, null, 8, Js), [
            [Nt, !f.value]
          ]),
          a("span", {
            innerHTML: v.value,
            style: { "margin-top": "4px", "overflow-y": "auto", "min-height": "50px", "max-height": "500px", "word-break": "break-all" }
          }, null, 8, Zs)
        ])) : Ce(v.value) === !0 ? (i(), m("div", Xs, [
          De(a("img", {
            src: se(C.value),
            height: "24",
            style: { "margin-right": "8px" }
          }, null, 8, ea), [
            [Nt, !f.value]
          ]),
          a("span", {
            innerHTML: v.value,
            style: { "margin-top": "4px" }
          }, null, 8, ta)
        ])) : (i(), m("div", na, [
          De(a("img", {
            src: se(C.value),
            height: "24",
            style: { "margin-right": "8px" }
          }, null, 8, la), [
            [Nt, !f.value]
          ]),
          a("span", { innerHTML: v.value }, null, 8, oa)
        ]))
      ]),
      footer: ze(() => [
        me(C.value) ? (i(), m(V, { key: 1 }, [
          a("button", {
            id: "btnOk_modal_message_box",
            type: "button",
            class: H([U.value ? "btn-scv-white" : "btn-scv-blue"]),
            style: { "margin-right": "40px" },
            onClick: ne
          }, A(g.value), 3),
          a("button", {
            id: "btn_cancel_modal_message_box",
            type: "button",
            class: "btn-scv-white",
            onClick: ce
          }, A(L.value), 1)
        ], 64)) : (i(), m("button", {
          key: 0,
          id: "btnOk_modal_message_box",
          type: "button",
          class: H([U.value ? "btn-scv-white" : "btn-scv-blue"]),
          onClick: ne
        }, A(g.value), 3))
      ]),
      _: 1
    }, 8, ["autoClose"]));
  }
});
function Zt(n, l) {
  Ee(l, () => {
    e(l.value);
  }), Le(() => {
    e(l.value);
  });
  function e(s) {
    s ? At.showModal(n) : At.hideModal(n);
  }
  function t() {
    l.value = !1;
  }
  return {
    hideModal: t
  };
}
const sa = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20240%20240'%3e%3cg%20id='a1908c24-145e-408e-856f-0d237994df40'%20data-name='レイヤー%205'%3e%3ccircle%20cx='120'%20cy='120'%20r='100'%20fill='%23c73e38'/%3e%3cpath%20d='M133.54858,120.00586l33.64551-33.65039A9.53053,9.53053,0,0,0,170,79.6001a9.67191,9.67191,0,0,0-2.80591-6.79395,9.58136,9.58136,0,0,0-13.5498,0L120,106.45508,86.35571,72.80615a9.581,9.581,0,0,0-13.5498,13.54932l33.64551,33.65039L72.80591,153.65625a9.581,9.581,0,0,0,13.5498,13.54932L120,133.55615l33.64429,33.64942a9.581,9.581,0,0,0,13.5498-13.54932Z'%20fill='%23fff'/%3e%3c/g%3e%3c/svg%3e", aa = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20240%20240'%3e%3cg%20id='aaa9a38c-f573-4bce-9352-08642897a534'%20data-name='240x240'%3e%3cpath%20d='M120,20A100,100,0,1,0,220,120,100,100,0,0,0,120,20Z'%20fill='%231464B9'/%3e%3c/g%3e%3cg%20id='ff48341d-61fa-4f4d-959e-cd143a7c7c13'%20data-name='レイヤー%205'%3e%3cpath%20d='M132.5,177.41167a12.50031,12.50031,0,1,1-25,0,12.50031,12.50031,0,0,1,25,0Z'%20fill='%23fff'/%3e%3cpath%20d='M120,152a9.57967,9.57967,0,0,1-10-10v-3c0-6.77173.95947-16.64178,10.17432-24.52118,1.88672-1.61334,3.8081-3.17175,5.666-4.67889C136.42773,101.212,144.167,97.48175,144.167,88.28418,144.167,79.83075,141.19238,70,120,70c-8.55859,0-25,4-25,20,0,6.41663-4.24707,10.00006-10,10.00006s-10-4.6637-10-10.41669C75,65.90735,93.83154,50,120,50c36.16016,0,45,21.73151,45,38.28418,0,17.71582-14.99268,24.4256-26.03564,33.38275-1.83545,1.489-2.32076,1.852-3.96436,3.33307-2.8741,2.58993-5,7-5,14v3A9.57967,9.57967,0,0,1,120,152Z'%20fill='%23fff'/%3e%3c/g%3e%3c/svg%3e", ia = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20240%20240'%3e%3cg%20id='b5278ebe-7d54-48f0-b5e3-60bac60958dc'%20data-name='レイヤー%205'%3e%3cpath%20d='M217.5,177.5,138.69654,41.17667a21.22945,21.22945,0,0,0-37.4125.02916L22.5,177.5a19.67288,19.67288,0,0,0-2.5,10A22.40645,22.40645,0,0,0,42.5,210h155A22.40645,22.40645,0,0,0,220,187.5,19.70264,19.70264,0,0,0,217.5,177.5Z'%20fill='%23fabe50'/%3e%3ccircle%20cx='120'%20cy='177.5'%20r='12.5'%20fill='%23493712'/%3e%3cpath%20d='M128.58154,143.77917C128.21071,147.295,124.46821,150,120.00238,150c-4.47167,0-8.21417-2.705-8.58167-6.22083,0,0-3.92071-62.77917-3.92071-68.94584C107.5,67,111.46667,60,120.00238,60,128.53571,60,132.5,67,132.5,74.83333,132.5,81,128.58154,143.77917,128.58154,143.77917Z'%20fill='%23493712'/%3e%3c/g%3e%3c/svg%3e", ra = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20240%20240'%3e%3cg%20id='e55d3ae3-6a81-4989-920b-aa9ca8f4aa9b'%20data-name='240x240'%3e%3cpath%20d='M120,20A100,100,0,1,0,220,120,100,100,0,0,0,120,20Z'%20fill='%231464B9'/%3e%3c/g%3e%3cg%20id='b43da061-7bcf-45ee-a375-515d02cfa0ff'%20data-name='レイヤー%205'%3e%3ccircle%20cx='119.5'%20cy='62.5'%20r='12.5'%20fill='%23fff'/%3e%3crect%20x='107'%20y='90'%20width='25'%20height='100'%20rx='12.49999'%20fill='%23fff'/%3e%3c/g%3e%3c/svg%3e", ca = ["id"], ua = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scv-cmn",
  role: "document"
}, da = { class: "modal-content modal-message-content-scv-cmn new-size" }, ma = { class: "modal-header modal-header-scv-cmn" }, fa = { class: "modal-header-text-box-scv-cmn" }, pa = { class: "modal-header-text-scv-cmn" }, ha = { class: "modal-body modal-body-scv-cmn" }, va = ["src"], ya = ["innerHTML"], ga = { class: "modal-footer modal-footer-scv-cmn" }, Ca = ["id", "onClick"], ba = /* @__PURE__ */ F({
  __name: "MessageBoxEx",
  props: {
    caption: { default: "" },
    flags: { default: K.MB_NO_BUTTON },
    message: { default: "" },
    show: { type: Boolean },
    uniqueButtonCaptions: { default: void 0 }
  },
  emits: ["update:show", "close"],
  setup(n, { emit: l }) {
    Lt((f) => ({
      "5b9a5fc9": h(S)
    }));
    const e = n, t = l, s = $(() => `messageBoxEx${rt.NewID()}`), o = vn("$show", T(null)), { hideModal: c } = Zt(s.value, $({
      get: () => o.value ?? e.show,
      set: (f) => t("update:show", f)
    })), r = $(() => {
      if (e.caption)
        return e.caption;
      switch (e.flags & 240) {
        case K.MB_ICONERROR:
          return "エラー";
        case K.MB_ICONQUESTION:
          return "確認";
        case K.MB_ICONWARNING:
          return "警告";
        case K.MB_ICONINFORMATION:
          return "情報";
        default:
          return "";
      }
    }), d = [
      // [中止]
      {
        caption: "中止",
        handler: () => t("close", Te.IDABORT),
        condition: (f) => K.MB_ABORTRETRYIGNORE === f
      },
      // [はい]
      {
        caption: "はい",
        handler: () => t("close", Te.IDYES),
        condition: (f) => K.MB_YESNOCANCEL === f || K.MB_YESNO === f,
        styleClass: "btn-scv-blue"
      },
      // [いいえ]
      {
        caption: "いいえ",
        handler: () => t("close", Te.IDNO),
        condition: (f) => K.MB_YESNOCANCEL === f || K.MB_YESNO === f
      },
      // [リトライ]
      {
        caption: "リトライ",
        handler: () => t("close", Te.IDRETRY),
        condition: (f) => K.MB_RETRYCANCEL === f || K.MB_ABORTRETRYIGNORE === f,
        styleClass: "btn-scv-blue"
      },
      // [OK]
      {
        caption: "OK",
        handler: () => t("close", Te.IDOK),
        condition: (f) => K.MB_OK === f || K.MB_OKCANCEL === f,
        styleClass: "btn-scv-blue"
      },
      // [キャンセル]
      {
        caption: "キャンセル",
        handler: () => t("close", Te.IDCANCEL),
        condition: (f) => K.MB_OKCANCEL === f || K.MB_YESNOCANCEL === f || K.MB_RETRYCANCEL === f || K.MB_CANCELTRYCONTINUE === f
      },
      // [再実行]
      {
        caption: "再実行",
        handler: () => t("close", Te.IDTRYAGAIN),
        condition: (f) => K.MB_CANCELTRYCONTINUE === f,
        styleClass: "btn-scv-blue"
      },
      // [続行]
      {
        caption: "続行",
        handler: () => t("close", Te.IDCONTINUE),
        condition: (f) => K.MB_CANCELTRYCONTINUE === f,
        styleClass: "btn-scv-blue"
      },
      // [無視]
      {
        caption: "無視",
        handler: () => t("close", Te.IDIGNORE),
        condition: (f) => K.MB_ABORTRETRYIGNORE === f
      },
      // [固有ボタン1]
      {
        caption: e.uniqueButtonCaptions ? e.uniqueButtonCaptions[0] : "",
        handler: () => t("close", Te.IDUNIQUE1),
        condition: (f) => e.uniqueButtonCaptions ? K.MB_UNIQUE === f && e.uniqueButtonCaptions.length >= 1 : !1,
        styleClass: "btn-scv-blue"
      },
      // [固有ボタン2]
      {
        caption: e.uniqueButtonCaptions ? e.uniqueButtonCaptions[1] : "",
        handler: () => t("close", Te.IDUNIQUE2),
        condition: (f) => e.uniqueButtonCaptions ? K.MB_UNIQUE === f && e.uniqueButtonCaptions.length >= 2 : !1
      },
      // [固有ボタン3]
      {
        caption: e.uniqueButtonCaptions ? e.uniqueButtonCaptions[2] : "",
        handler: () => t("close", Te.IDUNIQUE3),
        condition: (f) => e.uniqueButtonCaptions ? K.MB_UNIQUE === f && e.uniqueButtonCaptions.length >= 3 : !1
      }
    ], u = $(() => d.filter((g) => g.condition(e.flags & 15))), C = $(() => (f) => f.styleClass ? f.styleClass : "btn-scv-white"), p = $(() => {
      switch (e.flags & 240) {
        case K.MB_ICONERROR:
        case K.MB_ICONQUESTION:
        case K.MB_ICONWARNING:
        case K.MB_ICONINFORMATION:
          return !0;
        default:
          return !1;
      }
    }), v = $(() => {
      switch (e.flags & 240) {
        case K.MB_ICONERROR:
          return sa;
        case K.MB_ICONQUESTION:
          return aa;
        case K.MB_ICONWARNING:
          return ia;
        case K.MB_ICONINFORMATION:
          return ra;
        default:
          return "";
      }
    }), S = $(() => !e.message || 1 < e.message.replace(/\r?\n/g, "<br />").split("<br />").length ? "start" : "center");
    return Le(() => {
      const f = e.flags >> 8 & 15;
      if (f != K.MB_NO_DEFBUTTON) {
        const g = document.getElementById(s.value), y = g == null ? void 0 : g.querySelector("#messageBoxEXbutton" + f);
        g == null || g.addEventListener("shown.bs.modal", () => {
          y == null || y.focus();
        });
      }
    }), (f, g) => (i(), m("div", {
      class: "modal fade",
      id: h(s),
      tabindex: "-1",
      role: "dialog",
      "aria-labelledby": "modalFileUpload",
      "aria-hidden": "true",
      "data-bs-backdrop": "static",
      "data-bs-keyboard": "false"
    }, [
      a("div", ua, [
        a("div", da, [
          a("div", ma, [
            a("div", fa, [
              a("div", pa, [
                Y(f.$slots, "title", {}, () => [
                  fe(A(h(r)), 1)
                ], !0)
              ])
            ]),
            a("a", {
              class: "btn-scv-cmn-close",
              onClick: g[0] || (g[0] = (y) => {
                h(c)(), t("close", h(Te).IDCANCEL);
              })
            }, g[1] || (g[1] = [
              a("div", { class: "icon-font-slategray" }, [
                a("i", { class: "icon-delete" })
              ], -1)
            ]))
          ]),
          a("div", ha, [
            a("div", {
              class: H(f.$style.body)
            }, [
              h(p) ? (i(), m("img", {
                key: 0,
                src: h(v),
                height: "24"
              }, null, 8, va)) : E("", !0),
              a("div", null, [
                Y(f.$slots, "default", {}, () => [
                  a("div", {
                    innerHTML: e.message
                  }, null, 8, ya)
                ], !0)
              ])
            ], 2)
          ]),
          a("div", ga, [
            Y(f.$slots, "footer", {}, () => [
              a("div", {
                class: H(f.$style.footer)
              }, [
                (i(!0), m(V, null, Q(h(u), (y, k) => (i(), m("button", {
                  key: k,
                  id: "messageBoxEXbutton" + (k + 1),
                  class: H(h(C)(y)),
                  onClick: (x) => {
                    h(c)(), y.handler();
                  }
                }, A(y.caption), 11, Ca))), 128))
              ], 2)
            ], !0)
          ])
        ])
      ])
    ], 8, ca));
  }
}), _a = "_body_1c8kf_5", Ia = "_footer_1c8kf_45", xa = {
  body: _a,
  footer: Ia
}, ka = {
  $style: xa
}, br = /* @__PURE__ */ Z(ba, [["__cssModules", ka], ["__scopeId", "data-v-1640fa82"]]), wa = ["id"], Ta = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scv-cmn",
  role: "document"
}, Sa = { class: "modal-content modal-content-scv-cmn" }, Na = { class: "modal-header modal-header-scv-cmn" }, Da = { class: "modal-header-text-box-scv-cmn" }, Ma = { class: "modal-header-text-scv-cmn" }, $a = {
  key: 0,
  class: "modal-footer modal-footer-scv-cmn"
}, Ea = { class: "d-flex justify-content-center" }, Ba = { class: "zero-font templateModalExFooter" }, La = /* @__PURE__ */ F({
  __name: "TemplateModalEx",
  props: {
    show: { type: Boolean },
    showFooter: { type: Boolean, default: !0 }
  },
  emits: ["update:show", "close", "ok", "shown", "hidden"],
  setup(n, { emit: l }) {
    const e = n, t = l, s = T(rt.NewID()), { hideModal: o } = Zt(s.value, $({
      get: () => e.show,
      set: (d) => t("update:show", d)
    }));
    Le(async () => {
      const d = document.getElementById(s.value);
      d != null && (d.addEventListener("shown.bs.modal", () => {
        d.focus(), t("shown");
      }), d.addEventListener("hidden.bs.modal", () => {
        t("hidden");
      }));
    });
    function c() {
      t("close"), o();
    }
    function r() {
      t("ok"), o();
    }
    return (d, u) => (i(), m("div", {
      class: "modal fade",
      id: h(s),
      tabindex: "-1",
      role: "dialog",
      "aria-labelledby": "modalFileUpload",
      "aria-hidden": "true",
      "data-bs-backdrop": "static",
      "data-bs-keyboard": "false"
    }, [
      a("div", Ta, [
        a("div", Sa, [
          a("div", Na, [
            a("div", Da, [
              a("div", Ma, [
                Y(d.$slots, "title", {}, () => [
                  u[0] || (u[0] = fe("タイトル"))
                ], !0)
              ])
            ]),
            a("a", {
              class: "btn-scv-cmn-close",
              onClick: c
            }, u[1] || (u[1] = [
              a("div", { class: "icon-font-slategray" }, [
                a("i", { class: "icon-delete" })
              ], -1)
            ]))
          ]),
          a("div", {
            class: H(["modal-body modal-body-scv-cmn", { hideFooter: !e.showFooter }])
          }, [
            Y(d.$slots, "body", {}, () => [
              u[2] || (u[2] = fe(" ボディ部 "))
            ], !0)
          ], 2),
          e.showFooter ? (i(), m("div", $a, [
            a("div", Ea, [
              a("div", Ba, [
                Y(d.$slots, "footer", {}, () => [
                  a("button", {
                    type: "button",
                    class: "btn-scv-blue",
                    style: { "margin-right": "40px" },
                    onClick: r
                  }, [
                    Y(d.$slots, "labelOk", {}, () => [
                      u[3] || (u[3] = fe(" OK "))
                    ], !0)
                  ]),
                  a("button", {
                    type: "button",
                    class: "btn-scv-white",
                    onClick: c
                  }, [
                    Y(d.$slots, "labelCancel", {}, () => [
                      u[4] || (u[4] = fe(" キャンセル "))
                    ], !0)
                  ])
                ], !0)
              ])
            ])
          ])) : E("", !0)
        ])
      ])
    ], 8, wa));
  }
}), _r = /* @__PURE__ */ Z(La, [["__scopeId", "data-v-41a9d6a8"]]), Ra = { class: "d-flex align-items-center radio-height" }, Aa = ["id", "name", "value", "checked", "disabled"], Oa = ["id", "for"], Va = /* @__PURE__ */ F({
  __name: "Radio",
  props: {
    name: { default: "" },
    modelValue: {},
    innerValue: {},
    disabled: { type: Boolean, default: !1 },
    label: { default: "" },
    labelWidth: { default: void 0 },
    marginLeft: {}
  },
  emits: ["update:modelValue"],
  setup(n, { emit: l }) {
    const e = n, t = l, s = T(rt.NewID()), o = $({
      get: () => e.modelValue,
      set: (r) => {
        t("update:modelValue", r);
      }
    });
    Le(() => {
      c();
    }), Ee(() => e.label, (r) => {
      c();
    }, { immediate: !0 });
    function c() {
      const r = document.getElementById(s.value + "label");
      r && (r.innerText = e.label);
    }
    return (r, d) => (i(), m("div", Ra, [
      De(a("input", {
        id: h(s),
        name: e.name,
        type: "radio",
        "onUpdate:modelValue": d[0] || (d[0] = (u) => tt(o) ? o.value = u : null),
        value: e.innerValue,
        checked: e.innerValue === e.modelValue,
        style: ee({ "margin-left": e.marginLeft + "px" }),
        disabled: e.disabled
      }, null, 12, Aa), [
        [yn, h(o)]
      ]),
      Y(r.$slots, "default", {}, void 0, !0),
      a("div", {
        style: ee({
          width: e.labelWidth != null ? typeof e.labelWidth == "number" ? e.labelWidth + "px" : e.labelWidth : ""
        })
      }, [
        a("label", {
          id: h(s) + "label",
          for: h(s),
          class: "margin-l"
        }, null, 8, Oa)
      ], 4)
    ]));
  }
}), Ir = /* @__PURE__ */ Z(Va, [["__scopeId", "data-v-040e14d7"]]);
class zt {
  /// <summary>
  /// コンストラクタ
  /// </summary>
  constructor(l = 0, e = "", t = 0) {
    /// <summary>
    /// 検索ID
    /// </summary>
    N(this, "searchID", 0);
    /// <summary>
    /// 名称
    /// </summary>
    N(this, "strName", "");
    /// <summary>
    /// 選択タイプ
    /// </summary>
    N(this, "type", 0);
    this.searchID = l, this.strName = e, this.type = t;
  }
}
var Ke = /* @__PURE__ */ ((n) => (n[n.Text = 0] = "Text", n[n.Size = 1] = "Size", n[n.DateTimeRange = 2] = "DateTimeRange", n))(Ke || {});
class wt {
  constructor() {
    // 一意となるID
    N(this, "searchID", 0);
    // 検索の種類
    N(this, "searchType", Ke.Text);
    // ======================================
    // テキストデータ
    // ======================================
    // すべてを含む
    N(this, "strAndCondition", "");
    // いずれか含み
    N(this, "strOrCondition", "");
    // 含まない
    N(this, "strNotCondition", "");
    // ======================================
    // 数値データ
    // ======================================
    // 開始（nullは未入力）
    N(this, "num1", null);
    // 終了（nullは未入力）
    N(this, "num2", null);
    // ======================================
    // 日付データ
    // ======================================
    // 開始（nullは未入力） ※JSTで入れる想定。Webサーバーにアップロードしたときに勝手にUTCに変わる
    N(this, "dateTime1", null);
    // 終了（nullは未入力） ※JSTで入れる想定。Webサーバーにアップロードしたときに勝手にUTCに変わる
    N(this, "dateTime2", null);
  }
}
const Ha = { class: "d-flex flex-row align-items-center" }, Dt = 100, Ua = /* @__PURE__ */ F({
  __name: "SearchKeywordTypeText",
  props: {
    searchID: { type: Number, required: !0 }
    // 検索のID
  },
  setup(n, { expose: l }) {
    const e = n, t = T(new wt()), s = () => t.value.strAndCondition.trim().length != 0 || t.value.strOrCondition.trim().length != 0 || t.value.strNotCondition.trim().length != 0;
    return l({
      getData: () => s() ? (t.value.searchType = Ke.Text, t.value.searchID = e.searchID, t.value) : null,
      clearData: () => {
        t.value.strAndCondition = "", t.value.strOrCondition = "", t.value.strNotCondition = "";
      }
    }), (r, d) => (i(), m("div", Ha, [
      de(lt, {
        modelValue: t.value.strAndCondition,
        "onUpdate:modelValue": d[0] || (d[0] = (u) => t.value.strAndCondition = u),
        class: "input-text-scv input-text-scv-search-keyword-text",
        convertType: "text",
        placeholder: "文字列",
        maxlength: Dt
      }, null, 8, ["modelValue"]),
      d[3] || (d[3] = a("span", {
        class: "search-keyword-text-text",
        style: { "min-width": "84px" }
      }, "をすべて含み", -1)),
      de(lt, {
        modelValue: t.value.strOrCondition,
        "onUpdate:modelValue": d[1] || (d[1] = (u) => t.value.strOrCondition = u),
        class: "input-text-scv input-text-scv-search-keyword-text",
        convertType: "text",
        placeholder: "文字列",
        maxlength: Dt
      }, null, 8, ["modelValue"]),
      d[4] || (d[4] = a("span", {
        class: "search-keyword-text-text",
        style: { "min-width": "98px" }
      }, "をいずれか含み", -1)),
      de(lt, {
        modelValue: t.value.strNotCondition,
        "onUpdate:modelValue": d[2] || (d[2] = (u) => t.value.strNotCondition = u),
        class: "input-text-scv input-text-scv-search-keyword-text",
        convertType: "text",
        placeholder: "文字列",
        maxlength: Dt
      }, null, 8, ["modelValue"]),
      d[5] || (d[5] = a("span", {
        class: "search-keyword-text-text",
        style: { "min-width": "70px" }
      }, "を含まない", -1))
    ]));
  }
}), Wa = /* @__PURE__ */ Z(Ua, [["__scopeId", "data-v-52c79c48"]]), Pa = { class: "d-flex flex-row align-items-center" }, Fa = { class: "select-icon" }, za = ["value"], Ga = { class: "select-icon" }, qa = ["value"], ja = /* @__PURE__ */ F({
  __name: "SearchKeywordTypeSize",
  props: {
    searchID: { type: Number, required: !0 }
    // 検索のID
  },
  setup(n, { expose: l }) {
    const e = n, t = T(""), s = T(1024), o = T(""), c = T(1024), r = [
      { text: "Bytes", mul: 1 },
      { text: "KB", mul: 1024 },
      { text: "MB", mul: 1024 * 1024 },
      { text: "GB", mul: 1024 * 1024 * 1024 }
    ];
    return l({
      getData: () => {
        const u = t.value.trim(), C = o.value.trim();
        if (u == "" && C == "")
          return null;
        const p = new wt();
        if (p.searchID = e.searchID, p.searchType = Ke.Size, u != "") {
          const v = parseInt(u);
          isNaN(v) || (p.num1 = v * s.value);
        }
        if (C != "") {
          const v = parseInt(C);
          isNaN(v) || (p.num2 = v * c.value);
        }
        return p;
      }
    }), (u, C) => (i(), m("div", Pa, [
      de(lt, {
        modelValue: t.value,
        "onUpdate:modelValue": C[0] || (C[0] = (p) => t.value = p),
        class: "input-text-scv input-text-scv-search-keyword-size",
        convertType: "half-number",
        min: "0",
        max: "9999"
      }, null, 8, ["modelValue"]),
      a("div", Fa, [
        De(a("select", {
          class: "input-text-scv search-keyword-size-select-units",
          "onUpdate:modelValue": C[1] || (C[1] = (p) => s.value = p)
        }, [
          (i(), m(V, null, Q(r, (p) => a("option", {
            key: p.text,
            value: p.mul
          }, A(p.text), 9, za)), 64))
        ], 512), [
          [ht, s.value]
        ])
      ]),
      C[4] || (C[4] = a("span", { class: "search-keyword-size-center-text" }, "～", -1)),
      de(lt, {
        modelValue: o.value,
        "onUpdate:modelValue": C[2] || (C[2] = (p) => o.value = p),
        class: "input-text-scv input-text-scv-search-keyword-size",
        convertType: "half-number",
        min: "0",
        max: "9999"
      }, null, 8, ["modelValue"]),
      a("div", Ga, [
        De(a("select", {
          class: "input-text-scv search-keyword-size-select-units",
          "onUpdate:modelValue": C[3] || (C[3] = (p) => c.value = p)
        }, [
          (i(), m(V, null, Q(r, (p) => a("option", {
            key: p.text,
            value: p.mul
          }, A(p.text), 9, qa)), 64))
        ], 512), [
          [ht, c.value]
        ])
      ])
    ]));
  }
}), Ya = /* @__PURE__ */ Z(ja, [["__scopeId", "data-v-a7da5350"]]), Ka = { class: "d-flex flex-row align-items-center" }, Qa = /* @__PURE__ */ F({
  __name: "SearchKeywordTypeDateTimeRange",
  props: {
    searchID: { type: Number, required: !0 }
    // 検索のID
  },
  setup(n, { expose: l }) {
    const e = n, t = T(/* @__PURE__ */ new Date());
    t.value.AddMonth(-1);
    const s = T(/* @__PURE__ */ new Date());
    return l({
      getData: () => {
        if (t.value == null && s.value == null)
          return null;
        const c = new wt();
        return c.searchID = e.searchID, c.searchType = Ke.DateTimeRange, t.value != null && (c.dateTime1 = t.value), s.value != null && (c.dateTime2 = s.value), c;
      }
    }), (c, r) => (i(), m("div", Ka, [
      de(h(_t), {
        modelValue: t.value,
        "onUpdate:modelValue": r[0] || (r[0] = (d) => t.value = d),
        locale: "ja",
        enableTimePicker: !0,
        format: "yyyy-MM-dd HH:mm",
        previewFormat: "yyyy-MM-dd HH:mm",
        yearRange: [1970, 2070],
        minDate: /* @__PURE__ */ new Date("1970-01-01"),
        maxDate: /* @__PURE__ */ new Date("2070-12-31"),
        clearable: !0,
        style: { width: "240px" },
        inputClassName: "input-text-scv datepickerInput",
        weekStart: "0"
      }, null, 8, ["modelValue", "minDate", "maxDate"]),
      r[2] || (r[2] = a("span", { class: "search-keyword-size-center-text" }, "～", -1)),
      de(h(_t), {
        modelValue: s.value,
        "onUpdate:modelValue": r[1] || (r[1] = (d) => s.value = d),
        locale: "ja",
        enableTimePicker: !0,
        format: "yyyy-MM-dd HH:mm",
        previewFormat: "yyyy-MM-dd HH:mm",
        yearRange: [1970, 2070],
        minDate: /* @__PURE__ */ new Date("1970-01-01"),
        maxDate: /* @__PURE__ */ new Date("2070-12-31"),
        clearable: !0,
        style: { width: "240px" },
        inputClassName: "input-text-scv datepickerInput",
        weekStart: "0"
      }, null, 8, ["modelValue", "minDate", "maxDate"])
    ]));
  }
}), Ja = /* @__PURE__ */ Z(Qa, [["__scopeId", "data-v-0ff13238"]]), Za = {
  class: "d-flex flex-row align-items-center flex-wrap",
  style: { "row-gap": "8px" }
}, Xa = {
  class: "select-icon",
  style: { "margin-right": "16px" }
}, ei = ["value"], ti = /* @__PURE__ */ F({
  __name: "SearchKeywordSelectGroup",
  props: {
    groupList: { type: Array, required: !0 }
    // 検索対象一覧
  },
  setup(n, { expose: l }) {
    const e = T(new zt()), t = T(), s = T(), o = T();
    return l({
      getData: () => t.value != null && t.value != null ? t.value.getData() : s.value != null && s.value != null ? s.value.getData() : o.value != null && o.value != null ? o.value.getData() : null,
      clearData: () => {
        t.value != null && t.value != null && t.value.clearData(), e.value = new zt();
      }
    }), (d, u) => (i(), m("div", Za, [
      a("div", Xa, [
        De(a("select", {
          class: "input-text-scv overflow-text",
          style: { width: "200px" },
          "onUpdate:modelValue": u[0] || (u[0] = (C) => e.value = C)
        }, [
          (i(!0), m(V, null, Q(n.groupList, (C) => (i(), m("option", {
            value: C,
            key: C.strName
          }, A(C.strName), 9, ei))), 128))
        ], 512), [
          [ht, e.value]
        ])
      ]),
      a("div", null, [
        h(Ke).Text == e.value.type ? (i(), pe(Wa, {
          key: 0,
          ref_key: "refText",
          ref: t,
          searchID: e.value.searchID
        }, null, 8, ["searchID"])) : h(Ke).Size == e.value.type ? (i(), pe(Ya, {
          key: 1,
          ref_key: "refSize",
          ref: s,
          searchID: e.value.searchID
        }, null, 8, ["searchID"])) : h(Ke).DateTimeRange == e.value.type ? (i(), pe(Ja, {
          key: 2,
          ref_key: "refDate",
          ref: o,
          searchID: e.value.searchID
        }, null, 8, ["searchID"])) : E("", !0)
      ])
    ]));
  }
}), xr = /* @__PURE__ */ Z(ti, [["__scopeId", "data-v-bfd4cdde"]]), ni = 100, kr = /* @__PURE__ */ F({
  __name: "SearchKeywordTypeSimpleText",
  props: {
    searchID: { type: Number, required: !0 }
    // 検索のID
  },
  setup(n, { expose: l }) {
    const e = n, t = T(new wt()), s = () => t.value.strOrCondition.trim().length != 0;
    return l({
      getData: () => s() ? (t.value.searchType = Ke.Text, t.value.searchID = e.searchID, t.value) : null,
      clearData: () => {
        t.value.strOrCondition = "";
      }
    }), (r, d) => (i(), pe(lt, {
      modelValue: t.value.strOrCondition,
      "onUpdate:modelValue": d[0] || (d[0] = (u) => t.value.strOrCondition = u),
      class: "input-text-scv",
      placeholder: "文字列",
      convertType: "text",
      maxlength: ni
    }, null, 8, ["modelValue"]));
  }
});
class li {
  // アイコンID
  constructor() {
    N(this, "itemID");
    // アイテムID
    N(this, "itemName");
    // アイテム名
    N(this, "itemUINamePath");
    // UI用のアイテムパス
    N(this, "parentID");
    // 親ID
    N(this, "displayOrder");
    // 表示順序
    N(this, "iconID");
    this.itemID = 0, this.itemName = "", this.itemUINamePath = "", this.parentID = 0, this.displayOrder = 0, this.iconID = 0;
  }
  equalsObject(l) {
    return !(this.itemID != l.itemID || this.itemName != l.itemName || this.itemUINamePath != l.itemUINamePath || this.displayOrder != l.displayOrder || this.parentID != l.parentID || this.iconID != l.iconID);
  }
}
const pt = class pt {
  // 新規アイテムの仮ID
  constructor() {
    N(this, "itemId");
    // アイテムID
    N(this, "itemName");
    // アイテム名
    N(this, "itemUINamePath");
    // UI用アイテムパス名
    N(this, "arChildren", new Array());
    // 子部署
    N(this, "displayOrder");
    // 表示順
    N(this, "iconID");
    // アイコンID
    // オプション変数
    N(this, "alertCount");
    // アラート端末数
    N(this, "checkState");
    // チェック状態
    N(this, "sortMode");
    this.itemId = 0, this.itemName = "", this.itemUINamePath = "", this.alertCount = 0, this.checkState = !1, this.displayOrder = 0, this.iconID = 0, this.sortMode = 0;
  }
  /// <summary>
  /// 初期化
  /// </summary>
  SetDefault() {
    this.itemId = 0, this.itemName = "", this.itemUINamePath = "", this.alertCount = 0, this.checkState = !1, this.arChildren = new Array(), this.displayOrder = 0, this.iconID = 0, this.sortMode = 0;
  }
  /// <summary>
  /// データベースの情報をデータクラスに変換します
  /// @param [in] arItemList : データベースのデータ
  /// </summary>
  Load(l, e = 0) {
    this.SetDefault(), this.sortMode = e, l.sort(function(r, d) {
      return r.parentID < d.parentID ? -1 : r.parentID > d.parentID ? 1 : Gt.CompareTreeItemData(r, d, e);
    });
    const t = /* @__PURE__ */ new Map(), s = new Array();
    t.set(0, this);
    const o = l.length;
    for (let r = 0; r < o; ++r) {
      if (l[r].itemID == 0)
        continue;
      let d = new pt();
      d.itemId = l[r].itemID, d.itemName = l[r].itemName, d.itemUINamePath = l[r].itemUINamePath, d.displayOrder = l[r].displayOrder, d.iconID = l[r].iconID, d.sortMode = this.sortMode, t.set(l[r].itemID, d);
      const u = t.get(l[r].parentID);
      if (u == null) {
        s.push(l[r]);
        continue;
      }
      u.arChildren.push(d);
    }
    const c = s.length;
    for (let r = 0; r < c; r++) {
      const d = t.get(s[r].itemID);
      if (d == null)
        continue;
      const u = t.get(s[r].parentID);
      u != null && u.arChildren.push(d);
    }
  }
  /// <summary>
  /// アイテムをツリーに追加
  /// @param [in] treeItem : アイテム
  /// </summary>
  AddItem(l) {
    const e = this.GetItemData(l.parentID);
    if (e == null)
      return;
    let t = new pt();
    t.itemId = l.itemID, t.itemName = l.itemName, t.itemUINamePath = l.itemUINamePath, t.iconID = l.iconID, e.arChildren.push(t), this.SortChildItem(e);
  }
  /// <summary>
  /// データクラスをデータベースの情報に変換します
  /// @param [out] arItemList : データベース情報
  /// </summary>
  Save(l) {
    this.SaveChildren(l);
  }
  /// <summary>
  /// データクラスをデータベースの情報に変換します（子アイテム）
  /// @param [out] arItemList : データベース情報
  /// </summary>
  SaveChildren(l) {
    for (let e = 0; e < this.arChildren.length; e++) {
      const t = new li();
      t.itemID = this.arChildren[e].itemId, t.itemName = this.arChildren[e].itemName, t.itemUINamePath = this.itemUINamePath, t.parentID = this.itemId, t.displayOrder = this.displayOrder, t.iconID = this.iconID, l.push(t), this.arChildren[e].SaveChildren(l);
    }
  }
  /**
   * 指定されたアイテムIDのアイテム情報を返します
   * @param[in] nItemID : アイテムID
   * @return undefined:見つからなかった undefined以外：アイテムID
   */
  GetItemData(l) {
    if (this.itemId == l)
      return this;
    for (let e = 0; e < this.arChildren.length; e++) {
      const t = this.arChildren[e].GetItemData(l);
      if (t != null)
        return t;
    }
  }
  /**
   * 指定されたアイテムIDの親アイテム情報を返します
   * @param[in] nItemID : アイテムID
   * @return undefined:見つからなかった undefined以外：アイテムID
   */
  GetParentItemData(l) {
    if (this.itemId != l)
      for (let e = 0; e < this.arChildren.length; e++) {
        if (this.arChildren[e].itemId == l)
          return this;
        const t = this.arChildren[e].GetParentItemData(l);
        if (t != null)
          return t;
      }
  }
  /**
   * 指定されたアイテムIDの子アイテムを削除します
   * @param[in] nItemID : アイテムID
   * @return true : 削除        false : 対象が見つからない
   */
  DeleteChildItemData(l) {
    for (let e = 0; e < this.arChildren.length; e++) {
      if (this.arChildren[e].itemId == l)
        return this.arChildren.splice(e, 1), !0;
      const t = this.arChildren[e].DeleteChildItemData(l);
      if (t == !0)
        return t;
    }
    return !1;
  }
  /**
   * アイテムID一覧を取得します
   * @param[out] arItemID : アイテムID一覧
   */
  GetAllItemID(l) {
    0 < this.itemId && l.push(this.itemId);
    for (let e = 0; e < this.arChildren.length; e++)
      this.arChildren[e].GetAllItemID(l);
  }
  /**
   * 階層を取得します
   * @param[in] nItemID : アイテムID
   * @param[out] nResult : 結果（階層）
   */
  GetHierarchy(l) {
    if (this.itemId == l)
      return 1;
    for (let e = 0; e < this.arChildren.length; e++) {
      if (this.arChildren[e].itemId == l)
        return 2;
      const t = this.arChildren[e].GetHierarchy(l);
      if (t != 0)
        return t + 1;
    }
    return 0;
  }
  /**
   * 配下アイテムが何階層あるかを取得します
   * @return : 結果（階層）※自分を含めての値
   */
  GetChildrenHierarchy() {
    let l = 0;
    for (let e = 0; e < this.arChildren.length; e++) {
      const t = this.arChildren[e].GetChildrenHierarchy();
      l < t && (l = t);
    }
    return l + 1;
  }
  /**
   * 自身のフルパスを取得
   * @param  : isIncludeRoot: ルートを含むかどうか
   * @return : フルパス
   */
  GetFullPath(l, e = !0) {
    let t = "", s = l;
    if (s == 0)
      return t;
    const o = this.GetItemData(l);
    if (o == null)
      return t;
    for (t += o.itemName; 0 < s; ) {
      const c = this.GetParentItemData(s);
      if (c == null || c.itemId == 0)
        break;
      if (!e) {
        const r = this.GetParentItemData(c.itemId);
        if (r == null || r.itemId == 0)
          break;
      }
      t = c.itemName + "/" + t, s = c.itemId;
    }
    return t;
  }
  /**
   * UI用のアイテムパスを検索してアイテムIDを検索する
   * @return : 見つかった場合はそのアイテムID情報を、見つからなかった場合は null を返します。
   */
  findItemIDFromUINamePath(l) {
    if (this.itemUINamePath === l)
      return this;
    for (let e = 0; e < this.arChildren.length; ++e) {
      const t = this.arChildren[e].findItemIDFromUINamePath(l);
      if (t !== null)
        return t;
    }
    return null;
  }
  /**
   * 子アイテムのチェック状態を変更する
   * @param[in] bCheck : チェック状態
   */
  CheckChildItem(l) {
    for (let e = 0; e < this.arChildren.length; e++)
      this.arChildren[e].checkState = l, this.arChildren[e].CheckChildItem(l);
  }
  /**
   * チェック状態を変更する
   * @param[in] itemIDs : チェックがオンのアイテムID
   */
  SetCheckAllItem(l) {
    new Set(l).has(this.itemId) ? this.checkState = !0 : this.checkState = !1;
    for (let t = 0; t < this.arChildren.length; t++)
      this.arChildren[t].SetCheckAllItem(l);
  }
  /**
   * チェック状態を取得する
   * @param[out] itemIDs : チェックがオンのアイテムID
   */
  GetCheckAllItem(l) {
    this.checkState && 0 < this.itemId && l.push(this.itemId);
    for (let e = 0; e < this.arChildren.length; e++)
      this.arChildren[e].GetCheckAllItem(l);
  }
  /**
   * 指定した親の子アイテムをソートする
   * @param parentItem    親アイテム
   */
  SortChildItem(l) {
    l.arChildren.sort(function(e, t) {
      return Gt.CompareTreeData(e, t, l.sortMode);
    });
  }
};
// ソートモード
N(pt, "NEW_ITEM_ID", -1);
let Be = pt;
class Gt {
  /**
   * 与えられた2つのアイテムを比較（※TreeItemData用）
   * @param item1    比較するアイテム
   * @param item2    比較するアイテム
   * @param mode 比較モード
   * @return -1 item1がitem2より順序が先の場合
   * @return 0  item1とitem2が同一の場合
   * @return 1  item1がitem2より順序が後の場合
   */
  static CompareTreeItemData(l, e, t) {
    switch (t) {
      case 0:
        return l.displayOrder < e.displayOrder ? -1 : l.displayOrder > e.displayOrder ? 1 : 0;
      case 1:
        return Ot.compare(l.itemName, e.itemName, !1);
      default:
        return 0;
    }
  }
  /**
   * 与えられた2つのアイテムを比較（※TreeData用）
   * @param item1    比較するアイテム
   * @param item2    比較するアイテム
   * @param mode 比較モード
   * @return -1 item1がitem2より順序が先の場合
   * @return 0  item1とitem2が同一の場合
   * @return 1  item1がitem2より順序が後の場合
   */
  static CompareTreeData(l, e, t) {
    switch (t) {
      case 0:
        return l.displayOrder < e.displayOrder ? -1 : l.displayOrder > e.displayOrder ? 1 : 0;
      case 1:
        return Ot.compare(l.itemName, e.itemName, !1);
      default:
        return 0;
    }
  }
}
const oi = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20240%20240'%3e%3cg%20id='uuid-5ef8da2c-8ddd-401a-8ec8-f310fa1e5901'%20data-name='24x24'/%3e%3cg%20id='uuid-07eeb596-5a9b-48f8-a59b-7fdf5c71bca0'%20data-name='240x240'/%3e%3cg%20id='uuid-10e8f05e-e852-4213-a293-b9c4d4f34de8'%20data-name='未使用パーツ'/%3e%3cg%20id='uuid-f80c0a3f-49aa-4473-b090-e914938743c2'%20data-name='レイヤー%205'%3e%3cpath%20d='M217.5,177.5L138.69654,41.17667c-3.6825-6.88-10.85488-11.17667-18.69654-11.17667s-15.01429,4.29167-18.71596,11.20583L22.5,177.5c-1.77262,3.28583-2.5,6.25-2.5,10,0,12.5,10,22.5,22.5,22.5H197.5c12.5,0,22.5-10,22.5-22.5,0-3.75-.73263-6.72333-2.5-10Z'%20fill='%23fabe50'/%3e%3cpath%20d='M120,40c4.14771,0,7.93347,2.25928,9.88,5.896,.05139,.0957,.10449,.19092,.15894,.28564l78.72217,136.18262c.92468,1.74512,1.23889,3.05859,1.23889,5.13574,0,7.00928-5.4906,12.5-12.5,12.5H42.5c-7.0094,0-12.5-5.49072-12.5-12.5,0-2.07812,.31433-3.3916,1.23914-5.13623L109.94165,46.21045c.05444-.09375,.1073-.18896,.15857-.28467,1.95679-3.65527,5.75012-5.92578,9.89978-5.92578m0-10c-7.84167,0-15.01428,4.2915-18.71594,11.20605L22.5,177.5c-1.77258,3.28564-2.5,6.25-2.5,10,0,12.5,10,22.5,22.5,22.5H197.5c12.5,0,22.5-10,22.5-22.5,0-3.75-.73267-6.72314-2.5-10L138.69653,41.17676c-3.6825-6.87988-10.85486-11.17676-18.69653-11.17676h0Z'%20fill='%23996231'/%3e%3ccircle%20cx='120'%20cy='177.5'%20r='12.5'%20fill='%23493712'/%3e%3cpath%20d='M128.58154,143.77917c-.37083,3.51583-4.11333,6.22083-8.57917,6.22083-4.47167,0-8.21417-2.705-8.58167-6.22083,0,0-3.92071-62.77917-3.92071-68.94583,0-7.83333,3.96667-14.83333,12.50238-14.83333,8.53333,0,12.49762,7,12.49762,14.83333,0,6.16667-3.91846,68.94583-3.91846,68.94583Z'%20fill='%23493712'/%3e%3c/g%3e%3c/svg%3e", si = {
  class: "d-flex align-items-center",
  style: { height: "32px" }
}, ai = { class: "svg-container" }, ii = ["innerHTML"], ri = {
  key: 0,
  class: "d-flex flex-row align-items-center"
}, ci = { class: "alert-count-text" }, ui = /* @__PURE__ */ F({
  __name: "TreeCtrlItemText",
  props: {
    treeItem: { type: Be, required: !0, default: new Be() },
    // [in] (必須)部署ツリー
    selectItem: { type: Be, required: !0 },
    // [in] (必須)選択中の部署
    arDisableItemID: { type: Array, default: () => [] },
    // [in] (オプション)無効状態にする部署
    getIconHtml: { type: Function, default: null }
    // [in] (オプション)アイコンのHTMLを取得
  },
  emits: ["selectItem"],
  setup(n, { emit: l }) {
    const e = n, t = () => e.arDisableItemID.find((o) => o == e.treeItem.itemId) != null ? "disableText" : 0 < e.treeItem.alertCount ? "alertText" : "";
    return (s, o) => (i(), m("div", si, [
      a("div", ai, [
        n.getIconHtml ? (i(), m("span", {
          key: 0,
          innerHTML: n.getIconHtml(e.treeItem.iconID)
        }, null, 8, ii)) : E("", !0)
      ]),
      a("div", {
        class: H(t()),
        style: { "margin-left": "4px" }
      }, [
        a("span", null, A(e.treeItem.itemName), 1)
      ], 2),
      0 < n.treeItem.alertCount ? (i(), m("div", ri, [
        o[0] || (o[0] = a("div", { style: { width: "8px" } }, null, -1)),
        o[1] || (o[1] = a("img", {
          src: oi,
          height: "20"
        }, null, -1)),
        o[2] || (o[2] = a("div", { style: { width: "4px" } }, null, -1)),
        a("span", ci, A(e.treeItem.alertCount), 1)
      ])) : E("", !0),
      Y(s.$slots, "label" + e.treeItem.itemId, {}, void 0, !0)
    ]));
  }
}), di = /* @__PURE__ */ Z(ui, [["__scopeId", "data-v-3df2b49b"]]), mi = ["onClick"], fi = {
  class: "d-flex align-items-center",
  style: { "min-width": "24px", height: "24px" }
}, pi = ["onClick", "id"], hi = {
  key: 0,
  class: "d-flex justify-content-center align-items-center",
  style: { "margin-left": "4px", "min-width": "24px", height: "24px" }
}, vi = { class: "scv-check-label-box" }, yi = ["onUpdate:modelValue", "onClick"], gi = {
  key: 0,
  class: "nested"
}, Ci = /* @__PURE__ */ F({
  __name: "TreeCtrlItem",
  props: {
    treeItem: { type: Be, required: !0, default: new Be() },
    // [in] (必須)アイテム
    selectItem: { type: Be, required: !0 },
    // [in] (必須)選択中のアイテム
    arDisableItemID: { type: Array, default: () => [] },
    // [in] (オプション)無効状態にするアイテム
    nHierarchy: { type: Number, default: 0 },
    // [in] 自階層
    selectMode: { type: Number, default: 0 },
    // [in]（オプション）選択方法 0 : 行選択（単一） 1 : チェックボックス（複数）
    /* アイコンのHTMLを取得 */
    getIconHtml: { type: Function, default: null },
    /* チェックボックス押下時（変更前） */
    selectRowCheckButtonFunc: { type: Function, default: null }
  },
  emits: ["selectItem", "expanded", "checkItem"],
  setup(n, { expose: l, emit: e }) {
    const t = n, s = e;
    let o = T(new Be()), c = T(), r = T();
    Ee(
      () => t.treeItem,
      () => {
        o.value = t.treeItem;
      },
      {
        deep: !0
      }
    ), Ee(
      () => t.selectItem,
      () => {
        let y = o.value.GetParentItemData(t.selectItem.itemId);
        y == null || y.itemId == 0 || it(() => {
          g(!0, y.itemId);
        });
      },
      {
        deep: !0
      }
    );
    const d = (y, k) => {
      var L, U, q, J, j, ne, ce, he, Ce, se, me, G;
      const x = y.currentTarget;
      x.classList.contains("icon-font-open") == !0 ? ((J = (q = (U = (L = x.parentElement) == null ? void 0 : L.parentElement) == null ? void 0 : U.parentElement) == null ? void 0 : q.querySelector(".nested")) == null || J.classList.remove("active"), x.classList.remove("icon-font-open"), x.classList.add("icon-font-close"), (j = x.firstElementChild) == null || j.classList.remove("icon-arrow1down"), (ne = x.firstElementChild) == null || ne.classList.add("icon-arrow1right")) : ((se = (Ce = (he = (ce = x.parentElement) == null ? void 0 : ce.parentElement) == null ? void 0 : he.parentElement) == null ? void 0 : Ce.querySelector(".nested")) == null || se.classList.add("active"), x.classList.remove("icon-font-close"), x.classList.add("icon-font-open"), (me = x.firstElementChild) == null || me.classList.remove("icon-arrow1right"), (G = x.firstElementChild) == null || G.classList.add("icon-arrow1down")), s("expanded");
    }, u = (y) => {
      t.arDisableItemID.find((x) => x == y.itemId) == null && t.selectMode == 0 && s("selectItem", y);
    }, C = (y, k = new Event("default"), x) => {
      if (t.selectMode != 0) {
        if (t.selectRowCheckButtonFunc != null && k.type != "default" && !t.selectRowCheckButtonFunc(y, y.checkState)) {
          k.preventDefault();
          return;
        }
        if (x) {
          k.preventDefault(), setTimeout(C, 1, y, k, !1);
          return;
        }
        y.checkState = !y.checkState, s("checkItem");
      }
    }, p = () => {
      s("checkItem");
    }, v = (y) => t.selectMode == 0 && y == t.selectItem.itemId ? "tree-selectItem" : "", S = () => {
      var y = t.nHierarchy * 28;
      return "padding-left:" + y.toString() + "px";
    }, f = () => {
      s("expanded");
    }, g = (y, k = void 0) => {
      var U, q, J, j, ne, ce, he, Ce, se, me, G, Re;
      if (r.value == null || c.value == null)
        return;
      const x = r.value;
      for (let ae of x)
        ae.expandTree(y, k);
      const L = c.value;
      for (let ae of L)
        k != null && (ae.id == 0 || ae.id != k) || (y ? ae.classList.contains("icon-font-close") == !0 && ((j = (J = (q = (U = ae.parentElement) == null ? void 0 : U.parentElement) == null ? void 0 : q.parentElement) == null ? void 0 : J.querySelector(".nested")) == null || j.classList.add("active"), ae.classList.remove("icon-font-close"), ae.classList.add("icon-font-open"), (ne = ae.firstElementChild) == null || ne.classList.remove("icon-arrow1right"), (ce = ae.firstElementChild) == null || ce.classList.add("icon-arrow1down")) : ae.classList.contains("icon-font-open") == !0 && ((me = (se = (Ce = (he = ae.parentElement) == null ? void 0 : he.parentElement) == null ? void 0 : Ce.parentElement) == null ? void 0 : se.querySelector(".nested")) == null || me.classList.remove("active"), ae.classList.remove("icon-font-open"), ae.classList.add("icon-font-close"), (G = ae.firstElementChild) == null || G.classList.remove("icon-arrow1down"), (Re = ae.firstElementChild) == null || Re.classList.add("icon-arrow1right")));
      s("expanded");
    };
    return l({
      expandTree: g
    }), (y, k) => {
      const x = jt("TreeCtrlItem", !0);
      return i(!0), m(V, null, Q(n.treeItem.arChildren, (L) => (i(), m("li", {
        key: L.itemId
      }, [
        a("div", {
          class: H([v(L.itemId), "d-flex align-items-center tree-treeText"]),
          style: ee([S(), { "margin-bottom": "4px" }]),
          onClick: nt((U) => u(L), ["stop"])
        }, [
          a("div", fi, [
            0 < L.arChildren.length ? (i(), m("div", {
              key: 0,
              class: "icon-font-close",
              ref_for: !0,
              ref_key: "ref_expand",
              ref: c,
              onClick: (U) => d(U),
              id: L.itemId.toString(),
              style: { "margin-right": "auto", "margin-left": "auto" }
            }, k[0] || (k[0] = [
              a("i", { class: "icon-arrow1right" }, null, -1)
            ]), 8, pi)) : E("", !0)
          ]),
          t.selectMode == 1 ? (i(), m("div", hi, [
            a("label", vi, [
              De(a("input", {
                type: "checkbox",
                "onUpdate:modelValue": (U) => L.checkState = U,
                onClick: (U) => C(L, U, !0)
              }, null, 8, yi), [
                [qt, L.checkState]
              ])
            ])
          ])) : E("", !0),
          de(di, {
            treeItem: L,
            selectItem: t.selectItem,
            arDisableItemID: t.arDisableItemID,
            selectMode: t.selectMode,
            getIconHtml: t.getIconHtml,
            onClick: (U) => C(L, U, !1)
          }, $t({ _: 2 }, [
            Q(y.$slots, (U, q) => ({
              name: q,
              fn: ze((J) => [
                Y(y.$slots, q, Mt({ ref_for: !0 }, J), void 0, !0)
              ])
            }))
          ]), 1032, ["treeItem", "selectItem", "arDisableItemID", "selectMode", "getIconHtml", "onClick"])
        ], 14, mi),
        0 < L.arChildren.length ? (i(), m("ul", gi, [
          de(x, {
            treeItem: L,
            selectItem: t.selectItem,
            arDisableItemID: t.arDisableItemID,
            nHierarchy: t.nHierarchy + 1,
            getIconHtml: t.getIconHtml,
            selectRowCheckButtonFunc: t.selectRowCheckButtonFunc,
            onSelectItem: u,
            onExpanded: f,
            onCheckItem: p,
            selectMode: t.selectMode,
            ref_for: !0,
            ref_key: "ref_childTreeCtrlItem",
            ref: r
          }, $t({ _: 2 }, [
            Q(y.$slots, (U, q) => ({
              name: q,
              fn: ze((J) => [
                Y(y.$slots, q, Mt({ ref_for: !0 }, J), void 0, !0)
              ])
            }))
          ]), 1032, ["treeItem", "selectItem", "arDisableItemID", "nHierarchy", "getIconHtml", "selectRowCheckButtonFunc", "selectMode"])
        ])) : E("", !0)
      ]))), 128);
    };
  }
}), bi = /* @__PURE__ */ Z(Ci, [["__scopeId", "data-v-28b3abc7"]]), _i = ["id"], Ii = ["id"], wr = /* @__PURE__ */ F({
  __name: "TreeCtrl",
  props: {
    treeItem: { type: Be, required: !0, default: new Be() },
    // [in]（必須）アイテム情報一覧
    selectItem: { type: Be, default: new Be() },
    // [in]（selecteModが0の時、必須）選択中のアイテム情報
    arDisableItemID: { type: Array, default: () => [] },
    // [in]（オプション）無効にするアイテムのアイテムID
    idPrefix: { type: String, default: "" },
    // [in] アイテムツリーIDのプレフィックス
    getIconHtml: { type: Function, default: null },
    // [in] (オプション)アイコンのHTMLを取得
    /*
     * （オプション）選択方法
     * 0 : 行選択（単一）
     * 1 : チェックボックス（複数）
     *
     * 0の場合はpropsで「selectItem」の指定が必須です。
     * 1の場合は
     */
    selectMode: { type: Number, default: 0 },
    /* チェックボックス押下時（変更前） */
    selectRowCheckButtonFunc: { type: Function, default: null }
  },
  emits: ["selectItem", "expanded", "checkItem"],
  setup(n, { expose: l, emit: e }) {
    const t = n, s = e;
    let o = null, c = T();
    gn(() => {
      r();
    });
    const r = () => {
      const f = document.getElementById(t.idPrefix + "-Area"), g = document.getElementById(t.idPrefix + "-Tree");
      if (f == null || g == null)
        return;
      const y = f.clientHeight - f.offsetHeight;
      5 >= y && 0 <= y || -5 <= y && y <= 0 ? g.style.width = "100%" : g.style.width = "max-content";
    }, d = () => {
      r();
    }, u = () => {
      s("checkItem");
    }, C = (f) => {
      t.selectItem.itemId != f.itemId && s("selectItem", f);
    };
    return l({
      show: () => {
        o == null && (o = wn(r, 100), window.addEventListener("resize", o)), r();
      },
      hide: () => {
        o != null && (window.removeEventListener("resize", o), o = null);
      },
      expandTree: (f, g = void 0) => {
        c.value != null && c.value.expandTree(f, g);
      }
    }), (f, g) => (i(), m("div", {
      id: t.idPrefix + "-Area",
      class: "tree-area d-flex flex-column flex-grow-1 overflow-auto"
    }, [
      a("div", {
        id: t.idPrefix + "-Tree",
        style: { "list-style-type": "none", padding: "8px" }
      }, [
        de(bi, {
          treeItem: t.treeItem,
          selectItem: t.selectItem,
          arDisableItemID: t.arDisableItemID,
          nHierarchy: 0,
          selectMode: t.selectMode,
          selectRowCheckButtonFunc: n.selectRowCheckButtonFunc,
          getIconHtml: t.getIconHtml,
          onSelectItem: C,
          onExpanded: d,
          onCheckItem: u,
          ref_key: "ref_treeCtrlItem",
          ref: c
        }, $t({ _: 2 }, [
          Q(f.$slots, (y, k) => ({
            name: k,
            fn: ze((x) => [
              Y(f.$slots, k, Cn(bn(x)))
            ])
          }))
        ]), 1032, ["treeItem", "selectItem", "arDisableItemID", "selectMode", "selectRowCheckButtonFunc", "getIconHtml"])
      ], 8, Ii)
    ], 8, _i));
  }
});
var vt = /* @__PURE__ */ ((n) => (n[n.Default = 0] = "Default", n[n.Radio = 1] = "Radio", n))(vt || {});
const xi = {
  key: 0,
  class: "tab radio"
}, ki = ["id", "name", "checked"], wi = ["for"], Ti = /* @__PURE__ */ F({
  __name: "Tab",
  props: {
    id: {},
    active: { type: Boolean, default: !1 },
    tabStyle: { default: vt.Default },
    group: {}
  },
  emits: ["click"],
  setup(n, { emit: l }) {
    const e = n, t = l, s = T(rt.NewID());
    function o() {
      t("click", e.id);
    }
    return (c, r) => h(vt).Radio === e.tabStyle ? (i(), m("div", xi, [
      a("input", {
        id: h(s),
        name: e.group,
        type: "radio",
        checked: e.active,
        onClick: o
      }, null, 8, ki),
      a("label", { for: h(s) }, [
        Y(c.$slots, "default", {}, void 0, !0)
      ], 8, wi)
    ])) : (i(), m("div", {
      key: 1,
      class: H(["tab default", { active: e.active }]),
      onClick: o
    }, [
      Y(c.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), Tr = /* @__PURE__ */ Z(Ti, [["__scopeId", "data-v-7c1afb07"]]), Si = /* @__PURE__ */ F({
  __name: "Tabs",
  props: {
    tabs: {},
    activeTab: {},
    tabStyle: { default: vt.Default }
  },
  emits: ["click"],
  setup(n, { emit: l }) {
    const e = n, t = l, s = T(rt.NewID()), o = kt(), c = $(() => {
      if (o.default) {
        let d = o.default();
        return d[0].type === Symbol.for("v-fgt") && (d = d[0].children), d;
      } else
        return e.tabs ?? [];
    });
    function r(d) {
      t("click", d);
    }
    return (d, u) => (i(), m("div", {
      class: H(["tabs", { radio: h(vt).Radio === e.tabStyle }])
    }, [
      (i(!0), m(V, null, Q(h(c), (C, p) => (i(), pe(Et(C), {
        key: p,
        active: C.props.id === e.activeTab,
        tabStyle: e.tabStyle,
        group: h(s),
        onClick: r
      }, null, 8, ["active", "tabStyle", "group"]))), 128))
    ], 2));
  }
}), Sr = /* @__PURE__ */ Z(Si, [["__scopeId", "data-v-318c50f4"]]), Ni = { class: "labeled-text-label" }, Di = { class: "labeled-text-text" }, Mi = /* @__PURE__ */ F({
  __name: "LabeledText",
  props: {
    name: {},
    direction: { default: "row" },
    height: {},
    width: {},
    labelWidth: {},
    gap: { default: 8 },
    underline: { type: Boolean, default: !1 },
    labelAlign: { default: "left" }
  },
  setup(n) {
    Lt((C) => ({
      "6232f3cb": h(t),
      "7878bb7a": h(o),
      "649196db": h(c),
      "1f62e762": h(r),
      "10be1270": h(u),
      "32f4bbe8": h(d),
      69948995: h(s)
    }));
    const l = n, e = $(() => l.direction === "row"), t = $(() => `${l.gap}px`), s = $(() => l.underline ? "1px solid #cccccc" : void 0), o = $(() => l.height ? `${l.height}px` : void 0), c = $(() => l.width ? `${l.width}px` : void 0), r = $(() => l.labelWidth ? `${l.labelWidth}px` : void 0), d = $(() => l.width ? l.labelWidth ? `${l.width - l.labelWidth - l.gap - 8}px` : "100%" : l.labelWidth ? `${l.labelWidth}px` : void 0), u = $(() => l.labelAlign);
    return (C, p) => (i(), m("div", {
      class: H(["labeled-text-main", { "labeled-text-horizontal": h(e), "labeled-text-vertical": !h(e) }, "default-text-font"])
    }, [
      a("div", Ni, A(l.name) + "：", 1),
      a("div", Di, [
        Y(C.$slots, "default", {}, void 0, !0)
      ])
    ], 2));
  }
}), Nr = /* @__PURE__ */ Z(Mi, [["__scopeId", "data-v-db83d95a"]]), $i = { class: "stepperProgress" }, Ei = /* @__PURE__ */ F({
  __name: "StepperProgress",
  props: {
    items: {},
    step: {}
  },
  setup(n) {
    const l = n;
    return (e, t) => (i(), m("div", $i, [
      (i(!0), m(V, null, Q(l.items, (s, o) => (i(), m("div", {
        key: o,
        class: H({ active: o === l.step })
      }, A(s), 3))), 128))
    ]));
  }
}), Bi = /* @__PURE__ */ Z(Ei, [["__scopeId", "data-v-f3942a6a"]]), Li = { class: "stepper" }, Ri = { class: "stepperContent" }, Ai = { class: "stepperActions" }, Oi = { class: "stepperActionsLeft" }, Vi = { class: "stepperActionsRight" }, Hi = ["disabled"], Ui = ["disabled"], Wi = /* @__PURE__ */ F({
  __name: "Stepper",
  props: {
    items: {},
    step: {},
    transition: { type: Function, default: () => !0 },
    reverseTransition: { type: Function, default: () => !0 },
    nextDisabled: { type: Boolean, default: !1 }
  },
  emits: ["update:step", "cancel", "apply"],
  setup(n, { emit: l }) {
    const e = n, t = l, s = $({
      get: () => e.step,
      set: (f) => t("update:step", f)
    }), o = $(() => e.items.length), c = kt(), r = $(() => {
      const f = c[`item.${s.value + 1}`];
      if (f) {
        const g = u(f([]), "backButtonLabel");
        if (g && g.props)
          return g.props.backButtonLabel ?? "一つ前に戻る";
      }
      return "一つ前に戻る";
    }), d = $(() => {
      const f = c[`item.${s.value + 1}`];
      if (f) {
        const g = u(f([]), "nextButtonLabel");
        if (g && g.props)
          return g.props.nextButtonLabel ?? "次へ";
      }
      return "次へ";
    });
    function u(f, g) {
      if (!f.find)
        return;
      let y = [];
      return f.forEach((k) => {
        if (k.props && k.props[g] !== void 0 && y.push(k), k.children) {
          const x = typeof k.children == "function" ? k.children() : k.children, L = u(x, g);
          L && y.push(L);
        }
      }), 0 < y.length ? y[0] : void 0;
    }
    function C() {
      e.transition(s.value) && (s.value += 1);
    }
    function p() {
      e.reverseTransition(s.value) && (s.value -= 1);
    }
    function v() {
      t("cancel", s.value);
    }
    function S() {
      t("apply");
    }
    return (f, g) => (i(), m("div", Li, [
      Y(f.$slots, "header", {}, () => [
        de(Bi, {
          items: e.items,
          step: h(s)
        }, null, 8, ["items", "step"])
      ], !0),
      a("div", Ri, [
        (i(!0), m(V, null, Q(e.items.length, (y) => (i(), m(V, { key: y }, [
          y - 1 === h(s) ? Y(f.$slots, `item.${y}`, { key: 0 }, void 0, !0) : E("", !0)
        ], 64))), 128))
      ]),
      Y(f.$slots, "actions", {}, () => [
        a("div", Ai, [
          a("div", Oi, [
            0 < h(s) ? (i(), m("button", {
              key: 0,
              class: "btn-scv-white",
              onClick: p
            }, [
              Y(f.$slots, "back", {}, () => [
                fe(A(h(r)), 1)
              ], !0)
            ])) : E("", !0)
          ]),
          a("div", Vi, [
            h(s) < h(o) - 1 ? (i(), m("button", {
              key: 0,
              class: "btn-scv-blue",
              onClick: C,
              disabled: e.nextDisabled
            }, [
              Y(f.$slots, "next", {}, () => [
                fe(A(h(d)), 1)
              ], !0)
            ], 8, Hi)) : E("", !0),
            h(s) === h(o) - 1 ? (i(), m("button", {
              key: 1,
              class: "btn-scv-blue",
              onClick: S,
              disabled: e.nextDisabled
            }, [
              Y(f.$slots, "apply", {}, () => [
                g[0] || (g[0] = fe(A("適用")))
              ], !0)
            ], 8, Ui)) : E("", !0),
            a("button", {
              class: "btn-scv-white",
              onClick: v
            }, [
              Y(f.$slots, "cancel", {}, () => [
                g[1] || (g[1] = fe(A("キャンセル")))
              ], !0)
            ])
          ])
        ])
      ], !0)
    ]));
  }
}), Dr = /* @__PURE__ */ Z(Wi, [["__scopeId", "data-v-2b2908c1"]]), Mr = /* @__PURE__ */ F({
  __name: "StepperItem",
  props: {
    backButtonLabel: {},
    nextButtonLabel: {}
  },
  setup(n) {
    return (l, e) => Y(l.$slots, "default");
  }
});
var He = /* @__PURE__ */ ((n) => (n[n.Date = 0] = "Date", n[n.Time = 1] = "Time", n[n.DateTime = 2] = "DateTime", n[n.DateAndTime = 3] = "DateAndTime", n))(He || {});
const Pi = { class: "dateTimePicker" }, Fi = ["disabled"], zi = /* @__PURE__ */ F({
  __name: "DateTimePicker",
  props: {
    modelValue: {},
    pickerStyle: { default: He.DateAndTime },
    modern: { type: Boolean, default: !0 },
    markHoliday: { type: Boolean, default: !1 },
    inputStyleClass: {},
    directInput: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    disabledPastDate: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: l }) {
    const e = n, t = l, s = $({
      get: () => e.modelValue,
      set: (k) => {
        if (He.DateTime === e.pickerStyle)
          t("update:modelValue", k);
        else {
          const x = new Date(e.modelValue);
          x.setFullYear(k.getFullYear()), x.setMonth(k.getMonth()), x.setDate(k.getDate()), t("update:modelValue", x);
        }
      }
    }), o = $({
      get: () => ({
        hours: e.modelValue.getHours(),
        minutes: e.modelValue.getMinutes(),
        seconds: e.modelValue.getSeconds()
      }),
      set: (k) => {
        const x = new Date(e.modelValue);
        x.setHours(k.hours), x.setMinutes(k.minutes), x.setSeconds(k.seconds), t("update:modelValue", x);
      }
    }), c = $({
      get: () => {
        const k = e.modelValue.getHours().toString().padStart(2, "0"), x = e.modelValue.getMinutes().toString().padStart(2, "0");
        return `${k}:${x}`;
      },
      set: (k) => {
        const [x, L] = k.split(":"), U = new Date(e.modelValue);
        U.setHours(Number.parseInt(x)), U.setMinutes(Number.parseInt(L)), U.setSeconds(0), t("update:modelValue", U);
      }
    }), r = $(() => {
      switch (e.pickerStyle) {
        case He.Date:
        case He.DateTime:
        case He.DateAndTime:
          return !0;
        default:
          return !1;
      }
    }), d = $(() => {
      switch (e.pickerStyle) {
        case He.Time:
        case He.DateAndTime:
          return !0;
        default:
          return !1;
      }
    }), u = $(() => {
      let k = "yyyy/MM/dd";
      return He.DateTime === e.pickerStyle && (k = "yyyy/MM/dd HH:mm"), {
        input: k,
        preview: k
      };
    }), C = $(() => ({
      input: "HH:mm",
      preview: "HH:mm"
    })), p = $(() => {
      switch (e.pickerStyle) {
        case He.DateTime:
          return "dateTimePicker";
        default:
          return "datePicker";
      }
    }), v = $(() => e.inputStyleClass ? {
      input: e.inputStyleClass
    } : {}), S = $(() => e.disabledPastDate ? [Tn().get("years"), 2070] : [1970, 2070]), f = $(() => e.disabledPastDate ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date("1970-01-01"));
    function g(k) {
      if (e.markHoliday)
        switch (k.getDay()) {
          case 6:
            return "saturday";
          case 0:
            return "sunday";
          default:
            return "weekday";
        }
      else
        return "";
    }
    function y(k) {
      const x = k.key.toLowerCase();
      (x === "backspace" || x === "delete") && k.preventDefault();
    }
    return (k, x) => (i(), m("div", Pi, [
      h(r) ? (i(), pe(h(_t), {
        key: 0,
        modelValue: h(s),
        "onUpdate:modelValue": x[0] || (x[0] = (L) => tt(s) ? s.value = L : null),
        locale: "ja",
        enableTimePicker: h(He).DateTime === e.pickerStyle,
        format: h(u).input,
        previewFormat: h(u).preview,
        yearRange: h(S),
        minDate: h(f),
        maxDate: /* @__PURE__ */ new Date("2070-12-31"),
        clearable: !1,
        textInput: e.directInput,
        autoApply: !0,
        weekStart: 0,
        dayClass: g,
        class: H(h(p)),
        ui: h(v),
        disabled: e.disabled
      }, null, 8, ["modelValue", "enableTimePicker", "format", "previewFormat", "yearRange", "minDate", "maxDate", "textInput", "class", "ui", "disabled"])) : E("", !0),
      h(d) ? (i(), m(V, { key: 1 }, [
        e.modern ? (i(), pe(h(_t), {
          key: 0,
          timePicker: "",
          modelValue: h(o),
          "onUpdate:modelValue": x[1] || (x[1] = (L) => tt(o) ? o.value = L : null),
          locale: "ja",
          format: h(C).input,
          previewFormat: h(C).preview,
          clearable: !1,
          textInput: e.directInput,
          autoApply: !0,
          class: "timePicker",
          inputClassName: e.inputStyleClass,
          ui: h(v),
          disabled: e.disabled
        }, {
          "input-icon": ze(() => x[3] || (x[3] = [
            a("i", { class: "icon-time" }, null, -1)
          ])),
          _: 1
        }, 8, ["modelValue", "format", "previewFormat", "textInput", "inputClassName", "ui", "disabled"])) : De((i(), m("input", {
          key: 1,
          type: "time",
          inputmode: "text",
          "onUpdate:modelValue": x[2] || (x[2] = (L) => tt(c) ? c.value = L : null),
          class: H(["dp__theme_light timePickerClassic", e.inputStyleClass]),
          disabled: e.disabled,
          onKeydown: y
        }, null, 42, Fi)), [
          [Bt, h(c)]
        ])
      ], 64)) : E("", !0)
    ]));
  }
}), $r = /* @__PURE__ */ Z(zi, [["__scopeId", "data-v-86c4025f"]]), Gi = { class: "dayOfWeeks" }, qi = ["onClick", "disabled", "checked"], ji = /* @__PURE__ */ F({
  __name: "DayOfWeeks",
  props: {
    modelValue: {},
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: l }) {
    const e = n, t = l, s = ["月", "火", "水", "木", "金", "土", "日"], o = $({
      get: () => e.modelValue,
      set: (u) => t("update:modelValue", u)
    }), c = $(() => (u) => s[u]);
    function r(u) {
      return (o.value & 1 << u) !== 0;
    }
    function d(u, C) {
      const p = C.target, v = o.value;
      p.checked ? o.value = v | 1 << u : o.value = v & ~(1 << u);
    }
    return (u, C) => (i(), m("div", Gi, [
      (i(), m(V, null, Q(7, (p, v) => a("div", {
        key: v,
        class: "dayOfWeek"
      }, [
        a("input", {
          type: "checkbox",
          onClick: (S) => d(v, S),
          disabled: e.disabled,
          checked: r(v)
        }, null, 8, qi),
        a("span", null, A(h(c)(v)), 1)
      ])), 64))
    ]));
  }
}), Er = /* @__PURE__ */ Z(ji, [["__scopeId", "data-v-b3f8bac9"]]), Yi = ["innerHTML"], Ki = ["innerHTML"], Qi = /* @__PURE__ */ F({
  __name: "Annotator",
  props: {
    annotation: {},
    error: {},
    position: { default: "bottom" },
    for: {}
  },
  setup(n) {
    const l = n, e = T(null), t = $(() => {
      var p, v;
      return 0 < (((p = l.annotation) == null ? void 0 : p.length) ?? 0) || 0 < (((v = l.error) == null ? void 0 : v.length) ?? 0);
    }), s = $(() => {
      var p;
      return 0 < (((p = l.annotation) == null ? void 0 : p.length) ?? 0);
    }), o = $(() => {
      var p;
      return 0 < (((p = l.error) == null ? void 0 : p.length) ?? 0);
    }), c = $(() => ft(l.annotation ?? "")), r = $(() => ft(l.error ?? "")), d = T({}), { watchElementVisibility: u } = Jt();
    Le(() => {
      l.position !== "top" && l.position !== "bottom" || l.for && e.value && u(e.value, {
        onVisibled(p) {
          const v = document.getElementById(l.for);
          d.value = {
            paddingLeft: `${v ? C(v) : 0}px`
          };
        },
        options: {
          immediate: !0
        }
      });
    });
    function C(p) {
      const v = p.parentElement, S = p.getBoundingClientRect(), f = v == null ? void 0 : v.getBoundingClientRect();
      return S.left - ((f == null ? void 0 : f.left) ?? 0);
    }
    return (p, v) => (i(), m("div", {
      ref_key: "thisComponentRoot",
      ref: e,
      class: H(["annotator", [
        { "decorator-pos-top": l.position === "top" },
        { "decorator-pos-right": l.position === "right" },
        { "decorator-pos-bottom": l.position === "bottom" }
      ]])
    }, [
      Y(p.$slots, "default", {}, void 0, !0),
      h(t) ? (i(), m("div", {
        key: 0,
        class: "decoration-area",
        style: ee(h(d))
      }, [
        h(s) ? (i(!0), m(V, { key: 0 }, Q(h(c), (S, f) => (i(), m("span", {
          key: f,
          innerHTML: S,
          class: "input-text-annotation"
        }, null, 8, Yi))), 128)) : E("", !0),
        h(o) ? (i(!0), m(V, { key: 1 }, Q(h(r), (S, f) => (i(), m("span", {
          key: f,
          innerHTML: S,
          class: "input-text-validation-error-message"
        }, null, 8, Ki))), 128)) : E("", !0)
      ], 4)) : E("", !0)
    ], 2));
  }
}), Br = /* @__PURE__ */ Z(Qi, [["__scopeId", "data-v-d6f2d1b8"]]);
export {
  Er as $,
  kr as A,
  Wa as B,
  Se as C,
  cr as D,
  zt as E,
  Ke as F,
  gr as G,
  wt as H,
  wr as I,
  Be as J,
  li as K,
  vo as L,
  Wt as M,
  Tr as N,
  Sr as O,
  hr as P,
  vt as Q,
  Ir as R,
  rr as S,
  ll as T,
  Nr as U,
  mr as V,
  Dr as W,
  Mr as X,
  Bi as Y,
  $r as Z,
  Ht as _,
  br as a,
  He as a0,
  Br as a1,
  K as b,
  Te as c,
  Jt as d,
  Ut as e,
  il as f,
  ur as g,
  lt as h,
  dr as i,
  fr as j,
  bt as k,
  mt as l,
  ct as m,
  vr as n,
  xt as o,
  pr as p,
  X as q,
  yr as r,
  Ft as s,
  Cr as t,
  Zt as u,
  Ks as v,
  _r as w,
  To as x,
  bo as y,
  xr as z
};
